webpackJsonp([34],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://api-lepisma.prod.uks.ufes.br/";

var getTiposDocumentoAutorizados = function getTiposDocumentoAutorizados() {
  var DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos';
  var config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getTiposDocumentoGlossario = function getTiposDocumentoGlossario() {
  var DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos';
  var config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true,
    params: {
      paraInclusaoEmVocabularioControlado: true
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getTodosTiposDocumento = function getTodosTiposDocumento() {
  var DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos?todosTipos=true';
  var config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaDocumentos = function getListaDocumentos(parameters) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos',
    params: {
      numeroDocumento: parameters.numeroDocumento,
      resumoAssunto: parameters.resumoAssunto,
      idTipoDocumento: parameters.idTipoDocumento,
      idAssunto: parameters.idAssunto,
      dataCriacaoInicio: parameters.dataCriacaoInicio !== undefined ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(parameters.dataCriacaoInicio).format('YYYY-MM-DD') : parameters.dataCriacaoInicio,
      dataCriacaoFim: parameters.dataCriacaoFim !== undefined ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(parameters.dataCriacaoFim).format('YYYY-MM-DD') : parameters.dataCriacaoFim,
      dataEnvioInicio: parameters.dataEnvioInicio !== undefined ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(parameters.dataEnvioInicio).format('YYYY-MM-DD') : parameters.dataEnvioInicio,
      dataEnvioFim: parameters.dataEnvioFim !== undefined ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(parameters.dataEnvioFim).format('YYYY-MM-DD') : parameters.dataEnvioFim,
      tipoInteressado: parameters.tipoInteressado,
      idInteressado: parameters.interessado,
      idProcedencia: parameters.idProcedencia,
      tipoResponsavelTramitacao: parameters.tipoResponsavelTramitacao,
      idResponsavelTramitacao: parameters.responsavelTramitacao,
      idServidorLotadoProcedencia: parameters.servidoresProcedencia
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaDocumentosCaixaPostal = function getListaDocumentosCaixaPostal(parameters) {
  var config = {
    method: 'get',
    url: API_URL + 'caixa-postal',
    params: {
      numeroDocumento: parameters.numeroDocumento && parameters.numeroDocumento.length > 0 ? parameters.numeroDocumento : undefined,
      idTipoDocumento: parameters.idTipoDocumento,
      idUnidadeAtual: parameters.idUnidadeAtual,
      dataInicio: __WEBPACK_IMPORTED_MODULE_2_moment___default()(parameters.dataEnvioInicio).format('YYYY-MM-DD'),
      dataFim: __WEBPACK_IMPORTED_MODULE_2_moment___default()(parameters.dataEnvioFim).format('YYYY-MM-DD')
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaDocumentosParaJuntada = function getListaDocumentosParaJuntada(numeroDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'caixa-postal',
    params: {
      numeroDocumento: numeroDocumento
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaDocumentosParaDesmembramento = function getListaDocumentosParaDesmembramento(numeroDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'caixa-postal',
    params: {
      numeroDocumento: numeroDocumento
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getDocument = function getDocument(idDocumento) {
  var DOCUMENT_URL = API_URL + 'documentos/' + idDocumento;
  var config = {
    method: 'get',
    url: DOCUMENT_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var receberDocumento = function receberDocumento(idDocumento) {
  var config = {
    method: 'post',
    url: API_URL + ('documentos/' + idDocumento + '/receber'),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var receberDocumentoReencaminhamento = function receberDocumentoReencaminhamento(idDocumento) {
  var config = {
    method: 'post',
    url: API_URL + ('reencaminhamento/documento/' + idDocumento + '/receber'),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var realizarReencaminhamento = function realizarReencaminhamento(idDocumento, idPasso, idDestino, despacho) {
  var config = {
    method: 'post',
    url: API_URL + ('reencaminhamento/documento/' + idDocumento + '/tramitacoes'),
    responseType: 'json',
    credentials: true,
    body: {
      idPasso: idPasso,
      idDestino: idDestino,
      despacho: despacho
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getInteressadoPorId = function getInteressadoPorId(idTipoInteressado, idInteressado) {
  var INTERESTED_ENTITIES_URL = API_URL + 'interessados/' + idTipoInteressado;
  var config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: {
      idInteressado: idInteressado
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getResponsavelTramitacaoPorId = function getResponsavelTramitacaoPorId(idTipoResponsavelTramitacao, idResponsavelTramitacao) {
  var INTERESTED_ENTITIES_URL = API_URL + 'responsaveis-tramitacao/' + idTipoResponsavelTramitacao;
  var config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: {
      idResponsavelTramitacao: idResponsavelTramitacao
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaUnidadesReencaminhamento = function getListaUnidadesReencaminhamento() {
  var config = {
    method: 'get',
    url: API_URL + 'reencaminhamento/unidades',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaDocumentosReencaminhamento = function getListaDocumentosReencaminhamento(idUnidade, numeroDocumento) {
  var config = {
    method: 'get',
    url: API_URL + ('reencaminhamento/unidades/' + idUnidade + '/caixa-postal'),
    params: {
      numeroDocumento: numeroDocumento && numeroDocumento.length > 0 ? numeroDocumento : undefined
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaUnidadesProcedenciaCaixaPostal = function getListaUnidadesProcedenciaCaixaPostal() {
  var URL_UNIDADES_PROCEDENCIA = API_URL + 'procedencias/caixa-postal/UNIDADE';
  var config = {
    method: 'get',
    url: URL_UNIDADES_PROCEDENCIA,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaUnidadesProcedenciaRelatorios = function getListaUnidadesProcedenciaRelatorios(relatorio) {
  var config = {
    method: 'get',
    url: API_URL + ('relatorios/' + relatorio + '/unidades'),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getUnidadeProcedenciaPorId = function getUnidadeProcedenciaPorId(idProcedencia) {
  var URL_UNIDADES_PROCEDENCIA = API_URL + 'procedencias/UNIDADE';
  var config = {
    method: 'get',
    url: URL_UNIDADES_PROCEDENCIA,
    params: {
      idProcedencia: idProcedencia
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getProcessingsList = function getProcessingsList(idDocumento) {
  var PROCESSINGS_LIST_URL = API_URL + 'documentos/' + idDocumento + '/tramitacoes';
  var config = {
    method: 'get',
    url: PROCESSINGS_LIST_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaArquivos = function getListaArquivos(idDocumento) {
  var LISTA_ARQUIVOS_URL = API_URL + 'documentos/' + idDocumento + '/anexos';
  var config = {
    method: 'get',
    url: LISTA_ARQUIVOS_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaPecas = function getListaPecas(idDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/pecas',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaVinculosDocumento = function getListaVinculosDocumento(idDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/agregados',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPassosFluxoPossiveisList = function getPassosFluxoPossiveisList(idDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/fluxos',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPassosFluxoPossiveisReencaminhamentoList = function getPassosFluxoPossiveisReencaminhamentoList(idDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'reencaminhamento/documento/' + idDocumento + '/fluxos',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getDestinosPassoFluxoList = function getDestinosPassoFluxoList(idDocumento, fluxoId) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/fluxos/' + fluxoId + '/destinos',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getValidacaoFluxo = function getValidacaoFluxo(idDocumento, fluxoId) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/fluxos/' + fluxoId + '/consistencia',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getUltimaTramitacao = function getUltimaTramitacao(idDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + idDocumento + '/ultima-tramitacao',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getMotivosRestricoesArquivo = function getMotivosRestricoesArquivo() {
  var config = {
    method: 'get',
    url: API_URL + 'propriedades/hipoteses-legais',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getEmailInteressado = function getEmailInteressado(idTipoInteressado, idInteressado) {
  var config = {
    method: 'get',
    url: API_URL + ('interessados/' + idTipoInteressado + '/' + idInteressado + '/email'),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getDespachoSalvo = function getDespachoSalvo(idDocumento) {
  var config = {
    method: 'get',
    url: API_URL + ('documentos/' + idDocumento + '/tramitacoes/despacho'),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var salvarDespacho = function salvarDespacho(idDocumento, despacho) {
  var config = {
    method: 'patch',
    url: API_URL + ('documentos/' + idDocumento + '/tramitacoes'),
    responseType: 'json',
    credentials: true,
    body: {
      despacho: despacho
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var salvarDespachoPreparatorio = function salvarDespachoPreparatorio(idDocumento, despachoPreparatorio) {
  var config = {
    method: 'patch',
    url: API_URL + ('documentos/' + idDocumento + '/tramitacoes'),
    responseType: 'json',
    credentials: true,
    body: {
      despachoPreparatorio: despachoPreparatorio
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var enviarTramitacao = function enviarTramitacao(idDocumento, fluxo, destino, despacho, tipoDespacho, nivelAcesso, hipoteseLegal, despachoPreparatorio) {
  var config = {
    method: 'post',
    url: API_URL + 'documentos/' + idDocumento + '/tramitacoes',
    responseType: 'json',
    credentials: true,
    body: {
      idPasso: fluxo,
      idDestino: destino,
      despacho: despacho,
      tipoDespacho: tipoDespacho,
      nivelAcesso: nivelAcesso,
      idHipoteseLegal: hipoteseLegal,
      despachoPreparatorio: despachoPreparatorio
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var juntarDocumentos = function juntarDocumentos(tipoJuntada, documento, juntador) {
  var config = {
    method: 'post',
    url: API_URL + 'documentos/' + juntador.idDocumento + '/agregados',
    responseType: 'json',
    credentials: true,
    body: {
      idDocumento: String(documento.idDocumento),
      tipoAgregacao: tipoJuntada.nome
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getArquivo = function getArquivo(idDocumento, idArquivo) {
  var config = {
    method: 'get',
    url: API_URL + ('documentos/' + idDocumento + '/anexos/' + idArquivo),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getArquivoBinario = function getArquivoBinario(idDocumento, idArquivo) {
  var config = {
    method: 'get',
    url: API_URL + ('documentos/' + idDocumento + '/anexos/' + idArquivo + '/binario'),
    responseType: 'arraybuffer',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var excluirArquivo = function excluirArquivo(idDocumento, idArquivo) {
  var config = {
    method: 'delete',
    url: API_URL + 'documentos/' + idDocumento + '/anexos/' + idArquivo,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var cancelarPeca = function cancelarPeca(idDocumento, idPeca, situacaoVinculo, justificativaCancelamento, idDocumentoPecaDesmembramento) {
  var config = {
    method: 'patch',
    url: API_URL + ('documentos/' + idDocumento + '/pecas/' + idPeca + '/cancelar'),
    responseType: 'json',
    credentials: true,
    body: {
      situacaoVinculo: situacaoVinculo,
      justificativaCancelamento: justificativaCancelamento,
      idDocumentoPecaDesmembramento: idDocumentoPecaDesmembramento
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var enviarArquivo = function enviarArquivo(idDocumento, body) {
  var config = {
    method: 'post',
    url: API_URL + 'documentos/' + idDocumento + '/anexos',
    responseType: 'json',
    emulateJSON: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    credentials: true,
    body: body
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var salvarAlteracoesArquivo = function salvarAlteracoesArquivo(idDocumento, idAcessoAnexo, idAnexo, arquivo) {
  var config = {
    method: 'patch',
    url: API_URL + ('documentos/' + idDocumento + '/pecas/' + idAcessoAnexo),
    responseType: 'json',
    credentials: true,
    body: {
      idAnexo: idAnexo,
      descricao: arquivo.descricao,
      tipoCopia: arquivo.tipoCopia,
      nivelAcesso: arquivo.nivelAcesso,
      idHipoteseLegal: arquivo.idHipoteseLegal,
      justificativaAlteracao: arquivo.justificativaAlteracao
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var solicitaConsolidacao = function solicitaConsolidacao(parameters) {
  var config = {
    method: 'post',
    url: API_URL + ('consolidacao/' + parameters.idDocumento + '/' + parameters.tipo),
    responseType: 'json',
    credentials: true,
    body: parameters.idsPecas
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPDFCapa = function getPDFCapa(parameters) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + parameters.idDocumento + '/capa',
    responseType: 'arraybuffer',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPDFComprovanteProtocolizacao = function getPDFComprovanteProtocolizacao(parameters) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + parameters.idDocumento + '/comprovante',
    responseType: 'arraybuffer',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var enviarComprovanteProtocolizacaoPorEmail = function enviarComprovanteProtocolizacaoPorEmail(parameters) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos/' + parameters.idDocumento + '/comprovante/email',
    params: {
      destinatario: parameters.destinatario
    },
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var desapensarDocumentos = function desapensarDocumentos(idDocumentoPai, idDocumentoFilho) {
  var config = {
    method: 'delete',
    url: API_URL + ('documentos/' + idDocumentoPai + '/agregados/' + idDocumentoFilho),
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaUnidadesProcedenciaConsulta = function getListaUnidadesProcedenciaConsulta() {
  var UNIDADES_AUTUACAO_URL = API_URL + 'procedencias/UNIDADE?somenteAtivas=false';
  var config = {
    method: 'get',
    url: UNIDADES_AUTUACAO_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaServidoresProcedencia = function getListaServidoresProcedencia() {
  var SERVIDORES_PROCEDENCIA_URL = API_URL + 'procedencias/usuarios-lotados';
  var config = {
    method: 'get',
    url: SERVIDORES_PROCEDENCIA_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var salvarTags = function salvarTags(idDocumento, tags) {
  var config = {
    method: 'post',
    url: API_URL + 'documentos/' + idDocumento + '/tags',
    responseType: 'json',
    credentials: true,
    body: {
      stringTags: tags
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var favoritarDocumento = function favoritarDocumento(idDocumento) {
  var config = {
    method: 'post',
    url: API_URL + ('documentos-favoritos/' + idDocumento),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var desfavoritarDocumento = function desfavoritarDocumento(idDocumento) {
  var config = {
    method: 'delete',
    url: API_URL + ('documentos-favoritos/' + idDocumento),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscarDocumentosFavoritos = function buscarDocumentosFavoritos(payload) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos-favoritos',
    responseType: 'json',
    credentials: true,
    params: {
      dataInicioUltimaAlteracao: payload.dataInicioUltimaAlteracao,
      dataFimUltimaAlteracao: payload.dataFimUltimaAlteracao,
      resumoDocumento: payload.resumoDocumento,
      idTipoDocumento: payload.idTipoDocumento
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var alternarAcompanhamentoDeDocumentoFavorito = function alternarAcompanhamentoDeDocumentoFavorito(idDocumento, acompanharPorEmail) {
  var config = {
    method: 'patch',
    url: API_URL + ('documentos-favoritos/' + idDocumento),
    responseType: 'json',
    credentials: true,
    body: {
      acompanhadoPorEmail: acompanharPorEmail
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var alterarMarcadoresDeDocumentosFavoritos = function alterarMarcadoresDeDocumentosFavoritos(idDocumento, tags) {
  var config = {
    method: 'patch',
    url: API_URL + ('documentos-favoritos/' + idDocumento + '/tags'),
    responseType: 'json',
    credentials: true,
    body: tags
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscarArquivosAssinados = function buscarArquivosAssinados() {
  var config = {
    method: 'get',
    url: API_URL + 'arquivos-assinados/',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscarArquivosAssinadosVinculados = function buscarArquivosAssinadosVinculados(vinculados, usuarioAssinante, dataAssinaturaInicio, dataAssinaturaFim, arquivosAssinadosUsuario) {
  var config = {
    method: 'get',
    url: API_URL + 'arquivos-assinados/',
    responseType: 'json',
    credentials: true,
    params: {
      vinculados: vinculados,
      usuarioAssinante: usuarioAssinante,
      dataAssinaturaInicio: dataAssinaturaInicio,
      dataAssinaturaFim: dataAssinaturaFim,
      arquivosAssinadosUsuario: arquivosAssinadosUsuario
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscarArquivoAssinado = function buscarArquivoAssinado(idArquivoAssinado, tipoArquivo) {
  var config = {
    method: 'get',
    url: API_URL + ('arquivos-assinados/' + idArquivoAssinado),
    responseType: 'arraybuffer',
    credentials: true,
    params: {
      tipoArquivo: tipoArquivo
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscarTiposAssinatura = function buscarTiposAssinatura() {
  var config = {
    method: 'get',
    url: API_URL + 'arquivos-assinados/tipos-assinatura',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var excluirArquivoAssinado = function excluirArquivoAssinado(idArquivoAssinado) {
  var config = {
    method: 'delete',
    url: API_URL + ('arquivos-assinados/' + idArquivoAssinado),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var inserirArquivoAssinado = function inserirArquivoAssinado(body, idTipoAssinatura, tipoAssinatura, matrSiape) {
  var config = {
    method: 'post',
    url: API_URL + 'arquivos-assinados/',
    responseType: 'json',
    emulateJSON: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    credentials: true,
    body: body,
    params: {
      idTipoAssinatura: idTipoAssinatura,
      tipoAssinatura: tipoAssinatura,
      matrSiape: matrSiape
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var enviarArquivoAssinado = function enviarArquivoAssinado(idArquivoAssinado, idDocumento, body) {
  var config = {
    method: 'post',
    url: API_URL + ('arquivos-assinados/' + idArquivoAssinado + '/vincular-documento/' + idDocumento),
    responseType: 'json',
    emulateJSON: true,
    credentials: true,
    body: body
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var alterarSequencialPeca = function alterarSequencialPeca(idDocumento, idAcessoAnexo, novoSequencial) {
  var config = {
    method: 'patch',
    url: API_URL + ('documentos/' + idDocumento + '/pecas/' + idAcessoAnexo),
    responseType: 'json',
    credentials: true,
    body: {
      sequencial: novoSequencial
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscarConsolidacoes = function buscarConsolidacoes() {
  var config = {
    method: 'get',
    url: API_URL + 'consolidacao',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscarConsolidacaoPorUUID = function buscarConsolidacaoPorUUID(listTrabalhos) {
  var config = {
    method: 'post',
    url: API_URL + 'consolidacao',
    responseType: 'json',
    credentials: true,
    body: listTrabalhos
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getTiposDocumentoAutorizados: getTiposDocumentoAutorizados,
  getTiposDocumentoGlossario: getTiposDocumentoGlossario,
  getTodosTiposDocumento: getTodosTiposDocumento,
  getListaDocumentos: getListaDocumentos,
  getListaDocumentosCaixaPostal: getListaDocumentosCaixaPostal,
  getListaDocumentosParaJuntada: getListaDocumentosParaJuntada,
  getListaDocumentosParaDesmembramento: getListaDocumentosParaDesmembramento,
  getDocument: getDocument,
  getInteressadoPorId: getInteressadoPorId,
  getResponsavelTramitacaoPorId: getResponsavelTramitacaoPorId,
  getListaUnidadesReencaminhamento: getListaUnidadesReencaminhamento,
  getListaDocumentosReencaminhamento: getListaDocumentosReencaminhamento,
  getListaUnidadesProcedenciaCaixaPostal: getListaUnidadesProcedenciaCaixaPostal,
  getListaUnidadesProcedenciaRelatorios: getListaUnidadesProcedenciaRelatorios,
  getUnidadeProcedenciaPorId: getUnidadeProcedenciaPorId,
  getProcessingsList: getProcessingsList,
  getListaArquivos: getListaArquivos,
  getListaPecas: getListaPecas,
  getListaVinculosDocumento: getListaVinculosDocumento,
  getPassosFluxoPossiveisList: getPassosFluxoPossiveisList,
  getPassosFluxoPossiveisReencaminhamentoList: getPassosFluxoPossiveisReencaminhamentoList,
  getDestinosPassoFluxoList: getDestinosPassoFluxoList,
  getValidacaoFluxo: getValidacaoFluxo,
  getUltimaTramitacao: getUltimaTramitacao,
  getMotivosRestricoesArquivo: getMotivosRestricoesArquivo,
  getEmailInteressado: getEmailInteressado,
  getArquivo: getArquivo,
  getArquivoBinario: getArquivoBinario,
  solicitaConsolidacao: solicitaConsolidacao,
  getPDFCapa: getPDFCapa,
  getPDFComprovanteProtocolizacao: getPDFComprovanteProtocolizacao,
  getDespachoSalvo: getDespachoSalvo,
  enviarComprovanteProtocolizacaoPorEmail: enviarComprovanteProtocolizacaoPorEmail,
  receberDocumento: receberDocumento,
  receberDocumentoReencaminhamento: receberDocumentoReencaminhamento,
  realizarReencaminhamento: realizarReencaminhamento,
  salvarDespacho: salvarDespacho,
  salvarDespachoPreparatorio: salvarDespachoPreparatorio,
  enviarTramitacao: enviarTramitacao,
  juntarDocumentos: juntarDocumentos,
  excluirArquivo: excluirArquivo,
  cancelarPeca: cancelarPeca,
  enviarArquivo: enviarArquivo,
  salvarAlteracoesArquivo: salvarAlteracoesArquivo,
  desapensarDocumentos: desapensarDocumentos,
  getListaUnidadesProcedenciaConsulta: getListaUnidadesProcedenciaConsulta,
  getListaServidoresProcedencia: getListaServidoresProcedencia,
  salvarTags: salvarTags,
  favoritarDocumento: favoritarDocumento,
  desfavoritarDocumento: desfavoritarDocumento,
  buscarDocumentosFavoritos: buscarDocumentosFavoritos,
  alternarAcompanhamentoDeDocumentoFavorito: alternarAcompanhamentoDeDocumentoFavorito,
  alterarMarcadoresDeDocumentosFavoritos: alterarMarcadoresDeDocumentosFavoritos,
  buscarArquivosAssinados: buscarArquivosAssinados,
  buscarArquivosAssinadosVinculados: buscarArquivosAssinadosVinculados,
  buscarArquivoAssinado: buscarArquivoAssinado,
  buscarTiposAssinatura: buscarTiposAssinatura,
  excluirArquivoAssinado: excluirArquivoAssinado,
  inserirArquivoAssinado: inserirArquivoAssinado,
  enviarArquivoAssinado: enviarArquivoAssinado,
  alterarSequencialPeca: alterarSequencialPeca,
  buscarConsolidacoes: buscarConsolidacoes,
  buscarConsolidacaoPorUUID: buscarConsolidacaoPorUUID
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__(61);



var _this = this;







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var Home = function Home() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 433));
};
var Ajuda = function Ajuda() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 419));
};
var Usuario = function Usuario() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 441));
};
var ConfiguracoesUsuario = function ConfiguracoesUsuario() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 440));
};
var Autuacao = function Autuacao() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 427));
};
var EdicaoAutuacao = function EdicaoAutuacao() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 426));
};
var Administracao = function Administracao() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 415));
};
var EdicaoGlossario = function EdicaoGlossario() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 416));
};
var ReencaminhamentoDocumento = function ReencaminhamentoDocumento() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 418));
};
var CaixaPostal = function CaixaPostal() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 429));
};
var Documento = function Documento() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 431));
};
var InformacoesDocumento = function InformacoesDocumento() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 410));
};
var Tramitacoes = function Tramitacoes() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 439));
};
var Pecas = function Pecas() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 436));
};
var PecasTabela = function PecasTabela() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 411));
};
var PecasUpload = function PecasUpload() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 435));
};
var VinculosDocumento = function VinculosDocumento() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 442));
};
var BuscaDocumentos = function BuscaDocumentos() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 428));
};
var NovaTramitacao = function NovaTramitacao() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 438));
};
var PageNotFound = function PageNotFound() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 414));
};
var Juntada = function Juntada() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 434));
};
var Relatorios = function Relatorios() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 437));
};
var RelatorioGuiaRemessaMalote = function RelatorioGuiaRemessaMalote() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 413));
};
var RelatorioDocumentosDesarquivadosSetor = function RelatorioDocumentosDesarquivadosSetor() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 412));
};
var DocumentosFavoritos = function DocumentosFavoritos() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 432));
};
var EdicaoTipoDocumental = function EdicaoTipoDocumental() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 417));
};
var ArquivosAssinados = function ArquivosAssinados() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 425));
};
var Consolidacao = function Consolidacao() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 430));
};

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    redirect: { name: '404' }
  }, {
    path: '/',
    redirect: { name: 'Home' }
  }, {
    path: '/home',
    name: 'Home',
    component: Home
  }, {
    path: '/autuacoes',
    component: Autuacao,
    meta: { requiresAuth: true },
    children: [{
      path: '',
      name: 'NovaAutuacao',
      component: EdicaoAutuacao
    }, {
      path: ':idDocumento',
      name: 'EdicaoAutuacao',
      component: EdicaoAutuacao,
      props: function props(route) {
        return { idDocumento: route.params.idDocumento };
      }
    }]
  }, {
    path: '/administracao',
    component: Administracao,
    meta: { requiresAuth: true },
    children: [{
      path: 'edicao-de-vocabulario-controlado',
      name: 'EdicaoGlossario',
      component: EdicaoGlossario
    }, {
      path: 'reencaminhamento-de-documento',
      name: 'ReencaminhamentoDocumento',
      component: ReencaminhamentoDocumento
    }, {
      path: 'edicao-tipo-documental',
      name: 'EdicaoTipoDocumental',
      component: EdicaoTipoDocumental
    }]
  }, {
    path: '/busca',
    name: 'BuscaDocumentos',
    component: BuscaDocumentos,
    props: function props(route) {
      return { query: route.query };
    }
  }, {
    path: '/caixa-postal',
    name: 'CaixaPostal',
    component: CaixaPostal,
    meta: { requiresAuth: true }
  }, {
    path: '/relatorios',
    component: Relatorios,
    meta: { requiresAuth: true },
    children: [{
      path: 'malote',
      name: 'RelatorioGuiaRemessaMalote',
      component: RelatorioGuiaRemessaMalote,
      meta: { requiresAuth: true }
    }, {
      path: 'documentos-desarquivados',
      name: 'RelatorioDocumentosDesarquivadosSetor',
      component: RelatorioDocumentosDesarquivadosSetor,
      meta: { requiresAuth: true }
    }]
  }, {
    path: '/ajuda',
    name: 'Ajuda',
    component: Ajuda
  }, {
    path: '/documentos/:documentId',
    component: Documento,
    props: function props(route) {
      return { documentId: route.params.documentId };
    },
    children: [{
      path: '',
      name: 'InformacoesDocumento',
      component: InformacoesDocumento
    }, {
      path: 'juntada',
      name: 'Juntada',
      component: Juntada,
      meta: { requiresAuth: true }
    }, {
      path: 'tramitacoes',
      name: 'Tramitacoes',
      component: Tramitacoes
    }, {
      path: 'pecas',
      component: Pecas,
      children: [{
        path: '',
        name: 'PecasTabela',
        component: PecasTabela
      }, {
        path: 'upload',
        name: 'PecasUpload',
        component: PecasUpload,
        meta: { requiresAuth: true }
      }]
    }, {
      path: 'vinculos',
      name: 'VinculosDocumento',
      component: VinculosDocumento
    }, {
      path: 'tramitar',
      name: 'Tramitar',
      component: NovaTramitacao,
      meta: { requiresAuth: true }
    }]
  }, {
    path: '/usuario',
    component: Usuario,
    meta: { requiresAuth: true },
    children: [{
      path: '',
      name: 'ConfiguracoesUsuario',
      component: ConfiguracoesUsuario,
      meta: { requiresAuth: true }
    }]
  }, {
    path: '/404',
    name: '404',
    component: PageNotFound
  }, {
    path: '/documentos-favoritos',
    name: 'DocumentosFavoritos',
    component: DocumentosFavoritos,
    meta: { requiresAuth: true }
  }, {
    path: '/arquivos-assinados',
    name: 'ArquivosAssinados',
    component: ArquivosAssinados,
    meta: { requiresAuth: true }
  }, {
    path: '/consolidacao',
    name: 'Consolidacao',
    component: Consolidacao
  }]
});

router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var responseAuth, responsePermissoes, responseConfiguracoes;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_5__utils_auth__["a" /* default */].getAutenticacaoUsuario();

          case 3:
            responseAuth = _context.sent;
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_5__utils_auth__["a" /* default */].getPermissoesUsuario();

          case 6:
            responsePermissoes = _context.sent;
            _context.next = 9;
            return __WEBPACK_IMPORTED_MODULE_5__utils_auth__["a" /* default */].getConfiguracoesUsuario();

          case 9:
            responseConfiguracoes = _context.sent;

            __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].dispatch('auth/SET_USUARIO', { dadosAuth: responseAuth, dadosPermissoes: responsePermissoes, dadosConfiguracoes: responseConfiguracoes });
            next();
            _context.next = 18;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](0);

            __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */].dispatch('auth/SET_USUARIO', {});
            if (to.matched.some(function (record) {
              return record.meta.requiresAuth;
            })) {
              window.location.replace("https://api-lepisma.prod.uks.ufes.br/" + 'web');
            } else {
              next();
            }

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 14]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('pt-br');

var methods = {
  format: function format(date) {
    if (date) return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('L'); // DD/MM/AAAA
    else return undefined;
  },
  formatDateHour: function formatDateHour(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY HH:mm:ss'); // DD/MM/AAAA
  },
  formatStyle: function formatStyle(date, style) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(style);
  },
  APIFormat: function APIFormat(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
  },
  daysDiff: function daysDiff(startDate, endDate) {
    if (endDate) {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
      return Math.abs(startDate.diff(endDate, 'days', true));
    } else {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now());
      return Math.abs(startDate.diff(endDate, 'days', true));
    }
  },
  daysDiffInteger: function daysDiffInteger(startDate, endDate) {
    if (endDate) {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
      return Math.abs(startDate.diff(endDate, 'days'));
    } else {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now());
      return Math.abs(startDate.diff(endDate, 'days'));
    }
  },
  daysDiffSigned: function daysDiffSigned(startDate, endDate) {
    if (endDate) {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
      return startDate.diff(endDate, 'days', true);
    } else {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now());
      return startDate.diff(endDate, 'days', true);
    }
  },
  daysDiffIntegerSigned: function daysDiffIntegerSigned(startDate, endDate) {
    if (endDate) {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
      return startDate.diff(endDate, 'days');
    } else {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now());
      return startDate.diff(endDate, 'days');
    }
  },
  subtract: function subtract(date, quantity, type) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).subtract(quantity, type).format();
  },
  add: function add(date, quantity, type) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).add(quantity, type).format();
  },
  now: function now() {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_auth_module__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_module__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_caixa_postal_module__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_busca_documentos_module__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_documento_module__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_module__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_tramitacoes_module__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_autuacao_module__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_arquivos_documento_module__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_vinculos_documento_module__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_relatorios_module__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuex_administracao_module__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vuex_reencaminhamento_documento_module__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vuex_documentos_favoritos_module__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vuex_administracao_edicao_tipo_documental_module__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vuex_arquivos_assinados_module__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(236);



















// Vuex for state management

__WEBPACK_IMPORTED_MODULE_16_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* default */].Store({
  // strict: process.env.NODE_ENV !== 'production',
  strict: false,
  modules: {
    'auth': __WEBPACK_IMPORTED_MODULE_0__vuex_auth_module__["a" /* default */],
    'ui': __WEBPACK_IMPORTED_MODULE_1__vuex_ui_module__["a" /* default */],
    'caixaPostal': __WEBPACK_IMPORTED_MODULE_2__vuex_caixa_postal_module__["a" /* default */],
    'buscaDocumentos': __WEBPACK_IMPORTED_MODULE_3__vuex_busca_documentos_module__["a" /* default */],
    'documento': __WEBPACK_IMPORTED_MODULE_4__vuex_documento_module__["a" /* default */],
    'juntada': __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_module__["a" /* default */],
    'tramitacoes': __WEBPACK_IMPORTED_MODULE_6__vuex_tramitacoes_module__["a" /* default */],
    'autuacao': __WEBPACK_IMPORTED_MODULE_7__vuex_autuacao_module__["a" /* default */],
    'arquivosDocumento': __WEBPACK_IMPORTED_MODULE_8__vuex_arquivos_documento_module__["a" /* default */],
    'vinculosDocumento': __WEBPACK_IMPORTED_MODULE_9__vuex_vinculos_documento_module__["a" /* default */],
    'relatorios': __WEBPACK_IMPORTED_MODULE_10__vuex_relatorios_module__["a" /* default */],
    'administracao': __WEBPACK_IMPORTED_MODULE_11__vuex_administracao_module__["a" /* default */],
    'reencaminhamento-documento': __WEBPACK_IMPORTED_MODULE_12__vuex_reencaminhamento_documento_module__["a" /* default */],
    'documentosFavoritos': __WEBPACK_IMPORTED_MODULE_13__vuex_documentos_favoritos_module__["a" /* default */],
    'edicaoTipoDocumental': __WEBPACK_IMPORTED_MODULE_14__vuex_administracao_edicao_tipo_documental_module__["a" /* default */],
    'arquivosAssinados': __WEBPACK_IMPORTED_MODULE_15__vuex_arquivos_assinados_module__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(20);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://api-lepisma.prod.uks.ufes.br/";

var getListaItensGlossario = function getListaItensGlossario() {
  var SUBJECT_LIST_URL = API_URL + 'glossario';
  var config = {
    method: 'get',
    url: SUBJECT_LIST_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var criarItemGlossario = function criarItemGlossario(body) {
  var config = {
    method: 'post',
    url: API_URL + 'glossario',
    responseType: 'json',
    credentials: true,
    body: body
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var editarItemGlossario = function editarItemGlossario(idItemGlossario, body) {
  var config = {
    method: 'patch',
    url: API_URL + ('glossario/' + idItemGlossario),
    responseType: 'json',
    credentials: true,
    body: body
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var excluirItemGlossario = function excluirItemGlossario(idItemGlossario) {
  var config = {
    method: 'delete',
    url: API_URL + ('glossario/' + idItemGlossario),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var alteraPropriedadeTipoDocumental = function alteraPropriedadeTipoDocumental(idTipoDocumento, propriedade) {
  var config = {
    method: 'patch',
    url: API_URL + ('tipos-documentos/' + idTipoDocumento),
    responseType: 'json',
    credentials: true,
    body: propriedade
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var buscaTodosTiposDocumento = function buscaTodosTiposDocumento() {
  var DOCUMENT_TYPES_URL = API_URL + 'tipos-documentos?todosTipos=true&incluirInativos=true';
  var config = {
    method: 'get',
    url: DOCUMENT_TYPES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getListaItensGlossario: getListaItensGlossario,
  criarItemGlossario: criarItemGlossario,
  editarItemGlossario: editarItemGlossario,
  excluirItemGlossario: excluirItemGlossario,
  alteraPropriedadeTipoDocumental: alteraPropriedadeTipoDocumental,
  buscaTodosTiposDocumento: buscaTodosTiposDocumento
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(20);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://api-lepisma.prod.uks.ufes.br/";

// Send a request to the login URL. When using JWT, will just probably uncomment these lines
// const login = (creds) => {
//   let token = btoa(creds.name + ':' + creds.password)
//   let config = {
//     method: 'post',
//     url: LOGIN_URL,
//     responseType: 'json',
//     headers: {
//       'Authorization': 'Basic ' + token
//     },
//     credentials: true
//   }
//   return Vue.http(config)
// }

var getAutenticacaoUsuario = function getAutenticacaoUsuario() {
  var config = {
    method: 'get',
    url: API_URL + 'auth',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPermissoesUsuario = function getPermissoesUsuario() {
  var config = {
    method: 'get',
    url: API_URL + 'auth/permissoes',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getConfiguracoesUsuario = function getConfiguracoesUsuario() {
  var config = {
    method: 'get',
    url: API_URL + 'auth/configuracoes',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var alterarConfiguracoesUsuario = function alterarConfiguracoesUsuario(payload) {
  var config = {
    method: 'post',
    url: API_URL + 'auth/configuracoes',
    responseType: 'json',
    credentials: true,
    body: payload
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAutenticacaoUsuario: getAutenticacaoUsuario,
  getPermissoesUsuario: getPermissoesUsuario,
  getConfiguracoesUsuario: getConfiguracoesUsuario,
  alterarConfiguracoesUsuario: alterarConfiguracoesUsuario
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(20);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://api-lepisma.prod.uks.ufes.br/";
var INTERESTED_TYPES = {
  'ALUNO': 'A',
  'FORNECEDOR': 'F',
  'CURSO': 'K',
  'ENTIDADE_EXTERNA': 'O',
  'SERVIDOR': 'S',
  'UNIDADE': 'U',
  'CONTRIBUINTE': 'C'
};

var getListaUnidadesProcedencia = function getListaUnidadesProcedencia(somenteAtivas) {
  var UNIDADES_AUTUACAO_URL = API_URL + 'procedencias/UNIDADE';
  var config = {
    method: 'get',
    url: UNIDADES_AUTUACAO_URL,
    responseType: 'json',
    credentials: true,
    params: {
      somenteAtivas: somenteAtivas
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaTipoInteressado = function getListaTipoInteressado(idTipoDocumento) {
  var INTERESTED_TYPES_URL = API_URL + 'interessados';
  var params = {};
  if (idTipoDocumento) params.idTipoDocumento = idTipoDocumento;
  var config = {
    method: 'get',
    url: INTERESTED_TYPES_URL,
    responseType: 'json',
    credentials: true,
    params: params
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaTipoResponsavelTramitacao = function getListaTipoResponsavelTramitacao() {
  var INTERESTED_TYPES_URL = API_URL + 'responsaveis-tramitacao';
  var config = {
    method: 'get',
    url: INTERESTED_TYPES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaEntidadeInteressada = function getListaEntidadeInteressada(tipoInteressado, tipoBusca, nome, codigo, somenteAtivos) {
  var INTERESTED_ENTITIES_URL = API_URL + 'interessados/' + tipoInteressado;
  var params = {};
  if (tipoBusca === 'nome') params.nome = nome;
  if (tipoBusca === 'codigo') params.codigo = codigo;
  params.somenteAtivos = somenteAtivos;
  var config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: params,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaEntidadeResponsavelTramitacao = function getListaEntidadeResponsavelTramitacao(tipoResponsavelTramitacao, tipoBusca, nome, codigo) {
  var INTERESTED_ENTITIES_URL = API_URL + 'responsaveis-tramitacao/' + tipoResponsavelTramitacao;
  var params = {};
  if (tipoBusca === 'nome') params.nome = nome;
  if (tipoBusca === 'codigo') params.codigo = codigo;
  var config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: params,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaTiposAssunto = function getListaTiposAssunto(documentType) {
  var SUBJECT_LIST_URL = API_URL + 'tipos-documentos/' + documentType + '/assuntos';
  var config = {
    method: 'get',
    url: SUBJECT_LIST_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getAssuntos = function getAssuntos(idTipoDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'assuntos',
    responseType: 'json',
    credentials: true,
    params: idTipoDocumento ? { idTipoDocumento: idTipoDocumento } : undefined
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getAssunto = function getAssunto(idAssunto) {
  var config = {
    method: 'get',
    url: API_URL + ('assuntos/' + idAssunto),
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getItensGlossario = function getItensGlossario() {
  var SUBJECT_LIST_URL = API_URL + 'glossario';
  var config = {
    method: 'get',
    url: SUBJECT_LIST_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var enviarAutuacao = function enviarAutuacao(idDocumento, bodyAutuacao) {
  bodyAutuacao.tipoInteressado = INTERESTED_TYPES[bodyAutuacao.tipoInteressado];
  var config = {
    method: idDocumento ? 'patch' : 'post',
    url: API_URL + ('documentos' + (idDocumento ? '/' + idDocumento : '')),
    responseType: 'json',
    credentials: true,
    body: bodyAutuacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getDocumentoOrigem = function getDocumentoOrigem(numeroDocumento) {
  var config = {
    method: 'get',
    url: API_URL + 'documentos',
    params: {
      numeroDocumento: numeroDocumento
    },
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};
/* harmony default export */ __webpack_exports__["a"] = ({
  getListaUnidadesProcedencia: getListaUnidadesProcedencia,
  getListaTipoInteressado: getListaTipoInteressado,
  getListaTipoResponsavelTramitacao: getListaTipoResponsavelTramitacao,
  getListaEntidadeInteressada: getListaEntidadeInteressada,
  getListaEntidadeResponsavelTramitacao: getListaEntidadeResponsavelTramitacao,
  getListaTiposAssunto: getListaTiposAssunto,
  getDocumentoOrigem: getDocumentoOrigem,
  enviarAutuacao: enviarAutuacao,
  getAssuntos: getAssuntos,
  getAssunto: getAssunto,
  getItensGlossario: getItensGlossario
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_LISTA_TIPOS_DOCUMENTAIS: 'SET_LISTA_TIPOS_DOCUMENTAIS',
  SET_TIPO_SELECIONADO: 'SET_TIPO_SELECIONADO',
  SET_PROPRIEDADES: 'SET_PROPRIEDADES',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  ABRIR_DIALOG_EDICAO: 'ABRIR_DIALOG_EDICAO',
  FECHAR_DIALOG_EDICAO: 'FECHAR_DIALOG_EDICAO',
  SET_LISTA_ITENS_GLOSSARIO: 'SET_LISTA_ITENS_GLOSSARIO',
  CRIAR_ITEM_GLOSSARIO: 'CRIAR_ITEM_GLOSSARIO',
  EDITAR_ITEM_GLOSSARIO: 'EDITAR_ITEM_GLOSSARIO',
  EXCLUIR_ITEM_GLOSSARIO: 'EXCLUIR_ITEM_GLOSSARIO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG',
  SET_LISTA_TIPOS_DOCUMENTO: 'SET_LISTA_TIPOS_DOCUMENTO'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {

  SET_LISTA_ARQUIVOS_ASSINADOS: 'SET_LISTA_ARQUIVOS_ASSINADOS',
  SET_ARQUIVO_ASSINADO_BLOB_URL: 'SET_ARQUIVO_ASSINADO_BLOB_URL',
  SET_LISTA_TIPOS_ASSINATURA: 'SET_LISTA_TIPOS_ASSINATURA',

  SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG',
  HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO: 'SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO',
  SET_LISTA_ARQUIVOS: 'SET_LISTA_ARQUIVOS',
  SET_LISTA_PECAS: 'SET_LISTA_PECAS',
  SET_ARQUIVO: 'SET_ARQUIVO',
  SET_ARQUIVO_BLOB_URL: 'SET_ARQUIVO_BLOB_URL',
  SET_PASSO_ATUAL: 'SET_PASSO_ATUAL',
  SET_SITUACAO_VINCULO: 'SET_SITUACAO_VINCULO',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_DOCUMENTO_SELECIONADO: 'SET_DOCUMENTO_SELECIONADO',
  SET_JUSTIFICATIVA_CANCELAMENTO: 'SET_JUSTIFICATIVA_CANCELAMENTO',
  SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS: 'SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS',
  REMOVER_ARQUIVO_LISTA: 'REMOVER_ARQUIVO_LISTA',
  ALTERAR_PECA_LISTA: 'ALTERAR_PECA_LISTA',
  ALTERAR_SEQUENCIAL: 'ALTERAR_SEQUENCIAL',

  SHOW_EDICAO_ARQUIVO_DIALOG: 'SHOW_EDICAO_ARQUIVO_DIALOG',
  HIDE_EDICAO_ARQUIVO_DIALOG: 'HIDE_EDICAO_ARQUIVO_DIALOG',
  SHOW_CANCELAMENTO_PECA_DIALOG: 'SHOW_CANCELAMENTO_PECA_DIALOG',
  HIDE_EXCLUSAO_ARQUIVO_DIALOG: 'HIDE_EXCLUSAO_ARQUIVO_DIALOG',
  SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG: 'SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG',
  HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG: 'HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_USUARIO: 'SET_USUARIO',
  ALTERAR_CONFIGURACOES_USUARIO: 'ALTERAR_CONFIGURACOES_USUARIO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  EXIBIR_DIALOG_INTERESSADO: 'EXIBIR_DIALOG_INTERESSADO',
  ESCONDER_DIALOG_INTERESSADO: 'ESCONDER_DIALOG_INTERESSADO',
  EXIBIR_DIALOG_ASSUNTO: 'EXIBIR_DIALOG_ASSUNTO',
  ESCONDER_DIALOG_ASSUNTO: 'ESCONDER_DIALOG_ASSUNTO',
  EXIBIR_DIALOG_GLOSSARIO: 'EXIBIR_DIALOG_GLOSSARIO',
  ESCONDER_DIALOG_GLOSSARIO: 'ESCONDER_DIALOG_GLOSSARIO',

  SET_LISTA_TIPO_DOCUMENTO: 'SET_LISTA_TIPO_DOCUMENTO',
  SET_LISTA_UNIDADE_PROCEDENCIA: 'SET_LISTA_UNIDADE_PROCEDENCIA',
  SET_LISTA_TIPO_INTERESSADO: 'SET_LISTA_TIPO_INTERESSADO',
  SET_LISTA_INTERESSADOS: 'SET_LISTA_INTERESSADOS',
  SET_LISTA_ASSUNTO: 'SET_LISTA_ASSUNTO',
  SET_LISTA_ASSUNTO_NIVEL_1: 'SET_LISTA_ASSUNTO_NIVEL_1',
  SET_LISTA_ITENS_GLOSSARIO: 'SET_LISTA_ITENS_GLOSSARIO',

  SET_TIPO_DOCUMENTO: 'SET_TIPO_DOCUMENTO',
  SET_UNIDADE_PROCEDENCIA: 'SET_UNIDADE_PROCEDENCIA',
  SET_TIPO_INTERESSADO: 'SET_TIPO_INTERESSADO',
  SET_INTERESSADO: 'SET_INTERESSADO',
  SET_ASSUNTO: 'SET_ASSUNTO',
  SET_RESUMO_ASSUNTO: 'SET_RESUMO_ASSUNTO',
  SET_URGENTE: 'SET_URGENTE',
  SET_MOTIVO_URGENCIA: 'SET_MOTIVO_URGENCIA',
  SET_DOCUMENTO_ORIGEM: 'SET_DOCUMENTO_ORIGEM',
  SET_EMITENTE: 'SET_EMITENTE',
  SET_DATA_DOCUMENTO_ORIGEM: 'SET_DATA_DOCUMENTO_ORIGEM',
  SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM: 'SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM',
  SET_OBSERVACAO: 'SET_OBSERVACAO',

  SET_DOCUMENTO: 'SET_DOCUMENTO',
  SET_BUSCANDO_DOCUMENTO_ORIGEM: 'SET_BUSCANDO_DOCUMENTO_ORIGEM',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_LISTA_TIPOS_DOCUMENTO: 'SET_LISTA_TIPOS_DOCUMENTO',
  SET_LISTA_TIPO_INTERESSADO: 'SET_LISTA_TIPO_INTERESSADO',
  SET_LISTA_INTERESSADOS: 'SET_LISTA_INTERESSADOS',
  SET_TIPO_INTERESSADO: 'SET_TIPO_INTERESSADO',
  SET_INTERESSADO: 'SET_INTERESSADO',
  SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO: 'SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO',
  SET_LISTA_RESPONSAVEL_TRAMITACAO: 'SET_LISTA_RESPONSAVEL_TRAMITACAO',
  SET_TIPO_RESPONSAVEL_TRAMITACAO: 'SET_TIPO_RESPONSAVEL_TRAMITACAO',
  SET_RESPONSAVEL_TRAMITACAO: 'SET_RESPONSAVEL_TRAMITACAO',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_LISTA_UNIDADES_PROCEDENCIA: 'SET_LISTA_UNIDADES_PROCEDENCIA',
  SET_LISTA_SERVIDORES_PROCEDENCIA: 'SET_LISTA_SERVIDORES_PROCEDENCIA',
  EXIBIR_DIALOG_INTERESSADO: 'EXIBIR_DIALOG_INTERESSADO',
  ESCONDER_DIALOG_INTERESSADO: 'ESCONDER_DIALOG_INTERESSADO',
  EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO: 'EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO',
  ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO: 'ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO',
  SET_BUSCANDO_DOCUMENTOS: 'SET_BUSCANDO_DOCUMENTOS',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_NUMERO_DOCUMENTO: 'SET_NUMERO_DOCUMENTO',
  SET_ID_TIPO_DOCUMENTO: 'SET_ID_TIPO_DOCUMENTO',
  SET_ID_UNIDADE_ATUAL: 'SET_ID_UNIDADE_ATUAL',
  SET_DATA_ENVIO_INICIO: 'SET_DATA_ENVIO_INICIO',
  SET_DATA_ENVIO_FIM: 'SET_DATA_ENVIO_FIM',
  SET_LISTA_TIPOS_DOCUMENTO: 'SET_LISTA_TIPOS_DOCUMENTO',
  SET_LISTA_UNIDADES_AUTORIZADAS: 'SET_LISTA_UNIDADES_AUTORIZADAS',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL: 'SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SET_DOCUMENTO: 'SET_DOCUMENTO',
  SET_PRESENTE_CAIXA_POSTAL: 'SET_PRESENTE_CAIXA_POSTAL',
  SET_RAIZ_PRESENTE_CAIXA_POSTAL: 'SET_RAIZ_PRESENTE_CAIXA_POSTAL',
  SET_EMAIL_INTERESSADO: 'SET_EMAIL_INTERESSADO',
  SET_URL_CONSOLIDACAO: 'SET_URL_CONSOLIDACAO',
  SET_LISTA_CONSOLIDACOES: 'SET_LISTA_CONSOLIDACOES',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {

  SET_LISTA_FAVORITOS: 'SET_LISTA_FAVORITOS',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_PASSO_ATUAL: 'SET_PASSO_ATUAL',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_TIPO_JUNTADA_SELECIONADA: 'SET_TIPO_JUNTADA_SELECIONADA',
  SET_DOCUMENTO_SELECIONADO: 'SET_DOCUMENTO_SELECIONADO',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_PASSO_ATUAL: 'SET_PASSO_ATUAL',
  SET_LISTA_UNIDADES: 'SET_LISTA_UNIDADES',
  SET_UNIDADE: 'SET_UNIDADE',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_DOCUMENTO: 'SET_DOCUMENTO',
  SET_NUMERO_DOCUMENTO: 'SET_NUMERO_DOCUMENTO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_LISTA_UNIDADES_PROCEDENCIA: 'SET_LISTA_UNIDADES_PROCEDENCIA',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_LISTA_TRAMITACOES: 'SET_LISTA_TRAMITACOES',
  SET_LISTA_FLUXOS: 'SET_LISTA_FLUXOS',
  SET_DESTINOS_FLUXO: 'SET_DESTINOS_FLUXO',
  SET_VALIDACAO_FLUXO: 'SET_VALIDACAO_FLUXO',
  SET_FLUXO: 'SET_FLUXO',
  SET_DESTINO: 'SET_DESTINO',
  SET_DESPACHO: 'SET_DESPACHO',
  SET_DESPACHO_SALVO: 'SET_DESPACHO_SALVO',
  SET_NIVEL_ACESSO: 'SET_NIVEL_ACESSO',
  SET_HIPOTESE_LEGAL: 'SET_HIPOTESE_LEGAL',
  SET_LISTA_HIPOTESE_LEGAL: 'SET_LISTA_HIPOTESE_LEGAL',
  SET_TIPO_DESPACHO: 'SET_TIPO_DESPACHO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG',
  SET_DESPACHO_PREPARATORIO: 'SET_DESPACHO_PREPARATORIO'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SHOW_GLOBAL_LOADING: 'SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'HIDE_GLOBAL_LOADING',
  SET_SNACKBAR: 'SET_SNACKBAR',
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR',
  SET_ENFATIZAR_SNACKBAR: 'SET_ENFATIZAR_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'HIDE_CONFIRMATION_DIALOG',
  SHOW_CONFIRMAR_DIALOG: 'SHOW_CONFIRMAR_DIALOG',
  HIDE_CONFIRMAR_DIALOG: 'HIDE_CONFIRMAR_DIALOG',
  SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE: 'SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE',
  SET_CONFIRMAR_DIALOG_PROMISE_REJECT: 'SET_CONFIRMAR_DIALOG_PROMISE_REJECT',
  SET_INFORMACAO: 'SET_INFORMACAO'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_LISTA_VINCULOS_DOCUMENTO: 'SET_LISTA_VINCULOS_DOCUMENTO',
  SET_DOCUMENTO_AGREGADOR: 'SET_DOCUMENTO_AGREGADOR',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_gtag__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__app__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale('pt-br');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.moment = __WEBPACK_IMPORTED_MODULE_4_moment___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_gtag__["a" /* default */], {
  config: {
    id: 'G-0FTQYC6381'
  }
}, __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]);

__webpack_require__(230);
__webpack_require__(228);
__webpack_require__(229);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__vuex_store_js__["a" /* default */],
  el: '#app',
  template: '<app/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__app___default.a }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(20);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://api-lepisma.prod.uks.ufes.br/";

var getInformacao = function getInformacao() {
  var config = {
    method: 'get',
    url: API_URL + 'mensagens',
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getInformacao: getInformacao
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(20);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://api-lepisma.prod.uks.ufes.br/";

var getPDFGuiaRemessaMalote = function getPDFGuiaRemessaMalote(parameters) {
  var GUIA_REMESSA_MALOTE_PDF_URL = API_URL + 'relatorios/malote';
  var config = {
    method: 'get',
    url: GUIA_REMESSA_MALOTE_PDF_URL,
    params: {
      inicio: parameters.dataInicio + 'T' + parameters.horaInicio,
      fim: parameters.dataFim + 'T' + parameters.horaFim,
      idsUnidades: parameters.idsUnidades
    },
    responseType: 'arraybuffer',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPDFDocumentosDesarquivadosSetor = function getPDFDocumentosDesarquivadosSetor(parameters) {
  var GUIA_REMESSA_MALOTE_PDF_URL = API_URL + 'relatorios/desarquivados';
  var config = {
    method: 'get',
    url: GUIA_REMESSA_MALOTE_PDF_URL,
    params: {
      inicio: parameters.dataInicio + 'T' + parameters.horaInicio,
      fim: parameters.dataFim + 'T' + parameters.horaFim,
      idsUnidades: parameters.idsUnidades
    },
    responseType: 'arraybuffer',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};
/* harmony default export */ __webpack_exports__["a"] = ({
  getPDFGuiaRemessaMalote: getPDFGuiaRemessaMalote,
  getPDFDocumentosDesarquivadosSetor: getPDFDocumentosDesarquivadosSetor
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_mutations_types_js__ = __webpack_require__(64);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_mutations_types_js__["a" /* default */], {
  GET_LISTA_ITENS_GLOSSARIO: 'GET_LISTA_ITENS_GLOSSARIO',
  GET_LISTA_TIPOS_DOCUMENTO_GLOSSARIO: 'GET_LISTA_TIPOS_DOCUMENTO_GLOSSARIO',
  CRIAR_ITEM_GLOSSARIO: 'CRIAR_ITEM_GLOSSARIO',
  EDITAR_ITEM_GLOSSARIO: 'EDITAR_ITEM_GLOSSARIO',
  EXCLUIR_ITEM_GLOSSARIO: 'EXCLUIR_ITEM_GLOSSARIO'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_administracao__ = __webpack_require__(60);





var _this = this,
    _actions;





var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].ABRIR_DIALOG_EDICAO, function (_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].ABRIR_DIALOG_EDICAO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].FECHAR_DIALOG_EDICAO, function (_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].FECHAR_DIALOG_EDICAO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].GET_LISTA_ITENS_GLOSSARIO, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(_ref4) {
    var commit = _ref4.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, { root: true });
            _context.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: [] });
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_administracao__["a" /* default */].getListaItensGlossario();

          case 5:
            response = _context.sent;

            response.data.forEach(function (item) {
              item.descricaoAssunto = item.descricaoAssunto && item.descricaoAssunto.split('-').length > 1 ? item.descricaoAssunto.substring(item.descricaoAssunto.indexOf('-') + 1).trim() : item.descricaoAssunto.trim();
            });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: response.data });
            return _context.abrupt('return', response.data);

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os itens do vocabulário controlado' }, { root: true });
            throw _context.t0;

          case 15:
            _context.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, { root: true });
            return _context.finish(15);

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 11, 15, 18]]);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].CRIAR_ITEM_GLOSSARIO, function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(_ref6, payload) {
    var commit = _ref6.commit;
    var body, response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando novo item no vocabulário controlado' }, { root: true });
            _context2.prev = 1;
            body = {
              idTipoDocumento: payload.itemGlossario.idTipoDocumento,
              idAssunto: payload.itemGlossario.idAssunto,
              descricao: payload.itemGlossario.descricao,
              detalhamento: payload.itemGlossario.detalhamento
            };
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_administracao__["a" /* default */].criarItemGlossario(body);

          case 5:
            response = _context2.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].CRIAR_ITEM_GLOSSARIO, { itemGlossario: response.data });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Novo item inserido com sucesso no vocabulário controlado' }, { root: true });
            _context2.next = 14;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o novo item no vocabulário controlado' }, { root: true });
            throw _context2.t0;

          case 14:
            _context2.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando novo item no vocabulário controlado' }, { root: true });
            return _context2.finish(14);

          case 17:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x2, _x3) {
    return _ref5.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].EDITAR_ITEM_GLOSSARIO, function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, payload) {
    var commit = _ref8.commit;
    var body;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Editando item do vocabulário controlado' }, { root: true });
            _context3.prev = 1;
            body = {
              idTipoDocumento: payload.itemGlossario.idTipoDocumento,
              idAssunto: payload.itemGlossario.idAssunto,
              descricao: payload.itemGlossario.descricao,
              detalhamento: payload.itemGlossario.detalhamento
            };
            _context3.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_administracao__["a" /* default */].editarItemGlossario(payload.itemGlossario.idItemGlossario, body);

          case 5:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].EDITAR_ITEM_GLOSSARIO, { itemGlossario: payload.itemGlossario });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Edição de item do vocabulário controlado realizada com sucesso' }, { root: true });
            _context3.next = 13;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o novo item no vocabulário controlado' }, { root: true });
            throw _context3.t0;

          case 13:
            _context3.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Editando item do vocabulário controlado' }, { root: true });
            return _context3.finish(13);

          case 16:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x4, _x5) {
    return _ref7.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].EXCLUIR_ITEM_GLOSSARIO, function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10, payload) {
    var commit = _ref10.commit;
    var confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            confirmacaoCallback = function () {
              var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo item do vocabulário controlado' }, { root: true });
                        _context4.prev = 1;
                        _context4.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_6__utils_administracao__["a" /* default */].excluirItemGlossario(payload.itemGlossario.idItemGlossario);

                      case 4:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].EXCLUIR_ITEM_GLOSSARIO, { itemGlossario: payload.itemGlossario });
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Item excluído do vocabulário controlado com sucesso' }, { root: true });
                        _context4.next = 12;
                        break;

                      case 8:
                        _context4.prev = 8;
                        _context4.t0 = _context4['catch'](1);

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível excluir o item do vocabulário controlado' }, { root: true });
                        throw _context4.t0;

                      case 12:
                        _context4.prev = 12;

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo item do vocabulário controlado' }, { root: true });
                        return _context4.finish(12);

                      case 15:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this, [[1, 8, 12, 15]]);
              }));

              return function confirmacaoCallback() {
                return _ref11.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Excluir o item do vocabulário controlado?',
              textoConteudo: 'O item "' + payload.itemGlossario.tipoDocumento + ': ' + payload.itemGlossario.codigoAssunto + ' - ' + payload.itemGlossario.descricao + '" ser\xE1 exclu\xEDdo do vocabul\xE1rio controlado.',
              textoNao: 'Cancelar',
              textoSim: 'Excluir',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x6, _x7) {
    return _ref9.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].GET_LISTA_TIPOS_DOCUMENTO_GLOSSARIO, function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(_ref13) {
    var commit = _ref13.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documento autorizados' }, { root: true });
            _context6.prev = 1;
            _context6.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getTiposDocumentoGlossario();

          case 4:
            response = _context6.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data });
            _context6.next = 12;
            break;

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de documento autorizados' }, { root: true });
            throw _context6.t0;

          case 12:
            _context6.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_administracao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documento autorizados' }, { root: true });
            return _context6.finish(12);

          case 15:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x8) {
    return _ref12.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_mutations_types_js__ = __webpack_require__(63);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_mutations_types_js__["a" /* default */], {
  BUSCA_TIPOS_DOCUMENTAIS: 'BUSCA_TIPOS_DOCUMENTAIS',
  SELECIONA_TIPO_DOCUMENTAL: 'SELECIONA_TIPO_DOCUMENTAL',
  ALTERA_PROPRIEDADE_TIPO_DOCUMENTAL: 'ALTERA_PROPRIEDADE_TIPO_DOCUMENTAL'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_administracao__ = __webpack_require__(60);




var _this = this,
    _actions;




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].BUSCA_TIPOS_DOCUMENTAIS, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos documentais' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SET_TIPO_SELECIONADO, { idTipoSelecionado: undefined });
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_4__utils_administracao__["a" /* default */].buscaTodosTiposDocumento();

          case 5:
            response = _context.sent;

            response.body.sort(function (a, b) {
              var textA = a.descricao.toUpperCase();
              var textB = b.descricao.toUpperCase();
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTAIS, { listaTiposDocumentais: response.body });
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos documentais' }, { root: true });
            throw _context.t0;

          case 14:
            _context.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos documentais' }, { root: true });
            return _context.finish(14);

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 10, 14, 17]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SELECIONA_TIPO_DOCUMENTAL, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SET_TIPO_SELECIONADO, { idTipoSelecionado: payload.idTipoSelecionado });

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].ALTERA_PROPRIEDADE_TIPO_DOCUMENTAL, function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, payload) {
    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando propriedade' }, { root: true });
            _context3.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__utils_administracao__["a" /* default */].alteraPropriedadeTipoDocumental(payload.idTipoDocumento, payload.propriedade);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SET_PROPRIEDADES, payload);
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Propriedades do tipo documental alteradas com sucesso' }, { root: true });
            _context3.next = 12;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Erro ao alterar propriedades' }, { root: true });
            throw _context3.t0;

          case 12:
            _context3.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando propriedades' }, { root: true });
            return _context3.finish(12);

          case 15:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 8, 12, 15]]);
  }));

  return function (_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaTiposDocumentais: function listaTiposDocumentais(state) {
    return state.listaTiposDocumentais;
  },
  idTipoSelecionado: function idTipoSelecionado(state) {
    return state.idTipoSelecionado;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_administracao_edicao_tipo_documental_state_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_getters_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_edicao_tipo_documental_mutations_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_js__ = __webpack_require__(253);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_administracao_edicao_tipo_documental_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_edicao_tipo_documental_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_edicao_tipo_documental_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_mutations_types__ = __webpack_require__(63);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_mutations_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTAIS, function (state, payload) {
  state.listaTiposDocumentais = payload.listaTiposDocumentais;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_mutations_types__["a" /* default */].SET_TIPO_SELECIONADO, function (state, payload) {
  state.idTipoSelecionado = payload.idTipoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_edicao_tipo_documental_mutations_types__["a" /* default */].SET_PROPRIEDADES, function (state, payload) {
  state.listaTiposDocumentais.forEach(function (o) {
    if (o.id === payload.idTipoDocumento) {
      if (typeof payload.propriedade.ativo !== 'undefined') {
        o.ativo = payload.propriedade.ativo;
      }
      if (typeof payload.propriedade.geraCapa !== 'undefined') {
        o.geraCapa = payload.propriedade.geraCapa;
      }
      if (typeof payload.propriedade.notificaInteressadoTramitacao !== 'undefined') {
        o.notificaInteressadoTramitacao = payload.propriedade.notificaInteressadoTramitacao;
      }
      if (typeof payload.propriedade.integrado !== 'undefined') {
        o.integrado = payload.propriedade.integrado;
      }
      if (typeof payload.propriedade.urlDocumentacao !== 'undefined') {
        o.urlDocumentacao = payload.propriedade.urlDocumentacao;
      }
      if (typeof payload.propriedade.consideradoProcessoNaAnexacao !== 'undefined') {
        o.consideradoProcessoNaAnexacao = payload.propriedade.consideradoProcessoNaAnexacao;
      }
    }
  });
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaTiposDocumentais: [],
  idTipoSelecionado: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaItensGlossario: function listaItensGlossario(state) {
    return state.listaItensGlossario;
  },
  dialogEdicao: function dialogEdicao(state) {
    return state.dialogEdicao;
  },
  listaTiposDocumento: function listaTiposDocumento(state) {
    return state.listaTiposDocumento;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_administracao_state_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_getters_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_actions_js__ = __webpack_require__(251);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_administracao_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_administracao_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_administracao_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__ = __webpack_require__(64);



var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__["a" /* default */].ABRIR_DIALOG_EDICAO, function (state) {
  state.dialogEdicao = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__["a" /* default */].FECHAR_DIALOG_EDICAO, function (state) {
  state.dialogEdicao = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__["a" /* default */].SET_LISTA_ITENS_GLOSSARIO, function (state, payload) {
  state.listaItensGlossario = payload.listaItensGlossario;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__["a" /* default */].CRIAR_ITEM_GLOSSARIO, function (state, payload) {
  state.listaItensGlossario.push(payload.itemGlossario);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__["a" /* default */].EDITAR_ITEM_GLOSSARIO, function (state, payload) {
  var listaIds = state.listaItensGlossario.map(function (item) {
    return item.idItemGlossario;
  });
  var index = listaIds.indexOf(payload.itemGlossario.idItemGlossario);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.listaItensGlossario[index], payload.itemGlossario);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__["a" /* default */].EXCLUIR_ITEM_GLOSSARIO, function (state, payload) {
  state.listaItensGlossario.splice(state.listaItensGlossario.indexOf(payload.itemGlossario), 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_administracao_mutations_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTO, function (state, payload) {
  state.listaTiposDocumento = payload.listaTiposDocumento;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaItensGlossario: [],
  dialogEdicao: false,
  listaTiposDocumento: []
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types_js__ = __webpack_require__(65);



var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types_js__["a" /* default */], {
  BUSCAR_ARQUIVOS_ASSINADOS: 'BUSCAR_ARQUIVOS_ASSINADOS',
  EXCLUIR_ARQUIVO_ASSINADO: 'EXCLUIR_ARQUIVO_ASSINADO',
  EXCLUIR_ARQUIVO_ASSINADO_EM_BLOCO: 'EXCLUIR_ARQUIVO_ASSINADO_EM_BLOCO',
  BUSCAR_TIPOS_ASSINATURA: 'BUSCAR_TIPOS_ASSINATURA',
  INSERIR_ARQUIVO_ASSINADO: 'INSERIR_ARQUIVO_ASSINADO',
  GET_ARQUIVO_ASSINADO_BLOB_URL: 'GET_ARQUIVO_ASSINADO_BLOB_URL',
  SET_ARQUIVO_ASSINADO_BLOB_URL: 'SET_ARQUIVO_ASSINADO_BLOB_URL',
  SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG',
  HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG: 'HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_documentos__ = __webpack_require__(8);








var _this = this,
    _actions;




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS, function (_ref, payload) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_TIPOS_ASSINATURA, function (_ref2, payload) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_TIPOS_ASSINATURA, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].BUSCAR_ARQUIVOS_ASSINADOS, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(_ref4, payload) {
    var commit = _ref4.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, { root: true });
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].buscarArquivosAssinadosVinculados(payload.vinculados, payload.usuarioAssinante, payload.dataAssinaturaInicio, payload.dataAssinaturaFim, payload.arquivosAssinadosUsuario);

          case 4:
            response = _context.sent;

            if (response.data.length === 50) {
              commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, {
                snackbarType: 'warning',
                snackbarText: 'Limite de busca de 50 arquivos atingido. Favor filtrar melhor a busca caso o arquivo buscado não estiver nos resultados'
              }, { root: true });
            }
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS, { listaArquivosAssinados: response.data });
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os arquivos assinados' }, { root: true });
            throw _context.t0;

          case 13:
            _context.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, { root: true });
            return _context.finish(13);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 9, 13, 16]]);
  }));

  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].BUSCAR_TIPOS_ASSINATURA, function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(_ref6) {
    var commit = _ref6.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Tipos de Assinatura' }, { root: true });
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].buscarTiposAssinatura();

          case 4:
            response = _context2.sent;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_TIPOS_ASSINATURA, { listaTiposAssinatura: response.data });
            _context2.next = 12;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os tipos de assinatura' }, { root: true });
            throw _context2.t0;

          case 12:
            _context2.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Tipos de Assinatura' }, { root: true });
            return _context2.finish(12);

          case 15:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[0, 8, 12, 15]]);
  }));

  return function (_x3) {
    return _ref5.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].GET_ARQUIVO_ASSINADO_BLOB_URL, function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, payload) {
    var commit = _ref8.commit;
    var response, blob, blobURL;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando arquivo' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_ARQUIVO_ASSINADO_BLOB_URL, { arquivoAssinadoBlobURL: null });
            _context3.prev = 2;
            _context3.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].buscarArquivoAssinado(payload.idArquivoAssinado, payload.tipoArquivo);

          case 5:
            response = _context3.sent;
            blob = new Blob([response.body], { type: 'application/pdf' });
            blobURL = (window.URL || window.webkitURL).createObjectURL(blob);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_ARQUIVO_ASSINADO_BLOB_URL, { arquivoAssinadoBlobURL: blobURL });
            _context3.next = 15;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3['catch'](2);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível abrir o arquivo' }, { root: true });
            throw _context3.t0;

          case 15:
            _context3.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Abrindo arquivo' }, { root: true });
            return _context3.finish(15);

          case 18:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[2, 11, 15, 18]]);
  }));

  return function (_x4, _x5) {
    return _ref7.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].EXCLUIR_ARQUIVO_ASSINADO, function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10, payload) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    var confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            confirmacaoCallback = function () {
              var _ref11 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.prev = 0;

                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo arquivo assinado ' + payload.arquivoAssinado.nomeOriginal }, { root: true });
                        _context4.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].excluirArquivoAssinado(payload.arquivoAssinado.idArquivoAssinado);

                      case 4:
                        payload.listaArquivosAssinados.splice(payload.listaArquivosAssinados.findIndex(function (i) {
                          return i.idArquivoAssinado === payload.arquivoAssinado.idArquivoAssinado;
                        }), 1);
                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS, { listaArquivosAssinados: payload.listaArquivosAssinados });
                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: payload.arquivoAssinado.nomeOriginal + ' exclu\xEDdo com sucesso' }, { root: true });
                        return _context4.abrupt('return', true);

                      case 10:
                        _context4.prev = 10;
                        _context4.t0 = _context4['catch'](0);

                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'N\xE3o foi poss\xEDvel excluir ' + payload.arquivoAssinado.nomeOriginal }, { root: true });
                        return _context4.abrupt('return', false);

                      case 14:
                        _context4.prev = 14;

                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo arquivo assinado ' + payload.arquivoAssinado.nomeOriginal }, { root: true });
                        return _context4.finish(14);

                      case 17:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this, [[0, 10, 14, 17]]);
              }));

              return function confirmacaoCallback() {
                return _ref11.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Excluir o arquivo assinado?',
              textoConteudo: 'O arquivo assinado "' + payload.arquivoAssinado.nomeOriginal + '" ser\xE1 exclu\xEDdo da lista de arquivos assinados.',
              textoNao: 'Cancelar',
              textoSim: 'Excluir',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x6, _x7) {
    return _ref9.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].EXCLUIR_ARQUIVO_ASSINADO_EM_BLOCO, function (_ref12, payload) {
  var _this2 = this;

  var commit = _ref12.commit,
      dispatch = _ref12.dispatch;
  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var confirmacaoCallback = function () {
                var _ref13 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
                  var _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, arquivo, _ret;

                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo arquivos assinados' }, { root: true });
                          _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _loop(arquivo) {
                            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _loop$(_context6) {
                              while (1) {
                                switch (_context6.prev = _context6.next) {
                                  case 0:
                                    _context6.prev = 0;
                                    _context6.next = 3;
                                    return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].excluirArquivoAssinado(arquivo.idArquivoAssinado);

                                  case 3:
                                    payload.listaArquivosAssinados.splice(payload.listaArquivosAssinados.findIndex(function (i) {
                                      return i.idArquivoAssinado === arquivo.idArquivoAssinado;
                                    }), 1);
                                    _context6.next = 12;
                                    break;

                                  case 6:
                                    _context6.prev = 6;
                                    _context6.t0 = _context6['catch'](0);

                                    commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, {
                                      snackbarType: 'error',
                                      snackbarText: 'N\xE3o foi poss\xEDvel excluir ' + arquivo.nomeOriginal + '. Erro: ' + _context6.t0.body.message
                                    }, { root: true });
                                    commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo arquivos assinados' }, { root: true });
                                    reject(_context6.t0.body.message);
                                    return _context6.abrupt('return', {
                                      v: void 0
                                    });

                                  case 12:
                                  case 'end':
                                    return _context6.stop();
                                }
                              }
                            }, _loop, _this2, [[0, 6]]);
                          });
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _iteratorError = undefined;
                          _context7.prev = 5;
                          _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(payload.listaArquivosSelecionados);

                        case 7:
                          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _context7.next = 16;
                            break;
                          }

                          arquivo = _step.value;
                          return _context7.delegateYield(_loop(arquivo), 't0', 10);

                        case 10:
                          _ret = _context7.t0;

                          if (!((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret)) === "object")) {
                            _context7.next = 13;
                            break;
                          }

                          return _context7.abrupt('return', _ret.v);

                        case 13:
                          _iteratorNormalCompletion = true;
                          _context7.next = 7;
                          break;

                        case 16:
                          _context7.next = 22;
                          break;

                        case 18:
                          _context7.prev = 18;
                          _context7.t1 = _context7['catch'](5);
                          _didIteratorError = true;
                          _iteratorError = _context7.t1;

                        case 22:
                          _context7.prev = 22;
                          _context7.prev = 23;

                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }

                        case 25:
                          _context7.prev = 25;

                          if (!_didIteratorError) {
                            _context7.next = 28;
                            break;
                          }

                          throw _iteratorError;

                        case 28:
                          return _context7.finish(25);

                        case 29:
                          return _context7.finish(22);

                        case 30:
                          commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo arquivos assinados' }, { root: true });
                          commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS, { listaArquivosAssinados: payload.listaArquivosAssinados });
                          commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, {
                            snackbarType: 'success',
                            snackbarText: 'Arquivos selecionados exclu\xEDdos com sucesso'
                          }, { root: true });
                          resolve(true);
                          return _context7.abrupt('return');

                        case 35:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _callee6, _this2, [[5, 18, 22, 30], [23,, 25, 29]]);
                }));

                return function confirmacaoCallback() {
                  return _ref13.apply(this, arguments);
                };
              }();
              var config = {
                textoPergunta: 'Excluir os arquivos assinados selecionados?',
                textoConteudo: 'Os arquivo assinados selecionados ser\xE3o exclu\xEDdos da lista de arquivos assinados.',
                textoNao: 'Cancelar',
                textoSim: 'Excluir',
                confirmacaoCallback: confirmacaoCallback
              };
              commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, config), { root: true });
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee7, _this2);
  }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].INSERIR_ARQUIVO_ASSINADO, function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8(_ref15, payload) {
    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Assinando arquivo ' + payload.body.get('arquivo').name }, { root: true });
            _context9.prev = 1;
            _context9.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].inserirArquivoAssinado(payload.body, payload.idTipoAssinatura, payload.tipoAssinatura, payload.matrSiape);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Arquivo ' + payload.body.get('arquivo').name + ' assinado com sucesso' }, { root: true });
            _context9.next = 11;
            break;

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Arquivo ' + payload.body.get('arquivo').name + ' n\xE3o assinado: ' + _context9.t0.body.message }, { root: true });
            throw _context9.t0;

          case 11:
            _context9.prev = 11;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Assinando arquivo ' + payload.body.get('arquivo').name }, { root: true });
            return _context9.finish(11);

          case 14:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee8, _this, [[1, 7, 11, 14]]);
  }));

  return function (_x8, _x9) {
    return _ref14.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG, function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9(_ref17) {
    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG);

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee9, _this);
  }));

  return function (_x10) {
    return _ref16.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG, function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10(_ref19) {
    var commit = _ref19.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_arquivos_assinados_actions_types__["a" /* default */].HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG);

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function (_x11) {
    return _ref18.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaArquivosAssinados: function listaArquivosAssinados(state) {
    return state.listaArquivosAssinados;
  },
  arquivoAssinadoBlobURL: function arquivoAssinadoBlobURL(state) {
    return state.arquivoAssinadoBlobURL;
  },
  arquivoAssinadoInsercaoDialog: function arquivoAssinadoInsercaoDialog(state) {
    return state.arquivoAssinadoInsercaoDialog;
  },
  listaTiposAssinatura: function listaTiposAssinatura(state) {
    return state.listaTiposAssinatura;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_arquivos_assinados_state_js__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_getters_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_assinados_mutations_js__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_arquivos_assinados_actions_js__ = __webpack_require__(263);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_arquivos_assinados_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_assinados_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_arquivos_assinados_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types__ = __webpack_require__(65);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS, function (state, payload) {
  state.listaArquivosAssinados = payload.listaArquivosAssinados;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types__["a" /* default */].SET_ARQUIVO_ASSINADO_BLOB_URL, function (state, payload) {
  state.arquivoAssinadoBlobURL = payload.arquivoAssinadoBlobURL;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types__["a" /* default */].SET_LISTA_TIPOS_ASSINATURA, function (state, payload) {
  state.listaTiposAssinatura = payload.listaTiposAssinatura;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types__["a" /* default */].SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG, function (state) {
  state.arquivoAssinadoInsercaoDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_assinados_mutations_types__["a" /* default */].HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG, function (state) {
  state.arquivoAssinadoInsercaoDialog = false;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaArquivosAssinados: [],
  arquivoAssinadoBlobURL: null,
  arquivoAssinadoInsercaoDialog: false,
  listaTiposAssinatura: []
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_documento_mutations_types_js__ = __webpack_require__(66);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_documento_mutations_types_js__["a" /* default */], {
  GET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO: 'GET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO',
  GET_LISTA_PECAS: 'GET_LISTA_PECAS',
  VALIDAR_RESTRICOES_ARQUIVO: 'VALIDAR_RESTRICOES_ARQUIVO',
  VALIDAR_TAMANHO_ARQUIVO: 'VALIDAR_TAMANHO_ARQUIVO',
  GET_ARQUIVO: 'GET_ARQUIVO',
  GET_ARQUIVO_BLOB_URL: 'GET_ARQUIVO_BLOB_URL',
  SET_ARQUIVO: 'SET_ARQUIVO',
  EXCLUIR_ARQUIVO: 'EXCLUIR_ARQUIVO',
  ENVIAR_ARQUIVO: 'ENVIAR_ARQUIVO',
  ENVIAR_ARQUIVO_ASSINADO: 'ENVIAR_ARQUIVO_ASSINADO',
  SALVAR_EDICAO_ARQUIVO: 'SALVAR_EDICAO_ARQUIVO',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  CANCELAR_PECA: 'CANCELAR_PECA',
  GET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS: 'GET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS',
  SHOW_EDICAO_ARQUIVO_DIALOG: 'SHOW_EDICAO_ARQUIVO_DIALOG',
  HIDE_EDICAO_ARQUIVO_DIALOG: 'HIDE_EDICAO_ARQUIVO_DIALOG',
  SHOW_CANCELAMENTO_PECA_DIALOG: 'SHOW_CANCELAMENTO_PECA_DIALOG',
  HIDE_EXCLUSAO_ARQUIVO_DIALOG: 'HIDE_EXCLUSAO_ARQUIVO_DIALOG',
  SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  ATUALIZAR_SEQUENCIAL_PECA: 'ATUALIZAR_SEQUENCIAL_PECA'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dates__ = __webpack_require__(29);







var _this = this,
    _actions;





var CINCO_MEBIBYTES = 5242880;
var TEXTO_SUGESTAO_OTIMIZADOR_PDF = '\nFavor consultar link ao lado do botão "Adicionar Arquivos" para maiores informações.';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].GET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando upload de arquivo' }, { root: true });
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].getMotivosRestricoesArquivo();

          case 4:
            response = _context.sent;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO, { listaMotivosRestricoesArquivo: response.data });
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de motivos de restrições de arquivos' }, { root: true });
            throw _context.t0;

          case 12:
            _context.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando upload de arquivo' }, { root: true });
            return _context.finish(12);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].GET_LISTA_PECAS, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
    var commit = _ref4.commit;

    var response, items, documentoPertenceAoUsuario, usuarioLogadoEhOInteressado, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, formato;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando peças' }, { root: true });
            _context2.prev = 1;
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].getListaPecas(payload.documento.idDocumento);

          case 4:
            response = _context2.sent;
            items = response.data;
            documentoPertenceAoUsuario = payload.usuario && (payload.presenteCaixaPostal || payload.raizPresenteCaixaPostal) && (payload.documento.situacao === 'RECEBIDO' || payload.documento.situacao === 'EM_CRIACAO');
            usuarioLogadoEhOInteressado = payload.usuario && payload.documento && payload.documento.idPessoaInteressado === payload.usuario.idPessoa;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context2.prev = 11;


            for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              item = _step.value;

              item.dias = __WEBPACK_IMPORTED_MODULE_8__utils_dates__["a" /* default */].daysDiff(item.dataDespacho, item.dataRecebimento);
              if (item.situacaoVinculo === 'M') {
                item.restrito = !(payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS'));
                item.tipoArquivo = item.descricao = item.passoFluxo = payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS') ? item.passoFluxo.concat(' (DESMEMBRADA)') : 'DESMEMBRADA';
              } else if (item.situacaoVinculo === 'D') {
                item.restrito = !(payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS'));
                item.tipoArquivo = item.descricao = item.passoFluxo = payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS') ? item.passoFluxo.concat(' (DESENTRANHADA)') : 'DESENTRANHADA';
              } else if (item.nivelAcesso === 'R' && !documentoPertenceAoUsuario && !(usuarioLogadoEhOInteressado && (item.sequenciaTramitacao === 1 || payload.documento.estado[2001] === 2 || payload.documento.estado[2001] === 3))) {
                item.restrito = !(payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS'));
                item.tipoArquivo = item.descricao = item.passoFluxo = payload.usuario && payload.usuario.permissoes.includes('VISUALIZACAO_IRRESTRITA_PECAS') ? item.passoFluxo.concat(' (RESTRITO)') : 'RESTRITO - Motivo: ' + item.descricaoHipoteseLegal;
              } else {
                item.restrito = false;
                if (item.idAnexo) {
                  formato = item.nome.split('.').pop();

                  if (formato === 'jpg') item.tipoArquivo = 'Imagem JPG';
                  if (formato === 'png') item.tipoArquivo = 'Imagem PNG';
                  if (formato === 'bmp') item.tipoArquivo = 'Imagem BMP';
                  if (formato === 'gif') item.tipoArquivo = 'Imagem GIF';
                  if (formato === 'mp3') item.tipoArquivo = 'Áudio MP3';
                  if (formato === 'mp4') item.tipoArquivo = 'Vídeo MP4';
                  if (formato === 'pdf') item.tipoArquivo = 'Documento PDF';
                  if (formato === 'zip') item.tipoArquivo = 'Arquivo compactado ZIP';
                } else {
                  item.tipoArquivo = 'Despacho';
                }
              }
            }
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2['catch'](11);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 19:
            _context2.prev = 19;
            _context2.prev = 20;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 22:
            _context2.prev = 22;

            if (!_didIteratorError) {
              _context2.next = 25;
              break;
            }

            throw _iteratorError;

          case 25:
            return _context2.finish(22);

          case 26:
            return _context2.finish(19);

          case 27:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_PECAS, { listaPecas: items });
            _context2.next = 34;
            break;

          case 30:
            _context2.prev = 30;
            _context2.t1 = _context2['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as peças do documento' }, { root: true });
            throw _context2.t1;

          case 34:
            _context2.prev = 34;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando peças' }, { root: true });
            return _context2.finish(34);

          case 37:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 30, 34, 37], [11, 15, 19, 27], [20,, 22, 26]]);
  }));

  return function (_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS, function (_ref5, payload) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].GET_ARQUIVO, function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3(_ref7, payload) {
    var commit = _ref7.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando arquivo' }, { root: true });
            _context3.prev = 1;
            _context3.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].getArquivo(payload.idDocumento, payload.idArquivo);

          case 4:
            response = _context3.sent;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_ARQUIVO, { arquivo: response.data });
            _context3.next = 12;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar o arquivo' }, { root: true });
            throw _context3.t0;

          case 12:
            _context3.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando arquivo' }, { root: true });
            return _context3.finish(12);

          case 15:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_ARQUIVO, function (_ref8, payload) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_ARQUIVO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_SITUACAO_VINCULO, function (_ref9, payload) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_SITUACAO_VINCULO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_PASSO_ATUAL, function (_ref10, payload) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_PASSO_ATUAL, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].GET_ARQUIVO_BLOB_URL, function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4(_ref12, payload) {
    var commit = _ref12.commit;
    var response, type, formato, blob, blobURL;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando arquivo' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_ARQUIVO_BLOB_URL, { arquivoBlobURL: null });
            _context4.prev = 2;
            _context4.next = 5;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].getArquivoBinario(payload.idDocumento, payload.arquivo.idAcessoAnexo);

          case 5:
            response = _context4.sent;
            type = '';
            // Quando for despacho, que não tem nome, já é do tipo PDF

            if (payload.arquivo.nome === null) {
              payload.arquivo.nome = 'despacho.pdf';
              type = 'application/pdf';
            } else {
              formato = payload.arquivo.nome.split('.').pop();

              if (formato === 'jpg') type = 'image/jpg';else if (formato === 'png') type = 'image/png';else if (formato === 'bmp') type = 'image/bmp';else if (formato === 'gif') type = 'image/gif';else if (formato === 'mp3') type = 'audio/mp3';else if (formato === 'mp4') type = 'video/mp4';else if (formato === 'pdf') type = 'application/pdf';
            }
            blob = new Blob([response.body], { type: type });
            blobURL = (window.URL || window.webkitURL).createObjectURL(blob);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_ARQUIVO_BLOB_URL, { arquivoBlobURL: blobURL });
            _context4.next = 17;
            break;

          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4['catch'](2);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível abrir o arquivo' }, { root: true });
            throw _context4.t0;

          case 17:
            _context4.prev = 17;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Abrindo arquivo' }, { root: true });
            return _context4.finish(17);

          case 20:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[2, 13, 17, 20]]);
  }));

  return function (_x6, _x7) {
    return _ref11.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].VALIDAR_RESTRICOES_ARQUIVO, function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5(_ref14, payload) {
    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!payload.arquivo.tipoCopia || !payload.arquivo.nivelAcesso || payload.arquivo.nivelAcesso && payload.arquivo.nivelAcesso.id === 'R' && !payload.arquivo.motivoRestricao)) {
              _context5.next = 3;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'H\xE1 campos n\xE3o definidos para o arquivo "' + payload.arquivo.nome + '"' }, { root: true });
            return _context5.abrupt('return', false);

          case 3:
            return _context5.abrupt('return', true);

          case 4:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x8, _x9) {
    return _ref13.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].VALIDAR_TAMANHO_ARQUIVO, function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6(_ref16, payload) {
    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(payload.documento !== null)) {
              _context6.next = 12;
              break;
            }

            if (!(payload.documento.estado['32005'] === 2)) {
              _context6.next = 7;
              break;
            }

            if (!(payload.arquivo.size > CINCO_MEBIBYTES * 10)) {
              _context6.next = 5;
              break;
            }

            // 50 MiB
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, {
              snackbarType: 'error',
              snackbarText: 'Arquivos maiores que 50 MebiBytes (aproximadamente 50,42 MegaBytes) não podem ser adicionados a documentos nesta fase.' + TEXTO_SUGESTAO_OTIMIZADOR_PDF
            }, { root: true });
            return _context6.abrupt('return', false);

          case 5:
            _context6.next = 10;
            break;

          case 7:
            if (!(payload.arquivo.size > CINCO_MEBIBYTES)) {
              _context6.next = 10;
              break;
            }

            // 5 MiB
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, {
              snackbarType: 'error',
              snackbarText: 'Arquivos maiores que 5 MebiBytes (aproximadamente 5,24 MegaBytes) não podem ser adicionados a documentos nesta fase.' + TEXTO_SUGESTAO_OTIMIZADOR_PDF
            }, { root: true });
            return _context6.abrupt('return', false);

          case 10:
            _context6.next = 15;
            break;

          case 12:
            if (!(payload.arquivo.size > CINCO_MEBIBYTES * 10)) {
              _context6.next = 15;
              break;
            }

            // 50 MiB
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, {
              snackbarType: 'error',
              snackbarText: 'Arquivos maiores que 50 MebiBytes (aproximadamente 50,42 MegaBytes) não podem ser adicionados para serem assinados.' + TEXTO_SUGESTAO_OTIMIZADOR_PDF
            }, { root: true });
            return _context6.abrupt('return', false);

          case 15:
            return _context6.abrupt('return', true);

          case 16:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function (_x10, _x11) {
    return _ref15.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].ENVIAR_ARQUIVO, function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7(_ref18, payload) {
    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando ' + payload.body.get('arquivo').name }, { root: true });
            _context7.prev = 1;
            _context7.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].enviarArquivo(payload.idDocumento, payload.body);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Arquivo ' + payload.body.get('arquivo').name + ' enviado com sucesso' }, { root: true });
            _context7.next = 11;
            break;

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Arquivo ' + payload.body.get('arquivo').name + ' n\xE3o enviado: ' + _context7.t0.body.message }, { root: true });
            throw _context7.t0;

          case 11:
            _context7.prev = 11;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando ' + payload.body.get('arquivo').name }, { root: true });
            return _context7.finish(11);

          case 14:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this, [[1, 7, 11, 14]]);
  }));

  return function (_x12, _x13) {
    return _ref17.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].ENVIAR_ARQUIVO_ASSINADO, function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8(_ref20, payload) {
    var commit = _ref20.commit;
    var nomeArquivo;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            nomeArquivo = payload.body.get('arquivo').name;

            if (nomeArquivo === undefined) nomeArquivo = payload.body.get('arquivo');
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando ' + nomeArquivo }, { root: true });
            _context8.prev = 3;
            _context8.next = 6;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].enviarArquivoAssinado(payload.idArquivoAssinado, payload.idDocumento, payload.body);

          case 6:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Arquivo ' + nomeArquivo + ' enviado com sucesso' }, { root: true });
            _context8.next = 13;
            break;

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8['catch'](3);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Arquivo ' + nomeArquivo + ' n\xE3o enviado: ' + _context8.t0.body.message }, { root: true });
            throw _context8.t0;

          case 13:
            _context8.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando ' + nomeArquivo }, { root: true });
            return _context8.finish(13);

          case 16:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this, [[3, 9, 13, 16]]);
  }));

  return function (_x14, _x15) {
    return _ref19.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SALVAR_EDICAO_ARQUIVO, function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10(_ref22, payload) {
    var commit = _ref22.commit;
    var textoNomeArquivo, confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            textoNomeArquivo = payload.arquivoSelecionado.nome ? payload.arquivoSelecionado.nome : 'Despacho - Sequencial ' + payload.arquivoSelecionado.sequencial;

            confirmacaoCallback = function () {
              var _ref23 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var item;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.prev = 0;

                        commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando alterações em ' + textoNomeArquivo }, { root: true });
                        _context9.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].salvarAlteracoesArquivo(payload.idDocumento, payload.arquivoSelecionado.idAcessoAnexo, payload.arquivoSelecionado.idAnexo, payload.arquivoEditado);

                      case 4:
                        item = payload.arquivoSelecionado;

                        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(item, {
                          tipoCopia: payload.arquivoEditado.tipoCopia,
                          nivelAcesso: payload.arquivoEditado.nivelAcesso,
                          idHipoteseLegal: payload.arquivoEditado.idHipoteseLegal,
                          descricao: payload.arquivoEditado.descricao
                        });
                        commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].ALTERAR_PECA_LISTA, { arquivoSelecionadoIndex: payload.arquivoSelecionadoIndex, arquivo: item });
                        commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_EDICAO_ARQUIVO_DIALOG);
                        commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Arquivo ' + textoNomeArquivo + ' alterado com sucesso' }, { root: true });
                        _context9.next = 15;
                        break;

                      case 11:
                        _context9.prev = 11;
                        _context9.t0 = _context9['catch'](0);

                        commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível alterar o arquivo ' + textoNomeArquivo }, { root: true });
                        throw _context9.t0;

                      case 15:
                        _context9.prev = 15;

                        commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando alterações em ' + textoNomeArquivo }, { root: true });
                        return _context9.finish(15);

                      case 18:
                      case 'end':
                        return _context9.stop();
                    }
                  }
                }, _callee9, _this, [[0, 11, 15, 18]]);
              }));

              return function confirmacaoCallback() {
                return _ref23.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Alterar o arquivo?',
              textoConteudo: textoNomeArquivo + ' será alterado conforme especificado.',
              textoNao: 'Cancelar',
              textoSim: 'Alterar',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 4:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function (_x16, _x17) {
    return _ref21.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].EXCLUIR_ARQUIVO, function (_ref24, payload) {
  var commit = _ref24.commit;

  var confirmacaoCallback = function () {
    var _ref25 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;

              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo arquivo ' + payload.arquivoSelecionado.nome }, { root: true });
              _context11.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].excluirArquivo(payload.idDocumento, payload.arquivoSelecionado.idAnexo);

            case 4:
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].REMOVER_ARQUIVO_LISTA, { arquivoSelecionadoIndex: payload.arquivoSelecionadoIndex, arquivoSelecionado: payload.arquivoSelecionado });
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: '"' + payload.arquivoSelecionado.nome + '" exclu\xEDdo com sucesso' }, { root: true });
              _context11.next = 12;
              break;

            case 8:
              _context11.prev = 8;
              _context11.t0 = _context11['catch'](0);

              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'N\xE3o foi poss\xEDvel excluir "' + payload.arquivoSelecionado.nome + '"' }, { root: true });
              throw _context11.t0;

            case 12:
              _context11.prev = 12;

              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo arquivo ' + payload.arquivoSelecionado.nome }, { root: true });
              return _context11.finish(12);

            case 15:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this, [[0, 8, 12, 15]]);
    }));

    return function confirmacaoCallback() {
      return _ref25.apply(this, arguments);
    };
  }();
  var config = {
    textoPergunta: 'Excluir o arquivo?',
    textoConteudo: 'O arquivo "' + payload.arquivoSelecionado.nome + '" ser\xE1 exclu\xEDda deste documento permanentemente.',
    textoNao: 'Cancelar',
    textoSim: 'Excluir',
    confirmacaoCallback: confirmacaoCallback
  };
  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].CANCELAR_PECA, function (_ref26, payload) {
  var commit = _ref26.commit;

  var confirmacaoCallback = function () {
    var _ref27 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var item;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;

              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Cancelando ' + (payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho') }, { root: true });
              _context12.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].cancelarPeca(payload.idDocumento, payload.arquivoSelecionado.idAcessoAnexo, payload.situacaoVinculo.tipo, payload.justificativaCancelamento, payload.documentoSelecionado.idDocumento);

            case 4:
              item = payload.arquivoSelecionado;

              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(item, {
                situacaoVinculo: payload.situacaoVinculo.tipo,
                justificativaCancelamento: payload.justificativaCancelamento,
                tipoArquivo: payload.situacaoVinculo.tipo === 'M' ? 'DESMEMBRADA' : 'DESENTRANHADA',
                descricao: payload.situacaoVinculo.tipo === 'M' ? 'DESMEMBRADA' : 'DESENTRANHADA',
                passoFluxo: payload.situacaoVinculo.tipo === 'M' ? 'DESMEMBRADA' : 'DESENTRANHADA'
              });
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].ALTERAR_PECA_LISTA, { arquivoSelecionadoIndex: payload.arquivoSelecionadoIndex, arquivo: item });
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_EXCLUSAO_ARQUIVO_DIALOG);
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: (payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho') + ' cancelado com sucesso' }, { root: true });
              _context12.next = 15;
              break;

            case 11:
              _context12.prev = 11;
              _context12.t0 = _context12['catch'](0);

              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'N\xE3o foi poss\xEDvel cancelar o ' + (payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho') }, { root: true });
              throw _context12.t0;

            case 15:
              _context12.prev = 15;

              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Cancelando ' + (payload.arquivoSelecionado.nome ? ' arquivo: ' + payload.arquivoSelecionado.nome : 'despacho') }, { root: true });
              return _context12.finish(15);

            case 18:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this, [[0, 11, 15, 18]]);
    }));

    return function confirmacaoCallback() {
      return _ref27.apply(this, arguments);
    };
  }();
  var config = {
    textoPergunta: (payload.situacaoVinculo.tipo === 'M' ? 'Desmembrar' : 'Desentranhar') + ' a pe\xE7a?',
    textoConteudo: 'A pe\xE7a "' + payload.arquivoSelecionado.nome + '" ser\xE1 ' + (payload.situacaoVinculo.tipo === 'M' ? 'desmembrada' : 'desentranhada') + ' permanentemente.',
    textoNao: 'Cancelar',
    textoSim: '' + (payload.situacaoVinculo.tipo === 'M' ? 'Desmembrar' : 'Desentranhar'),
    confirmacaoCallback: confirmacaoCallback
  };
  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].GET_LISTA_DOCUMENTOS, function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13(_ref29, payload) {
    var commit = _ref29.commit;
    var response, listaDocumentos;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: {} });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: [] });
            _context13.next = 6;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].getListaDocumentosParaJuntada(payload.numeroDocumento);

          case 6:
            response = _context13.sent;
            listaDocumentos = response.data.filter(function (documento) {
              return documento.idDestino === payload.idUnidadeAtual && documento.estado['2001'] === 1 && documento.dataValidade !== null && documento.situacao !== 'E';
            });

            if (listaDocumentos.length === 0) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Nenhum documento encontrado. Documentos que não constam em sua caixa postal, de setores diferentes, arquivados, não recebidos ou ainda em criação não podem ter suas peças alteradas' }, { root: true });
            } else {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: listaDocumentos });
            }
            _context13.next = 15;
            break;

          case 11:
            _context13.prev = 11;
            _context13.t0 = _context13['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, { root: true });
            throw _context13.t0;

          case 15:
            _context13.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, { root: true });
            return _context13.finish(15);

          case 18:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this, [[0, 11, 15, 18]]);
  }));

  return function (_x18, _x19) {
    return _ref28.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].GET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS, function () {
  var _ref30 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14(_ref31, payload) {
    var commit = _ref31.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, { root: true });
            _context14.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].buscarArquivosAssinadosVinculados(payload.vinculados, payload.usuarioAssinante, payload.dataAssinaturaInicio, payload.dataAssinaturaFim, payload.arquivosAssinadosUsuario);

          case 4:
            response = _context14.sent;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS, { listaArquivosAssinadosNaoVinculados: response.data });
            if (response.data.length === 50) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'warning', snackbarText: 'Limite de busca de 50 arquivos atingido. Favor filtrar melhor a busca caso o arquivo buscado não estiver nos resultados' }, { root: true });
            }
            _context14.next = 13;
            break;

          case 9:
            _context14.prev = 9;
            _context14.t0 = _context14['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os arquivos assinados' }, { root: true });
            throw _context14.t0;

          case 13:
            _context14.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, { root: true });
            return _context14.finish(13);

          case 16:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this, [[0, 9, 13, 16]]);
  }));

  return function (_x20, _x21) {
    return _ref30.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function () {
  var _ref32 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15(_ref33, payload) {
    var commit = _ref33.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, payload);

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, _this);
  }));

  return function (_x22, _x23) {
    return _ref32.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, function () {
  var _ref34 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16(_ref35, payload) {
    var commit = _ref35.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, payload);

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, _this);
  }));

  return function (_x24, _x25) {
    return _ref34.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_JUSTIFICATIVA_CANCELAMENTO, function () {
  var _ref36 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17(_ref37, payload) {
    var commit = _ref37.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_JUSTIFICATIVA_CANCELAMENTO, payload);

          case 1:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, _this);
  }));

  return function (_x26, _x27) {
    return _ref36.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS, function () {
  var _ref38 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18(_ref39, payload) {
    var commit = _ref39.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS, payload);

          case 1:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, _this);
  }));

  return function (_x28, _x29) {
    return _ref38.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_EDICAO_ARQUIVO_DIALOG, function () {
  var _ref40 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19(_ref41) {
    var commit = _ref41.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_EDICAO_ARQUIVO_DIALOG);

          case 1:
          case 'end':
            return _context19.stop();
        }
      }
    }, _callee19, _this);
  }));

  return function (_x30) {
    return _ref40.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_EDICAO_ARQUIVO_DIALOG, function () {
  var _ref42 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee20(_ref43) {
    var commit = _ref43.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_EDICAO_ARQUIVO_DIALOG);

          case 1:
          case 'end':
            return _context20.stop();
        }
      }
    }, _callee20, _this);
  }));

  return function (_x31) {
    return _ref42.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_CANCELAMENTO_PECA_DIALOG, function () {
  var _ref44 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee21(_ref45) {
    var commit = _ref45.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_CANCELAMENTO_PECA_DIALOG);

          case 1:
          case 'end':
            return _context21.stop();
        }
      }
    }, _callee21, _this);
  }));

  return function (_x32) {
    return _ref44.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_EXCLUSAO_ARQUIVO_DIALOG, function () {
  var _ref46 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee22(_ref47) {
    var commit = _ref47.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_EXCLUSAO_ARQUIVO_DIALOG);

          case 1:
          case 'end':
            return _context22.stop();
        }
      }
    }, _callee22, _this);
  }));

  return function (_x33) {
    return _ref46.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG, function () {
  var _ref48 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee23(_ref49) {
    var commit = _ref49.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG);

          case 1:
          case 'end':
            return _context23.stop();
        }
      }
    }, _callee23, _this);
  }));

  return function (_x34) {
    return _ref48.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG, function () {
  var _ref50 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee24(_ref51) {
    var commit = _ref51.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG);

          case 1:
          case 'end':
            return _context24.stop();
        }
      }
    }, _callee24, _this);
  }));

  return function (_x35) {
    return _ref50.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG, function () {
  var _ref52 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee25(_ref53) {
    var commit = _ref53.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG);

          case 1:
          case 'end':
            return _context25.stop();
        }
      }
    }, _callee25, _this);
  }));

  return function (_x36) {
    return _ref52.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG, function () {
  var _ref54 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee26(_ref55) {
    var commit = _ref55.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG);

          case 1:
          case 'end':
            return _context26.stop();
        }
      }
    }, _callee26, _this);
  }));

  return function (_x37) {
    return _ref54.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].ATUALIZAR_SEQUENCIAL_PECA, function () {
  var _ref56 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee27(_ref57, payload) {
    var commit = _ref57.commit;
    var pecas, maiorSequencial, menorSequencial, novoSequencial, sequencialAntigo, idPeca;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Atualizando Sequencial' }, { root: true });
            pecas = payload.pecas;
            maiorSequencial = Math.max.apply(Math, pecas.filter(function (p) {
              return p.situacaoTramitacao === 'T';
            }).map(function (o) {
              return o.sequencial;
            }));
            menorSequencial = Math.min.apply(Math, pecas.filter(function (p) {
              return p.situacaoTramitacao === 'T';
            }).map(function (o) {
              return o.sequencial;
            }));
            novoSequencial = payload.novoSequencial;
            sequencialAntigo = payload.sequencialAntigo;


            novoSequencial = novoSequencial > maiorSequencial ? maiorSequencial : novoSequencial < menorSequencial ? menorSequencial : novoSequencial;
            idPeca = pecas.filter(function (p) {
              return p.sequencial === sequencialAntigo;
            }).map(function (p) {
              return p.idAcessoAnexo;
            });
            _context27.next = 11;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].alterarSequencialPeca(payload.idDocumento, idPeca, novoSequencial);

          case 11:

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].ALTERAR_SEQUENCIAL, { sequencialAntigo: sequencialAntigo, novoSequencial: novoSequencial });
            _context27.next = 18;
            break;

          case 14:
            _context27.prev = 14;
            _context27.t0 = _context27['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context27.t0.body.message }, { root: true });
            throw _context27.t0;

          case 18:
            _context27.prev = 18;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_arquivos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Atualizando Sequencial' }, { root: true });
            return _context27.finish(18);

          case 21:
          case 'end':
            return _context27.stop();
        }
      }
    }, _callee27, _this, [[0, 14, 18, 21]]);
  }));

  return function (_x38, _x39) {
    return _ref56.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaMotivosRestricoesArquivo: function listaMotivosRestricoesArquivo(state) {
    return state.listaMotivosRestricoesArquivo;
  },
  listaArquivos: function listaArquivos(state) {
    return state.listaArquivos;
  },
  listaPecas: function listaPecas(state) {
    return state.listaPecas;
  },
  listaDocumentos: function listaDocumentos(state) {
    return state.listaDocumentos;
  },
  listaArquivosAssinadosNaoVinculados: function listaArquivosAssinadosNaoVinculados(state) {
    return state.listaArquivosAssinadosNaoVinculados;
  },
  arquivo: function arquivo(state) {
    return state.arquivo;
  },
  arquivoBlobURL: function arquivoBlobURL(state) {
    return state.arquivoBlobURL;
  },
  arquivoEdicaoDialog: function arquivoEdicaoDialog(state) {
    return state.arquivoEdicaoDialog;
  },
  cancelamentoPecaDialog: function cancelamentoPecaDialog(state) {
    return state.cancelamentoPecaDialog;
  },
  adicionarArquivoAssinadoDialog: function adicionarArquivoAssinadoDialog(state) {
    return state.adicionarArquivoAssinadoDialog;
  },
  informacoesPecasUploadDialog: function informacoesPecasUploadDialog(state) {
    return state.informacoesPecasUploadDialog;
  },
  passoAtual: function passoAtual(state) {
    return state.passoAtual;
  },
  situacaoVinculo: function situacaoVinculo(state) {
    return state.situacaoVinculo;
  },
  documentoSelecionado: function documentoSelecionado(state) {
    return state.documentoSelecionado;
  },
  justificativaCancelamento: function justificativaCancelamento(state) {
    return state.justificativaCancelamento;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_arquivos_documento_state_js__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_documento_getters_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_js__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_arquivos_documento_actions_js__ = __webpack_require__(269);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_arquivos_documento_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_arquivos_documento_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_arquivos_documento_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__ = __webpack_require__(66);



var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO, function (state, payload) {
  state.listaMotivosRestricoesArquivo = payload.listaMotivosRestricoesArquivo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_LISTA_ARQUIVOS, function (state, payload) {
  state.listaArquivos = payload.listaArquivos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_LISTA_PECAS, function (state, payload) {
  state.listaPecas = payload.listaPecas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_ARQUIVO, function (state, payload) {
  state.arquivo = payload.arquivo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_ARQUIVO_BLOB_URL, function (state, payload) {
  state.arquivoBlobURL = payload.arquivoBlobURL;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_SITUACAO_VINCULO, function (state, payload) {
  state.situacaoVinculo = payload.situacaoVinculo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (state, payload) {
  state.listaDocumentos = payload.listaDocumentos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, function (state, payload) {
  state.documentoSelecionado = payload.documentoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_JUSTIFICATIVA_CANCELAMENTO, function (state, payload) {
  state.justificativaCancelamento = payload.justificativaCancelamento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_PASSO_ATUAL, function (state, payload) {
  state.passoAtual = payload.passoAtual;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS, function (state, payload) {
  state.listaArquivosAssinadosNaoVinculados = payload.listaArquivosAssinadosNaoVinculados;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].REMOVER_ARQUIVO_LISTA, function (state, payload) {
  state.listaPecas.splice(payload.arquivoSelecionadoIndex, 1);
  state.listaPecas.forEach(function (peca) {
    if (peca.sequencial > payload.arquivoSelecionado.sequencial) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(peca, { sequencial: peca.sequencial - 1 });
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].ALTERAR_PECA_LISTA, function (state, payload) {
  state.listaPecas.splice(payload.arquivoSelecionadoIndex, 1, payload.arquivo);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SHOW_EDICAO_ARQUIVO_DIALOG, function (state) {
  state.arquivoEdicaoDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].HIDE_EDICAO_ARQUIVO_DIALOG, function (state) {
  state.arquivoEdicaoDialog = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SHOW_CANCELAMENTO_PECA_DIALOG, function (state) {
  state.cancelamentoPecaDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].HIDE_EXCLUSAO_ARQUIVO_DIALOG, function (state) {
  state.cancelamentoPecaDialog = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG, function (state) {
  state.adicionarArquivoAssinadoDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG, function (state) {
  state.adicionarArquivoAssinadoDialog = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG, function (state) {
  state.informacoesPecasUploadDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG, function (state) {
  state.informacoesPecasUploadDialog = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__vuex_arquivos_documento_mutations_types__["a" /* default */].ALTERAR_SEQUENCIAL, function (state, payload) {
  var pecas = state.listaPecas.slice().sort(function (a, b) {
    return a.sequencial - b.sequencial;
  });
  var sequencialAntigo = +payload.sequencialAntigo;
  var novoSequencial = +payload.novoSequencial;

  pecas[sequencialAntigo - 1].sequencial = novoSequencial;
  if (sequencialAntigo > novoSequencial) {
    pecas.slice(novoSequencial - 1, sequencialAntigo - 1).forEach(function (p) {
      p.sequencial = p.sequencial + 1;
    });
  } else if (sequencialAntigo < novoSequencial) {
    pecas.slice(sequencialAntigo, novoSequencial).forEach(function (p) {
      p.sequencial = p.sequencial - 1;
    });
  }
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaMotivosRestricoesArquivo: [],
  listaArquivos: [],
  listaPecas: [],
  listaDocumentos: [],
  listaArquivosAssinadosNaoVinculados: [],
  arquivo: null,
  arquivoBlobURL: null,
  arquivoEdicaoDialog: false,
  cancelamentoPecaDialog: false,
  adicionarArquivoAssinadoDialog: false,
  informacoesPecasUploadDialog: false,
  passoAtual: 1,
  situacaoVinculo: {},
  documentoSelecionado: {},
  justificativaCancelamento: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__ = __webpack_require__(67);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */], {
  PERFORM_LOGIN: 'PERFORM_LOGIN',
  PERFORM_LOGOUT: 'PERFORM_LOGOUT'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(23);





var _this = this,
    _actions;





var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].ALTERAR_CONFIGURACOES_USUARIO, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando configuracoes' }, { root: true });
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_auth__["a" /* default */].alterarConfiguracoesUsuario(payload);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].ALTERAR_CONFIGURACOES_USUARIO, payload);
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Configurações alteradas com sucesso' }, { root: true });
            __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'CaixaPostal' });
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ocorreu um erro ao tentar alterar as configurações do usuário' }, { root: true });
            throw _context.t0;

          case 13:
            _context.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Alterando configuracoes' }, { root: true });
            return _context.finish(13);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].SET_USUARIO, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
    var commit = _ref4.commit;

    var usuario, _payload$dadosConfigu, emailNotificacoes, emailPessoal, configuracoes;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!payload.dadosAuth || !payload.dadosConfiguracoes || !payload.dadosPermissoes) {
              commit(__WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].SET_USUARIO, { usuario: undefined });
            } else {
              usuario = {};

              usuario.id = payload.dadosAuth.data.idUsuario;
              usuario.username = payload.dadosAuth.data.username;
              usuario.nome = payload.dadosAuth.data.usuario.nome;
              usuario.permissoes = payload.dadosPermissoes.data;
              _payload$dadosConfigu = payload.dadosConfiguracoes.data, emailNotificacoes = _payload$dadosConfigu.emailNotificacoes, emailPessoal = _payload$dadosConfigu.emailPessoal, configuracoes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_payload$dadosConfigu, ['emailNotificacoes', 'emailPessoal']);

              usuario.configuracoes = configuracoes;
              usuario.email = emailNotificacoes;
              usuario.emailPessoal = emailPessoal;
              usuario.idPessoa = payload.dadosAuth.data.usuario.idPessoa;
              commit(__WEBPACK_IMPORTED_MODULE_4__vuex_auth_actions_types__["a" /* default */].SET_USUARIO, { usuario: usuario });
            }

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  usuario: function usuario(state) {
    return state.usuario;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_auth_state_js__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_auth_getters_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_auth_mutations_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_auth_actions_js__ = __webpack_require__(275);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_auth_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_auth_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_auth_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_auth_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__ = __webpack_require__(67);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].ALTERAR_CONFIGURACOES_USUARIO, function (state, payload) {
  state.usuario.configuracoes = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_USUARIO, function (state, payload) {
  state.usuario = payload.usuario;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  usuario: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types_js__ = __webpack_require__(68);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types_js__["a" /* default */], {
  INICIALIZAR_DADOS: 'INICIALIZAR_DADOS',
  GET_ITENS_GLOSSARIO: 'GET_ITENS_GLOSSARIO',
  GET_LISTA_TIPO_DOCUMENTO: 'GET_LISTA_TIPO_DOCUMENTO',
  GET_LISTA_UNIDADE_PROCEDENCIA: 'GET_LISTA_UNIDADE_PROCEDENCIA',
  GET_LISTA_TIPO_INTERESSADO: 'GET_LISTA_TIPO_INTERESSADO',
  GET_ASSUNTOS: 'GET_ASSUNTOS',
  GET_ASSUNTO: 'GET_ASSUNTO',
  GET_DOCUMENTO_AUTUACAO: 'GET_DOCUMENTO_AUTUACAO',
  GET_LISTA_INTERESSADOS: 'GET_LISTA_INTERESSADOS',
  BUSCAR_LISTA_ASSUNTO: 'BUSCAR_LISTA_ASSUNTO',
  ENVIAR_AUTUACAO: 'ENVIAR_AUTUACAO',
  GET_DOCUMENTO_ORIGEM: 'GET_DOCUMENTO_ORIGEM'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_dates__ = __webpack_require__(29);







var _this = this,
    _actions;







var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].EXIBIR_DIALOG_INTERESSADO, function (_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].EXIBIR_DIALOG_INTERESSADO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_INTERESSADO, function (_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_INTERESSADO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].EXIBIR_DIALOG_ASSUNTO, function (_ref3) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].EXIBIR_DIALOG_ASSUNTO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_ASSUNTO, function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_ASSUNTO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].EXIBIR_DIALOG_GLOSSARIO, function (_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].EXIBIR_DIALOG_GLOSSARIO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_GLOSSARIO, function (_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_GLOSSARIO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, function (_ref7, payload) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ASSUNTO, function (_ref8, payload) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ASSUNTO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ASSUNTO_NIVEL_1, function (_ref9, payload) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ASSUNTO_NIVEL_1, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_TIPO_DOCUMENTO, function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(_ref11, payload) {
    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_TIPO_DOCUMENTO, payload);

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2) {
    return _ref10.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_UNIDADE_PROCEDENCIA, function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(_ref13, payload) {
    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_UNIDADE_PROCEDENCIA, payload);

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x3, _x4) {
    return _ref12.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_TIPO_INTERESSADO, function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3(_ref15, payload) {
    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_TIPO_INTERESSADO, payload);

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function (_x5, _x6) {
    return _ref14.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_INTERESSADO, function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4(_ref17, payload) {
    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_INTERESSADO, payload);

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function (_x7, _x8) {
    return _ref16.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_ASSUNTO, function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5(_ref19, payload) {
    var commit = _ref19.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_ASSUNTO, payload);

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x9, _x10) {
    return _ref18.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_RESUMO_ASSUNTO, function () {
  var _ref20 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6(_ref21, payload) {
    var commit = _ref21.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_RESUMO_ASSUNTO, payload);

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function (_x11, _x12) {
    return _ref20.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_OBSERVACAO, function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7(_ref23, payload) {
    var commit = _ref23.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_OBSERVACAO, payload);

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function (_x13, _x14) {
    return _ref22.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_URGENTE, function () {
  var _ref24 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8(_ref25, payload) {
    var commit = _ref25.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_URGENTE, payload);

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function (_x15, _x16) {
    return _ref24.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_MOTIVO_URGENCIA, function () {
  var _ref26 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9(_ref27, payload) {
    var commit = _ref27.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_MOTIVO_URGENCIA, payload);

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this);
  }));

  return function (_x17, _x18) {
    return _ref26.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DOCUMENTO_ORIGEM, function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10(_ref29, payload) {
    var commit = _ref29.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DOCUMENTO_ORIGEM, payload);

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function (_x19, _x20) {
    return _ref28.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_EMITENTE, function () {
  var _ref30 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11(_ref31, payload) {
    var commit = _ref31.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_EMITENTE, payload);

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this);
  }));

  return function (_x21, _x22) {
    return _ref30.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_DOCUMENTO_ORIGEM, function () {
  var _ref32 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12(_ref33, payload) {
    var commit = _ref33.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_DOCUMENTO_ORIGEM, payload);

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this);
  }));

  return function (_x23, _x24) {
    return _ref32.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, function () {
  var _ref34 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13(_ref35, payload) {
    var commit = _ref35.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, payload);

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this);
  }));

  return function (_x25, _x26) {
    return _ref34.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DOCUMENTO, function () {
  var _ref36 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14(_ref37, payload) {
    var commit = _ref37.commit;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DOCUMENTO, payload);

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this);
  }));

  return function (_x27, _x28) {
    return _ref36.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_ITENS_GLOSSARIO, function () {
  var _ref38 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15(_ref39, payload) {
    var commit = _ref39.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, { root: true });
            _context15.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: [] });
            _context15.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getItensGlossario();

          case 5:
            response = _context15.sent;

            response.data.forEach(function (item) {
              item.descricaoAssunto = item.descricaoAssunto && item.descricaoAssunto.split('-').length > 1 ? item.descricaoAssunto.substring(item.descricaoAssunto.indexOf('-') + 1).trim() : item.descricaoAssunto.trim();
            });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: response.data });
            _context15.next = 14;
            break;

          case 10:
            _context15.prev = 10;
            _context15.t0 = _context15['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os itens do vocabulário controlado' }, { root: true });
            throw _context15.t0;

          case 14:
            _context15.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, { root: true });
            return _context15.finish(14);

          case 17:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x29, _x30) {
    return _ref38.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_LISTA_TIPO_DOCUMENTO, function () {
  var _ref40 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16(_ref41) {
    var commit = _ref41.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de documento' }, { root: true });
            _context16.prev = 1;
            _context16.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].getTiposDocumentoAutorizados();

          case 4:
            response = _context16.sent;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_TIPO_DOCUMENTO, { listaTipoDocumento: response.data });
            _context16.next = 12;
            break;

          case 8:
            _context16.prev = 8;
            _context16.t0 = _context16['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de documento' }, { root: true });
            throw _context16.t0;

          case 12:
            _context16.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de documento' }, { root: true });
            return _context16.finish(12);

          case 15:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x31) {
    return _ref40.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_LISTA_UNIDADE_PROCEDENCIA, function () {
  var _ref42 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17(_ref43, payload) {
    var commit = _ref43.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades de procedência' }, { root: true });
            _context17.prev = 1;
            _context17.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getListaUnidadesProcedencia(payload.somenteAtivas);

          case 4:
            response = _context17.sent;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_UNIDADE_PROCEDENCIA, { listaUnidadesProcedencia: response.data });
            _context17.next = 12;
            break;

          case 8:
            _context17.prev = 8;
            _context17.t0 = _context17['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as unidades de procedência' }, { root: true });
            throw _context17.t0;

          case 12:
            _context17.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades de procedência' }, { root: true });
            return _context17.finish(12);

          case 15:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x32, _x33) {
    return _ref42.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_LISTA_TIPO_INTERESSADO, function () {
  var _ref44 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18(_ref45, payload) {
    var commit = _ref45.commit;
    var idTipoDocumento, response, lista;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de interessado' }, { root: true });
            idTipoDocumento = payload && payload.idTipoDocumento ? payload.idTipoDocumento : undefined;
            _context18.prev = 2;
            _context18.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getListaTipoInteressado(idTipoDocumento);

          case 5:
            response = _context18.sent;
            lista = [];

            response.data.forEach(function (tipo) {
              lista.push({ id: tipo, descricao: tipo.charAt(0) + tipo.slice(1).toLowerCase().split('_').join(' ') });
            });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_TIPO_INTERESSADO, { listaTiposInteressado: lista });
            _context18.next = 15;
            break;

          case 11:
            _context18.prev = 11;
            _context18.t0 = _context18['catch'](2);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de interessados' }, { root: true });
            throw _context18.t0;

          case 15:
            _context18.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando tipos de interessado' }, { root: true });
            return _context18.finish(15);

          case 18:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, _this, [[2, 11, 15, 18]]);
  }));

  return function (_x34, _x35) {
    return _ref44.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_DOCUMENTO_AUTUACAO, function () {
  var _ref46 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19(_ref47, payload) {
    var commit = _ref47.commit,
        dispatch = _ref47.dispatch;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando documento' }, { root: true });
            _context19.prev = 1;
            _context19.next = 4;
            return __WEBPACK_IMPORTED_MODULE_7__utils_documentos__["a" /* default */].getDocument(payload.idDocumento);

          case 4:
            response = _context19.sent;

            if (response.data.situacao !== 'EM_CRIACAO' && response.data.estado['2001'] !== 6) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Apenas documentos em criação podem ser editados' }, { root: true });
              __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({ name: 'NovaAutuacao' });
            } else if (response.data.estado['32002'] !== 3 && response.data.estado['32002'] !== 4) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Apenas documentos nato-digitais ou digitalizados podem ser editados' }, { root: true });
              __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({ name: 'NovaAutuacao' });
            } else {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DOCUMENTO, { documento: response.data });
            }
            _context19.next = 12;
            break;

          case 8:
            _context19.prev = 8;
            _context19.t0 = _context19['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar dados do documento' }, { root: true });
            throw _context19.t0;

          case 12:
            _context19.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando dados do documento.' }, { root: true });
            return _context19.finish(12);

          case 15:
          case 'end':
            return _context19.stop();
        }
      }
    }, _callee19, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x36, _x37) {
    return _ref46.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].INICIALIZAR_DADOS, function () {
  var _ref48 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee20(_ref49, payload) {
    var commit = _ref49.commit,
        dispatch = _ref49.dispatch;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Inicializando autuação' }, { root: true });
            _context20.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_ASSUNTO);
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_INTERESSADO);
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ESCONDER_DIALOG_GLOSSARIO);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_TIPO_DOCUMENTO, { tipoDocumento: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_UNIDADE_PROCEDENCIA, { unidadeProcedencia: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_TIPO_INTERESSADO, { tipoInteressado: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_INTERESSADO, { interessado: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_ASSUNTO, { assunto: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_RESUMO_ASSUNTO, { resumoAssunto: undefined });

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DOCUMENTO_ORIGEM, { documentoOrigem: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_EMITENTE, { emitente: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_DOCUMENTO_ORIGEM, { dataDocumentoOrigem: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, { dataRecebimentoDocumentoOrigem: undefined });

            _context20.next = 17;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([dispatch(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_ITENS_GLOSSARIO), dispatch(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_LISTA_TIPO_DOCUMENTO), dispatch(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_LISTA_UNIDADE_PROCEDENCIA, { somenteAtivas: payload.somenteAtivas })]);

          case 17:
            _context20.next = 23;
            break;

          case 19:
            _context20.prev = 19;
            _context20.t0 = _context20['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Erro durante a inicializa\xE7\xE3o de dados da autua\xE7\xE3o: ' + _context20.t0.statusText }, { root: true });
            throw _context20.t0;

          case 23:
            _context20.prev = 23;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Inicializando autuação' }, { root: true });
            return _context20.finish(23);

          case 26:
          case 'end':
            return _context20.stop();
        }
      }
    }, _callee20, _this, [[1, 19, 23, 26]]);
  }));

  return function (_x38, _x39) {
    return _ref48.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_LISTA_INTERESSADOS, function () {
  var _ref50 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee21(_ref51, payload) {
    var commit = _ref51.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessados.' }, { root: true });
            _context21.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: [] });
            _context21.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getListaEntidadeInteressada(payload.tipoInteressado, payload.tipoBusca, payload.nome, payload.codigo, payload.somenteAtivos);

          case 5:
            response = _context21.sent;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: response.data });
            _context21.next = 13;
            break;

          case 9:
            _context21.prev = 9;
            _context21.t0 = _context21['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de documento' }, { root: true });
            throw _context21.t0;

          case 13:
            _context21.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessados.' }, { root: true });
            return _context21.finish(13);

          case 16:
          case 'end':
            return _context21.stop();
        }
      }
    }, _callee21, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x40, _x41) {
    return _ref50.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_ASSUNTOS, function () {
  var _ref52 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee22(_ref53, payload) {
    var commit = _ref53.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos' }, { root: true });
            _context22.prev = 1;
            _context22.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getAssuntos(payload.idTipoDocumento);

          case 4:
            response = _context22.sent;
            return _context22.abrupt('return', response.data);

          case 8:
            _context22.prev = 8;
            _context22.t0 = _context22['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os assuntos' }, { root: true });
            throw _context22.t0;

          case 12:
            _context22.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos' }, { root: true });
            return _context22.finish(12);

          case 15:
          case 'end':
            return _context22.stop();
        }
      }
    }, _callee22, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x42, _x43) {
    return _ref52.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_ASSUNTO, function () {
  var _ref54 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee23(_ref55, payload) {
    var commit = _ref55.commit;
    var assunto, listaAssuntos;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assunto' }, { root: true });
            _context23.prev = 1;
            _context23.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getAssunto(payload.idAssunto);

          case 4:
            assunto = _context23.sent.data;

            if (!payload.idTipoDocumento) {
              _context23.next = 12;
              break;
            }

            _context23.next = 8;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getAssuntos(payload.idTipoDocumento);

          case 8:
            listaAssuntos = _context23.sent.data;

            if (listaAssuntos.some(function (a) {
              return a.id === assunto.id;
            })) {
              _context23.next = 12;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Este assunto é inválido para este tipo de documento' }, { root: true });
            return _context23.abrupt('return', null);

          case 12:
            return _context23.abrupt('return', assunto);

          case 15:
            _context23.prev = 15;
            _context23.t0 = _context23['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível encontrar o assunto' }, { root: true });
            throw _context23.t0;

          case 19:
            _context23.prev = 19;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assunto' }, { root: true });
            return _context23.finish(19);

          case 22:
          case 'end':
            return _context23.stop();
        }
      }
    }, _callee23, _this, [[1, 15, 19, 22]]);
  }));

  return function (_x44, _x45) {
    return _ref54.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].BUSCAR_LISTA_ASSUNTO, function () {
  var _ref56 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee24(_ref57, payload) {
    var commit = _ref57.commit;
    var response, listaAssunto, atribuiveis;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos.' }, { root: true });
            _context24.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_ASSUNTO, { assunto: undefined });
            _context24.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getListaTiposAssunto(payload.idTipoDocumento);

          case 5:
            response = _context24.sent;
            listaAssunto = response.data;

            listaAssunto.forEach(function (a) {
              a.descricaoComCodigo = a.codigo + ' - ' + a.descricao;
            });

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ASSUNTO, { listaAssunto: listaAssunto });
            atribuiveis = [];

            response.data.every(function (assunto) {
              if (assunto.atribuivel) atribuiveis = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(atribuiveis), [assunto]);
              return atribuiveis.length <= 1;
            });
            if (atribuiveis.length === 1) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_ASSUNTO, { assunto: atribuiveis[0] });
            }
            _context24.next = 19;
            break;

          case 14:
            _context24.prev = 14;
            _context24.t0 = _context24['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_LISTA_ASSUNTO, { listaAssunto: [] });
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de assuntos' }, { root: true });
            throw _context24.t0;

          case 19:
            _context24.prev = 19;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando assuntos.' }, { root: true });
            return _context24.finish(19);

          case 22:
          case 'end':
            return _context24.stop();
        }
      }
    }, _callee24, _this, [[1, 14, 19, 22]]);
  }));

  return function (_x46, _x47) {
    return _ref56.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].ENVIAR_AUTUACAO, function () {
  var _ref58 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee26(_ref59, payload) {
    var commit = _ref59.commit;
    var confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            if (payload.bodyAutuacao.documentoOrigem && (!payload.bodyAutuacao.dataDocumentoOrigem || !payload.bodyAutuacao.dataRecebimento || !payload.bodyAutuacao.emitente) || payload.bodyAutuacao.dataDocumentoOrigem && (!payload.bodyAutuacao.documentoOrigem || !payload.bodyAutuacao.dataRecebimento || !payload.bodyAutuacao.emitente) || payload.bodyAutuacao.dataRecebimento && (!payload.bodyAutuacao.documentoOrigem || !payload.bodyAutuacao.dataDocumentoOrigem || !payload.bodyAutuacao.emitente) || payload.bodyAutuacao.emitente && (!payload.bodyAutuacao.documentoOrigem || !payload.bodyAutuacao.dataDocumentoOrigem || !payload.bodyAutuacao.dataRecebimento)) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao definir um documento de origem, todos os campos devem ser preenchidos' }, { root: true });
            } else if (payload.urgente && !payload.motivoUrgencia.length) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao definir um documento como urgente, é necessário definir o motivo da urgência' }, { root: true });
            } else {
              confirmacaoCallback = function () {
                var _ref60 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee25() {
                  var response;
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
                    while (1) {
                      switch (_context25.prev = _context25.next) {
                        case 0:
                          commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: payload.idDocumento ? 'Alterando documento' : 'Autuando novo documento' }, { root: true });
                          _context25.prev = 1;
                          _context25.next = 4;
                          return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].enviarAutuacao(payload.idDocumento, payload.bodyAutuacao);

                        case 4:
                          response = _context25.sent;

                          __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({ name: 'InformacoesDocumento', params: { documentId: response.data.idDocumento } });
                          commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: payload.idDocumento ? 'Edição realizada com sucesso' : 'Autuação enviada com sucesso' }, { root: true });
                          _context25.next = 13;
                          break;

                        case 9:
                          _context25.prev = 9;
                          _context25.t0 = _context25['catch'](1);

                          commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context25.t0.body.message }, { root: true });
                          throw _context25.t0;

                        case 13:
                          _context25.prev = 13;

                          commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: payload.idDocumento ? 'Alterando documento' : 'Autuando novo documento' }, { root: true });
                          return _context25.finish(13);

                        case 16:
                        case 'end':
                          return _context25.stop();
                      }
                    }
                  }, _callee25, _this, [[1, 9, 13, 16]]);
                }));

                return function confirmacaoCallback() {
                  return _ref60.apply(this, arguments);
                };
              }();

              config = {
                textoPergunta: payload.idDocumento ? 'Alterar o documento?' : 'Criar novo documento?',
                textoConteudo: payload.idDocumento ? 'O documento será alterado de acordo com as novas informações fornecidas e continuará em sua caixa postal.' : 'Um novo documento será criado com base nas informações fornecidas e constará em sua caixa postal, em estado de criação.',
                textoNao: 'Cancelar',
                textoSim: payload.idDocumento ? 'Alterar' : 'Criar',
                confirmacaoCallback: confirmacaoCallback
              };

              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });
            }

          case 1:
          case 'end':
            return _context26.stop();
        }
      }
    }, _callee26, _this);
  }));

  return function (_x48, _x49) {
    return _ref58.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].GET_DOCUMENTO_ORIGEM, function () {
  var _ref61 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee27(_ref62, payload) {
    var commit = _ref62.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_BUSCANDO_DOCUMENTO_ORIGEM, { buscandoDocumentoOrigem: true });
            _context27.prev = 1;
            _context27.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_autuacao__["a" /* default */].getDocumentoOrigem(payload.numeroDocumento);

          case 4:
            response = _context27.sent;

            if (response.data.length === 1) {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DOCUMENTO_ORIGEM, { documentoOrigem: response.data[0].numero });
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_EMITENTE, { emitente: 'UFES' });
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_DOCUMENTO_ORIGEM, { dataDocumentoOrigem: __WEBPACK_IMPORTED_MODULE_10__utils_dates__["a" /* default */].APIFormat(response.data[0].dtCriacao) });
              // Data recebimento do Documento de Origem é igual a sua data de criação.
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, { dataRecebimentoDocumentoOrigem: __WEBPACK_IMPORTED_MODULE_10__utils_dates__["a" /* default */].APIFormat(response.data[0].dtCriacao) });
            } else {
              commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Documento não encontrado ou não é um processo/documento avulso' }, { root: true });
            }
            _context27.next = 13;
            break;

          case 8:
            _context27.prev = 8;
            _context27.t0 = _context27['catch'](1);

            console.log(_context27.t0);
            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar o documento' }, { root: true });
            throw _context27.t0;

          case 13:
            _context27.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_6__vuex_autuacao_actions_types__["a" /* default */].SET_BUSCANDO_DOCUMENTO_ORIGEM, { buscandoDocumentoOrigem: false });
            return _context27.finish(13);

          case 16:
          case 'end':
            return _context27.stop();
        }
      }
    }, _callee27, _this, [[1, 8, 13, 16]]);
  }));

  return function (_x50, _x51) {
    return _ref61.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  dialogInteressado: function dialogInteressado(state) {
    return state.dialogInteressado;
  },
  dialogAssunto: function dialogAssunto(state) {
    return state.dialogAssunto;
  },
  dialogGlossario: function dialogGlossario(state) {
    return state.dialogGlossario;
  },

  listaTipoDocumento: function listaTipoDocumento(state) {
    return state.listaTipoDocumento;
  },
  listaUnidadesProcedencia: function listaUnidadesProcedencia(state) {
    return state.listaUnidadesProcedencia;
  },
  listaTiposInteressado: function listaTiposInteressado(state) {
    return state.listaTiposInteressado;
  },
  listaEntidadeInteressada: function listaEntidadeInteressada(state) {
    return state.listaEntidadeInteressada;
  },
  listaAssunto: function listaAssunto(state) {
    return state.listaAssunto;
  },
  listaAssuntoNivel1: function listaAssuntoNivel1(state) {
    return state.listaAssuntoNivel1;
  },
  listaItensGlossario: function listaItensGlossario(state) {
    return state.listaItensGlossario;
  },

  tipoDocumento: function tipoDocumento(state) {
    return state.tipoDocumento;
  },
  unidadeProcedencia: function unidadeProcedencia(state) {
    return state.unidadeProcedencia;
  },
  tipoInteressado: function tipoInteressado(state) {
    return state.tipoInteressado;
  },
  interessado: function interessado(state) {
    return state.interessado;
  },
  assunto: function assunto(state) {
    return state.assunto;
  },
  resumoAssunto: function resumoAssunto(state) {
    return state.resumoAssunto;
  },
  urgente: function urgente(state) {
    return state.urgente;
  },
  motivoUrgencia: function motivoUrgencia(state) {
    return state.motivoUrgencia;
  },
  documentoOrigem: function documentoOrigem(state) {
    return state.documentoOrigem;
  },
  emitente: function emitente(state) {
    return state.emitente;
  },
  dataDocumentoOrigem: function dataDocumentoOrigem(state) {
    return state.dataDocumentoOrigem;
  },
  dataRecebimentoDocumentoOrigem: function dataRecebimentoDocumentoOrigem(state) {
    return state.dataRecebimentoDocumentoOrigem;
  },
  observacao: function observacao(state) {
    return state.observacao;
  },

  documento: function documento(state) {
    return state.documento;
  },
  buscandoDocumentoOrigem: function buscandoDocumentoOrigem(state) {
    return state.buscandoDocumentoOrigem;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_autuacao_state_js__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_getters_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_autuacao_mutations_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_autuacao_actions_js__ = __webpack_require__(281);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_autuacao_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_autuacao_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_autuacao_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__ = __webpack_require__(68);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].EXIBIR_DIALOG_INTERESSADO, function (state) {
  state.dialogInteressado = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].ESCONDER_DIALOG_INTERESSADO, function (state) {
  state.dialogInteressado = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].EXIBIR_DIALOG_ASSUNTO, function (state) {
  state.dialogAssunto = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].ESCONDER_DIALOG_ASSUNTO, function (state) {
  state.dialogAssunto = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].EXIBIR_DIALOG_GLOSSARIO, function (state) {
  state.dialogGlossario = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].ESCONDER_DIALOG_GLOSSARIO, function (state) {
  state.dialogGlossario = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_LISTA_TIPO_DOCUMENTO, function (state, payload) {
  state.listaTipoDocumento = payload.listaTipoDocumento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_LISTA_UNIDADE_PROCEDENCIA, function (state, payload) {
  state.listaUnidadesProcedencia = payload.listaUnidadesProcedencia;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_LISTA_TIPO_INTERESSADO, function (state, payload) {
  state.listaTiposInteressado = payload.listaTiposInteressado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_LISTA_INTERESSADOS, function (state, payload) {
  state.listaEntidadeInteressada = payload.listaEntidadeInteressada;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_LISTA_ASSUNTO, function (state, payload) {
  state.listaAssunto = payload.listaAssunto;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_LISTA_ASSUNTO_NIVEL_1, function (state, payload) {
  state.listaAssuntoNivel1 = payload.listaAssuntoNivel1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_LISTA_ITENS_GLOSSARIO, function (state, payload) {
  state.listaItensGlossario = payload.listaItensGlossario;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_TIPO_DOCUMENTO, function (state, payload) {
  state.tipoDocumento = payload.tipoDocumento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_UNIDADE_PROCEDENCIA, function (state, payload) {
  state.unidadeProcedencia = payload.unidadeProcedencia;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_TIPO_INTERESSADO, function (state, payload) {
  state.tipoInteressado = payload.tipoInteressado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_INTERESSADO, function (state, payload) {
  state.interessado = payload.interessado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_ASSUNTO, function (state, payload) {
  state.assunto = payload.assunto;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_RESUMO_ASSUNTO, function (state, payload) {
  state.resumoAssunto = payload.resumoAssunto;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_URGENTE, function (state, payload) {
  state.urgente = payload.urgente;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_MOTIVO_URGENCIA, function (state, payload) {
  state.motivoUrgencia = payload.motivoUrgencia;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_DOCUMENTO_ORIGEM, function (state, payload) {
  state.documentoOrigem = payload.documentoOrigem;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_EMITENTE, function (state, payload) {
  state.emitente = payload.emitente;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_DATA_DOCUMENTO_ORIGEM, function (state, payload) {
  state.dataDocumentoOrigem = payload.dataDocumentoOrigem;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM, function (state, payload) {
  state.dataRecebimentoDocumentoOrigem = payload.dataRecebimentoDocumentoOrigem;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_OBSERVACAO, function (state, payload) {
  state.observacao = payload.observacao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_DOCUMENTO, function (state, payload) {
  state.documento = payload.documento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_autuacao_mutations_types__["a" /* default */].SET_BUSCANDO_DOCUMENTO_ORIGEM, function (state, payload) {
  state.buscandoDocumentoOrigem = payload.buscandoDocumentoOrigem;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  dialogInteressado: false,
  dialogAssunto: false,
  dialogGlossario: false,

  listaTipoDocumento: [],
  listaUnidadesProcedencia: [],
  listaTiposInteressado: [],
  listaEntidadeInteressada: [],
  listaAssunto: [],
  listaAssuntoNivel1: [],
  listaItensGlossario: [],
  listaItensCriacao: [],

  tipoDocumento: undefined,
  unidadeProcedencia: undefined,
  tipoInteressado: undefined,
  interessado: undefined,
  assunto: undefined,
  resumoAssunto: undefined,
  urgente: false,
  motivoUrgencia: undefined,
  documentoOrigem: undefined,
  emitente: undefined,
  dataDocumentoOrigem: undefined,
  dataRecebimentoDocumentoOrigem: undefined,
  observacao: undefined,

  documento: undefined,
  buscandoDocumentoOrigem: false
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types_js__ = __webpack_require__(69);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types_js__["a" /* default */], {
  INICIALIZAR_DADOS_BUSCA_DOCUMENTOS: 'INICIALIZAR_DADOS_BUSCA_DOCUMENTOS',
  GET_LISTA_INTERESSADOS: 'GET_LISTA_INTERESSADOS',
  GET_LISTA_RESPONSAVEL_TRAMITACAO: 'GET_LISTA_RESPONSAVEL_TRAMITACAO',
  GET_INTERESSADO_POR_CODIGO: 'GET_INTERESSADO_POR_CODIGO',
  GET_RESPONSAVEL_TRAMITACAO_POR_CODIGO: 'GET_RESPONSAVEL_TRAMITACAO_POR_CODIGO',
  GET_LISTA_TODOS_TIPOS_DOCUMENTO: 'GET_LISTA_TODOS_TIPOS_DOCUMENTO',
  GET_LISTA_TIPOS_INTERESSADO: 'GET_LISTA_TIPOS_INTERESSADO',
  GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO: 'GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO',
  GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA: 'GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA',
  GET_LISTA_SERVIDORES_PROCEDENCIA: 'GET_LISTA_SERVIDORES_PROCEDENCIA',
  GET_LISTA_TIPOS_DOCUMENTO_AUTORIZADOS: 'GET_LISTA_TIPOS_DOCUMENTO_AUTORIZADOS',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_autuacao__ = __webpack_require__(62);





var _this = this,
    _actions;





var actions = (_actions = {
  'SHOW_SNACKBAR': function SHOW_SNACKBAR(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: payload.snackbarType, snackbarText: payload.snackbarText }, { root: true });
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].EXIBIR_DIALOG_INTERESSADO, function (_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].EXIBIR_DIALOG_INTERESSADO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].ESCONDER_DIALOG_INTERESSADO, function (_ref3) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].ESCONDER_DIALOG_INTERESSADO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO, function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO, function (_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_TIPO_INTERESSADO, function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(_ref7, payload) {
    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_TIPO_INTERESSADO, payload);

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2) {
    return _ref6.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_INTERESSADO, function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(_ref9, payload) {
    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_INTERESSADO, payload);

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x3, _x4) {
    return _ref8.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, function (_ref10, payload) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_TIPO_RESPONSAVEL_TRAMITACAO, function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(_ref12, payload) {
    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_TIPO_RESPONSAVEL_TRAMITACAO, payload);

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function (_x5, _x6) {
    return _ref11.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_RESPONSAVEL_TRAMITACAO, function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(_ref14, payload) {
    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_RESPONSAVEL_TRAMITACAO, payload);

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function (_x7, _x8) {
    return _ref13.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_RESPONSAVEL_TRAMITACAO, function (_ref15, payload) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_RESPONSAVEL_TRAMITACAO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (_ref16, payload) {
  var commit = _ref16.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_TODOS_TIPOS_DOCUMENTO, function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(_ref18) {
    var commit = _ref18.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documentos' }, { root: true });
            _context5.prev = 1;
            _context5.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getTodosTiposDocumento();

          case 4:
            response = _context5.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data });
            return _context5.abrupt('return', response.data);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de documento' }, { root: true });
            throw _context5.t0;

          case 13:
            _context5.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documentos' }, { root: true });
            return _context5.finish(13);

          case 16:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x9) {
    return _ref17.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_TIPOS_INTERESSADO, function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(_ref20) {
    var commit = _ref20.commit;
    var response, lista;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de interessados' }, { root: true });
            _context6.prev = 1;
            _context6.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_autuacao__["a" /* default */].getListaTipoInteressado();

          case 4:
            response = _context6.sent;
            lista = [];

            response.data.forEach(function (tipo) {
              lista.push({ id: tipo, descricao: tipo.charAt(0) + tipo.slice(1).toLowerCase().split('_').join(' ') });
            });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_TIPO_INTERESSADO, { listaTiposInteressado: lista });
            return _context6.abrupt('return', lista);

          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de interessados' }, { root: true });
            throw _context6.t0;

          case 15:
            _context6.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de interessados' }, { root: true });
            return _context6.finish(15);

          case 18:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this, [[1, 11, 15, 18]]);
  }));

  return function (_x10) {
    return _ref19.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO, function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(_ref22) {
    var commit = _ref22.commit;
    var response, lista;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de responsáveis tramitação' }, { root: true });
            _context7.prev = 1;
            _context7.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_autuacao__["a" /* default */].getListaTipoResponsavelTramitacao();

          case 4:
            response = _context7.sent;
            lista = [];

            response.data.forEach(function (tipo) {
              var descricao = '';
              if (tipo === 'COMISSAO') {
                descricao = 'Comissão';
              } else if (tipo === 'SERVIDOR') {
                descricao = 'Pessoa específica';
              } else {
                descricao = tipo.charAt(0) + tipo.slice(1).toLowerCase().split('_').join(' ');
              }
              lista.push({ id: tipo, descricao: descricao });
            });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO, { listaTiposResponsavelTramitacao: lista });
            return _context7.abrupt('return', lista);

          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de responsáveis tramitação' }, { root: true });
            throw _context7.t0;

          case 15:
            _context7.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de responsáveis tramitação' }, { root: true });
            return _context7.finish(15);

          case 18:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this, [[1, 11, 15, 18]]);
  }));

  return function (_x11) {
    return _ref21.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA, function () {
  var _ref23 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(_ref24) {
    var commit = _ref24.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando unidades de procedência' }, { root: true });
            _context8.prev = 1;
            _context8.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaUnidadesProcedenciaConsulta();

          case 4:
            response = _context8.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_UNIDADES_PROCEDENCIA, { listaUnidadesProcedencia: response.data });
            return _context8.abrupt('return', response.data);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar unidades de procedência' }, { root: true });
            throw _context8.t0;

          case 13:
            _context8.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando unidades de procedência' }, { root: true });
            return _context8.finish(13);

          case 16:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x12) {
    return _ref23.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_SERVIDORES_PROCEDENCIA, function () {
  var _ref25 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(_ref26) {
    var commit = _ref26.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando servidores das unidades de procedência' }, { root: true });
            _context9.prev = 1;
            _context9.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaServidoresProcedencia();

          case 4:
            response = _context9.sent;

            response.data.unshift({ header: 'Escolher Todos' }, { codigo: '0', cpf: '0', id: -1, nome: 'TODOS', situacao: 'Indefinida' }, { divider: true }, { header: 'Escolher um Servidor' });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_SERVIDORES_PROCEDENCIA, { listaServidoresProcedencia: response.data });
            return _context9.abrupt('return', response.data);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar servidores das unidades de procedência' }, { root: true });
            throw _context9.t0;

          case 14:
            _context9.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando servidores das unidades de procedência' }, { root: true });
            return _context9.finish(14);

          case 17:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x13) {
    return _ref25.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].INICIALIZAR_DADOS_BUSCA_DOCUMENTOS, function () {
  var _ref27 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(_ref28) {
    var commit = _ref28.commit,
        dispatch = _ref28.dispatch;
    var promises;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando busca de documentos.' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: [] });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_INTERESSADO, { interessado: undefined });
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_RESPONSAVEL_TRAMITACAO, { responsavelTramitacao: undefined });

            promises = [];


            promises.push(dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_TODOS_TIPOS_DOCUMENTO));
            promises.push(dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_TIPOS_INTERESSADO));
            promises.push(dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO));
            promises.push(dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA));

            _context10.prev = 9;
            _context10.next = 12;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);

          case 12:
            _context10.next = 18;
            break;

          case 14:
            _context10.prev = 14;
            _context10.t0 = _context10['catch'](9);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context10.t0.statusText }, { root: true });
            throw _context10.t0;

          case 18:
            _context10.prev = 18;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando busca de documentos.' }, { root: true });
            return _context10.finish(18);

          case 21:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this, [[9, 14, 18, 21]]);
  }));

  return function (_x14) {
    return _ref27.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_TIPOS_DOCUMENTO_AUTORIZADOS, function () {
  var _ref29 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11(_ref30) {
    var commit = _ref30.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documento autorizados' }, { root: true });
            _context11.prev = 1;
            _context11.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getTiposDocumentoAutorizados();

          case 4:
            response = _context11.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data });
            _context11.next = 12;
            break;

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de documento autorizados' }, { root: true });
            throw _context11.t0;

          case 12:
            _context11.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documento autorizados' }, { root: true });
            return _context11.finish(12);

          case 15:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x15) {
    return _ref29.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_INTERESSADOS, function () {
  var _ref31 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12(_ref32, payload) {
    var commit = _ref32.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessados.' }, { root: true });
            _context12.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: [] });
            _context12.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_autuacao__["a" /* default */].getListaEntidadeInteressada(payload.tipoInteressado, payload.tipoBusca, payload.nome, payload.codigo, payload.somenteAtivos);

          case 5:
            response = _context12.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: response.data });
            return _context12.abrupt('return', response.data);

          case 10:
            _context12.prev = 10;
            _context12.t0 = _context12['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os interessados' }, { root: true });
            throw _context12.t0;

          case 14:
            _context12.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessados.' }, { root: true });
            return _context12.finish(14);

          case 17:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x16, _x17) {
    return _ref31.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_RESPONSAVEL_TRAMITACAO, function () {
  var _ref33 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13(_ref34, payload) {
    var commit = _ref34.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando responsáveis tramitação.' }, { root: true });
            _context13.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_RESPONSAVEL_TRAMITACAO, { listaEntidadeResponsavelTramitacao: [] });
            _context13.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_autuacao__["a" /* default */].getListaEntidadeResponsavelTramitacao(payload.tipoResponsavelTramitacao, payload.tipoBusca, payload.nome, payload.codigo);

          case 5:
            response = _context13.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_RESPONSAVEL_TRAMITACAO, { listaEntidadeResponsavelTramitacao: response.data });
            return _context13.abrupt('return', response.data);

          case 10:
            _context13.prev = 10;
            _context13.t0 = _context13['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os responsáveis tramitação' }, { root: true });
            throw _context13.t0;

          case 14:
            _context13.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando responsáveis tramitação.' }, { root: true });
            return _context13.finish(14);

          case 17:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x18, _x19) {
    return _ref33.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_INTERESSADO_POR_CODIGO, function () {
  var _ref35 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14(_ref36, payload) {
    var commit = _ref36.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!(payload.idTipoInteressado && !payload.idInteressado)) {
              _context14.next = 4;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não é possível buscar um interessado sem definir seu tipo' }, { root: true });
            _context14.next = 31;
            break;

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessado.' }, { root: true });
            _context14.prev = 5;
            _context14.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getInteressadoPorId(payload.idTipoInteressado, payload.idInteressado);

          case 8:
            response = _context14.sent;

            if (!(response.data.length === 1)) {
              _context14.next = 13;
              break;
            }

            return _context14.abrupt('return', response.data[0]);

          case 13:
            if (!(response.data.length === 0)) {
              _context14.next = 18;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Interessado não encontrado' }, { root: true });
            return _context14.abrupt('return', undefined);

          case 18:
            if (!(response.data.length > 1)) {
              _context14.next = 21;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Múltiplos interessados encontrados' }, { root: true });
            return _context14.abrupt('return', undefined);

          case 21:
            _context14.next = 28;
            break;

          case 23:
            _context14.prev = 23;
            _context14.t0 = _context14['catch'](5);

            console.log(_context14.t0);
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível encontrar o interessado' }, { root: true });
            throw _context14.t0;

          case 28:
            _context14.prev = 28;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando interessado.' }, { root: true });
            return _context14.finish(28);

          case 31:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this, [[5, 23, 28, 31]]);
  }));

  return function (_x20, _x21) {
    return _ref35.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_RESPONSAVEL_TRAMITACAO_POR_CODIGO, function () {
  var _ref37 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15(_ref38, payload) {
    var commit = _ref38.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (!(payload.idTipoResponsavelTramitacao && !payload.idResponsavelTramitacao)) {
              _context15.next = 4;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não é possível buscar um responsável tramitações sem definir seu tipo' }, { root: true });
            _context15.next = 31;
            break;

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando responsável tramitações.' }, { root: true });
            _context15.prev = 5;
            _context15.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getResponsavelTramitacaoPorId(payload.idTipoResponsavelTramitacao, payload.idResponsavelTramitacao);

          case 8:
            response = _context15.sent;

            if (!(response.data.length === 1)) {
              _context15.next = 13;
              break;
            }

            return _context15.abrupt('return', response.data[0]);

          case 13:
            if (!(response.data.length === 0)) {
              _context15.next = 18;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Responsável tramiações não encontrado' }, { root: true });
            return _context15.abrupt('return', undefined);

          case 18:
            if (!(response.data.length > 1)) {
              _context15.next = 21;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Múltiplos responsáveis tramitações encontrados' }, { root: true });
            return _context15.abrupt('return', undefined);

          case 21:
            _context15.next = 28;
            break;

          case 23:
            _context15.prev = 23;
            _context15.t0 = _context15['catch'](5);

            console.log(_context15.t0);
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível encontrar o responsável tramitações' }, { root: true });
            throw _context15.t0;

          case 28:
            _context15.prev = 28;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando responsável tramitações.' }, { root: true });
            return _context15.finish(28);

          case 31:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, _this, [[5, 23, 28, 31]]);
  }));

  return function (_x22, _x23) {
    return _ref37.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].GET_LISTA_DOCUMENTOS, function () {
  var _ref39 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16(_ref40, payload) {
    var commit = _ref40.commit;
    var response, length, i;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            if (!(payload.dataEnvioInicio && !payload.dataEnvioFim || !payload.dataEnvioInicio && payload.dataEnvioFim)) {
              _context16.next = 3;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar uma data de tramitação, é necessário selecionar tanto a data de tramitação inicial quanto a data de tramitação final' }, { root: true });
            throw new Error('Ao selecionar uma data de tramtiação, é necessário selecionar tanto a data de criação inicial quanto a data de tramitação final');

          case 3:
            if (!(payload.dataCriacaoInicio && !payload.dataCriacaoFim || !payload.dataCriacaoInicio && payload.dataCriacaoFim)) {
              _context16.next = 6;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar uma data de criação, é necessário selecionar tanto a data de criação inicial quanto a data de criação final' }, { root: true });
            throw new Error('Ao selecionar uma data de criação, é necessário selecionar tanto a data de criação inicial quanto a data de criação final');

          case 6:
            if (!(payload.tipoInteressado && !payload.interessado || !payload.tipoInteressado && payload.interessado)) {
              _context16.next = 9;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar um tipo de interessado, é necessário selecionar também uma entidade interessada' }, { root: true });
            throw new Error('Ao selecionar um tipo de interessado, é necessário selecionar também uma entidade interessada');

          case 9:
            if (!(payload.resumoAssunto && payload.resumoAssunto.length > 0 && payload.resumoAssunto.length < 3)) {
              _context16.next = 12;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'O campo resumo de assunto deve conter no mínimo três caracteres' }, { root: true });
            throw new Error('O campo resumo de assunto deve conter no mínimo três caracteres');

          case 12:
            if (!(payload.resumoAssunto && !(payload.dataCriacaoInicio && payload.dataCriacaoFim || payload.dataEnvioInicio && payload.dataEnvioFim))) {
              _context16.next = 15;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao buscar pelo resumo do assunto, é necessário preencher completamente o filtro de data de criação ou de tramitação' }, { root: true });
            throw new Error('Ao buscar pelo resumo do assunto, é necessário preencher completamente pelo menos um dos filtros de data');

          case 15:
            if (!payload.usuario) {
              _context16.next = 21;
              break;
            }

            if (!(!payload.numeroDocumento && !(payload.dataCriacaoInicio && payload.dataCriacaoFim || payload.dataEnvioInicio && payload.dataEnvioFim) && !payload.tipoInteressado && !payload.interessado && !payload.tipoResponsavelTramitacao && !payload.responsavelTramitacao && !payload.servidoresProcedencia)) {
              _context16.next = 19;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado, um responsavel por tramitações ou um servidor lotado em unidades de procedência do usuário' }, { root: true });
            throw new Error('Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado, um responsavel por tramitações ou um servidor lotado em unidades de procedência do usuário');

          case 19:
            _context16.next = 24;
            break;

          case 21:
            if (!(!payload.numeroDocumento && !(payload.dataCriacaoInicio && payload.dataCriacaoFim || payload.dataEnvioInicio && payload.dataEnvioFim) && !payload.tipoInteressado && !payload.interessado && !payload.tipoResponsavelTramitacao && !payload.responsavelTramitacao)) {
              _context16.next = 24;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado ou um responsavel por tramitações' }, { root: true });
            throw new Error('Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado ou um responsavel por tramitações');

          case 24:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_BUSCANDO_DOCUMENTOS, { buscandoDocumentos: true });
            _context16.prev = 25;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: [] });
            _context16.next = 29;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaDocumentos(payload);

          case 29:
            response = _context16.sent;
            length = response.data.length;

            for (i = 0; i < length; i++) {
              if (response.data[i].estado && response.data[i].estado['32002'] === 3) {
                response.data[i].tipo = response.data[i].tipo + ' (Digitalizado)';
              }
            }
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: response.data });
            return _context16.abrupt('return', response.data);

          case 36:
            _context16.prev = 36;
            _context16.t0 = _context16['catch'](25);

            console.log(_context16.t0);
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, { root: true });
            throw _context16.t0;

          case 41:
            _context16.prev = 41;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_busca_documentos_actions_types__["a" /* default */].SET_BUSCANDO_DOCUMENTOS, { buscandoDocumentos: false });
            return _context16.finish(41);

          case 44:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, _this, [[25, 36, 41, 44]]);
  }));

  return function (_x24, _x25) {
    return _ref39.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  dialogInteressado: function dialogInteressado(state) {
    return state.dialogInteressado;
  },
  dialogResponsavelTramitacao: function dialogResponsavelTramitacao(state) {
    return state.dialogResponsavelTramitacao;
  },
  tipoInteressado: function tipoInteressado(state) {
    return state.tipoInteressado;
  },
  interessado: function interessado(state) {
    return state.interessado;
  },
  tipoResponsavelTramitacao: function tipoResponsavelTramitacao(state) {
    return state.tipoResponsavelTramitacao;
  },
  responsavelTramitacao: function responsavelTramitacao(state) {
    return state.responsavelTramitacao;
  },
  listaTiposDocumento: function listaTiposDocumento(state) {
    return state.listaTiposDocumento;
  },
  listaTiposInteressado: function listaTiposInteressado(state) {
    return state.listaTiposInteressado;
  },
  listaEntidadeInteressada: function listaEntidadeInteressada(state) {
    return state.listaEntidadeInteressada;
  },
  listaEntidadeResponsavelTramitacao: function listaEntidadeResponsavelTramitacao(state) {
    return state.listaEntidadeResponsavelTramitacao;
  },
  listaInteressados: function listaInteressados(state) {
    return state.listaInteressados;
  },
  listaDocumentos: function listaDocumentos(state) {
    return state.listaDocumentos;
  },
  listaUnidadesProcedencia: function listaUnidadesProcedencia(state) {
    return state.listaUnidadesProcedencia;
  },
  buscandoDocumentos: function buscandoDocumentos(state) {
    return state.buscandoDocumentos;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_busca_documentos_state_js__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_getters_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_busca_documentos_mutations_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_busca_documentos_actions_js__ = __webpack_require__(287);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_busca_documentos_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_busca_documentos_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_busca_documentos_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__ = __webpack_require__(69);


var _mutations;


// import dates from '@/utils/dates'

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].EXIBIR_DIALOG_INTERESSADO, function (state) {
  state.dialogInteressado = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].ESCONDER_DIALOG_INTERESSADO, function (state) {
  state.dialogInteressado = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO, function (state) {
  state.dialogResponsavelTramitacao = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO, function (state) {
  state.dialogResponsavelTramitacao = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTO, function (state, payload) {
  state.listaTiposDocumento = payload.listaTiposDocumento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_TIPO_INTERESSADO, function (state, payload) {
  state.listaTiposInteressado = payload.listaTiposInteressado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_INTERESSADOS, function (state, payload) {
  state.listaEntidadeInteressada = payload.listaEntidadeInteressada;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_TIPO_INTERESSADO, function (state, payload) {
  state.tipoInteressado = payload.tipoInteressado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_INTERESSADO, function (state, payload) {
  state.interessado = payload.interessado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO, function (state, payload) {
  state.listaTiposResponsavelTramitacao = payload.listaTiposResponsavelTramitacao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_RESPONSAVEL_TRAMITACAO, function (state, payload) {
  state.listaEntidadeResponsavelTramitacao = payload.listaEntidadeResponsavelTramitacao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_TIPO_RESPONSAVEL_TRAMITACAO, function (state, payload) {
  state.tipoResponsavelTramitacao = payload.tipoResponsavelTramitacao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_RESPONSAVEL_TRAMITACAO, function (state, payload) {
  state.responsavelTramitacao = payload.responsavelTramitacao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (state, payload) {
  state.listaDocumentos = payload.listaDocumentos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_UNIDADES_PROCEDENCIA, function (state, payload) {
  state.listaUnidadesProcedencia = payload.listaUnidadesProcedencia;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_LISTA_SERVIDORES_PROCEDENCIA, function (state, payload) {
  state.listaServidoresProcedencia = payload.listaServidoresProcedencia;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_busca_documentos_mutations_types__["a" /* default */].SET_BUSCANDO_DOCUMENTOS, function (state, payload) {
  state.buscandoDocumentos = payload.buscandoDocumentos;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  dialogInteressado: false,
  dialogResponsavelTramitacao: false,
  tipoInteressado: undefined,
  interessado: undefined,
  tipoResponsavelTramitacao: undefined,
  responsavelTramitacao: undefined,
  listaEntidadeInteressada: [],
  listaEntidadeResponsavelTramitacao: [],
  listaTiposDocumento: [],
  listaTiposInteressado: [],
  listaInteressados: [],
  listaDocumentos: [],
  listaUnidadesProcedencia: [],
  buscandoDocumentos: false
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types_js__ = __webpack_require__(70);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types_js__["a" /* default */], {
  INICIALIZAR_FORMULARIO_CAIXA_POSTAL: 'INICIALIZAR_FORMULARIO_CAIXA_POSTAL',
  GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS: 'GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS',
  GET_LISTA_TIPOS_DOCUMENTOS: 'GET_LISTA_TIPOS_DOCUMENTOS',
  GET_DOCUMENTO_CAIXA_POSTAL: 'GET_DOCUMENTO_CAIXA_POSTAL',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  GET_ULTIMA_TRAMITACAO: 'GET_ULTIMA_TRAMITACAO'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(29);





var _this = this,
    _actions;





var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_NUMERO_DOCUMENTO, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_NUMERO_DOCUMENTO, payload);
          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_ID_TIPO_DOCUMENTO, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_ID_TIPO_DOCUMENTO, payload);
          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_ID_UNIDADE_ATUAL, function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, payload) {
    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_ID_UNIDADE_ATUAL, payload);
          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function (_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_DATA_ENVIO_INICIO, function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8, payload) {
    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_DATA_ENVIO_INICIO, payload);
          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function (_x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_DATA_ENVIO_FIM, function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10, payload) {
    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_DATA_ENVIO_FIM, payload);
          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x9, _x10) {
    return _ref9.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(_ref12, payload) {
    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, payload);
          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function (_x11, _x12) {
    return _ref11.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].GET_LISTA_TIPOS_DOCUMENTOS, function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(_ref14) {
    var commit = _ref14.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documentos' }, { root: true });
            _context7.prev = 1;
            _context7.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getTodosTiposDocumento();

          case 4:
            response = _context7.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data });
            _context7.next = 11;
            break;

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7['catch'](1);

            if (_context7.t0.status === 400) commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Parâmetros de busca inválidos ao buscar lista de tipos de documento' }, { root: true });else commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os tipos de documento' }, { root: true });

          case 11:
            _context7.prev = 11;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tipos de documentos' }, { root: true });
            return _context7.finish(11);

          case 14:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this, [[1, 8, 11, 14]]);
  }));

  return function (_x13) {
    return _ref13.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS, function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(_ref16) {
    var commit = _ref16.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando unidades autorizadas' }, { root: true });
            _context8.prev = 1;
            _context8.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaUnidadesProcedenciaCaixaPostal();

          case 4:
            response = _context8.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_LISTA_UNIDADES_AUTORIZADAS, { listaUnidadesAutorizadas: response.data });
            _context8.next = 12;
            break;

          case 8:
            _context8.prev = 8;
            _context8.t0 = _context8['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as unidades autorizadas' }, { root: true });
            throw _context8.t0;

          case 12:
            _context8.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando unidades autorizadas' }, { root: true });
            return _context8.finish(12);

          case 15:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x14) {
    return _ref15.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].INICIALIZAR_FORMULARIO_CAIXA_POSTAL, function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(_ref18) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;
    var promises;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            promises = [];

            promises.push(dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].GET_LISTA_TIPOS_DOCUMENTOS));
            promises.push(dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].GET_LISTA_UNIDADES_PROCEDENCIA_AUTORIZADAS));
            _context9.next = 6;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);

          case 6:
            _context9.next = 12;
            break;

          case 8:
            _context9.prev = 8;
            _context9.t0 = _context9['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context9.t0.statusText }, { root: true });
            throw _context9.t0;

          case 12:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this, [[0, 8]]);
  }));

  return function (_x15) {
    return _ref17.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].GET_DOCUMENTO_CAIXA_POSTAL, function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(_ref20, payload) {
    var commit = _ref20.commit;
    var parameters, response, listaFiltrada;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento na caixa postal' }, { root: true });
            _context10.prev = 1;
            parameters = { numeroDocumento: payload.documento.numeroDocumento ? payload.documento.numeroDocumento : payload.documento.numero };
            _context10.next = 5;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaDocumentosCaixaPostal(parameters);

          case 5:
            response = _context10.sent;
            listaFiltrada = response.data.filter(function (item) {
              return item.idDocumento === payload.documento.idDocumento;
            });

            if (!(listaFiltrada.length > 0)) {
              _context10.next = 11;
              break;
            }

            return _context10.abrupt('return', listaFiltrada[0]);

          case 11:
            return _context10.abrupt('return', null);

          case 12:
            _context10.next = 18;
            break;

          case 14:
            _context10.prev = 14;
            _context10.t0 = _context10['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'N\xE3o foi poss\xEDvel buscar o documento ' + payload.documento.numeroDocumento + ' na sua caixa postal' }, { root: true });
            throw _context10.t0;

          case 18:
            _context10.prev = 18;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento na caixa postal' }, { root: true });
            return _context10.finish(18);

          case 21:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this, [[1, 14, 18, 21]]);
  }));

  return function (_x16, _x17) {
    return _ref19.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].GET_LISTA_DOCUMENTOS, function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11(_ref22, payload) {
    var commit = _ref22.commit;
    var response, items, length, i;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(!payload.dataEnvioInicio && !payload.dataEnvioFim && !payload.numeroDocumento)) {
              _context11.next = 5;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos o número do documento ou então as datas inicial e final conjuntamente' }, { root: true });
            throw new Error('Defina pelo menos o número do documento ou então as datas inicial e final conjuntamente');

          case 5:
            if (!(payload.dataEnvioInicio && !payload.dataEnvioFim || !payload.dataEnvioInicio && payload.dataEnvioFim)) {
              _context11.next = 10;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar uma data, é necessário selecionar tanto a data inicial quanto a data final' }, { root: true });
            throw new Error('Ao selecionar uma data, é necessário selecionar tanto a data inicial quanto a data final');

          case 10:
            _context11.prev = 10;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL, { buscandoDocumentosCaixaPostal: true });
            _context11.next = 14;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaDocumentosCaixaPostal(payload);

          case 14:
            response = _context11.sent;
            items = response.data;
            length = items.length;

            for (i = 0; i < length; i++) {
              items[i].prazo = __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */].daysDiff(items[i].dataEnvio);
              if (items[i].estado && items[i].estado['32002'] === 3) {
                items[i].tipoDocumento = items[i].tipoDocumento + ' (Digitalizado)';
              }
            }
            return _context11.abrupt('return', items.filter(function (item) {
              return item.estado && (!item.estado['32007'] || item.estado['32007'] === 1);
            }));

          case 21:
            _context11.prev = 21;
            _context11.t0 = _context11['catch'](10);

            if (_context11.t0.status === 0) commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Tempo de espera expirou. Tente refinar mais sua busca para obter um número menor de resultados.' }, { root: true });else commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, { root: true });
            throw _context11.t0;

          case 25:
            _context11.prev = 25;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL, { buscandoDocumentosCaixaPostal: false });
            return _context11.finish(25);

          case 28:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this, [[10, 21, 25, 28]]);
  }));

  return function (_x18, _x19) {
    return _ref21.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].GET_ULTIMA_TRAMITACAO, function () {
  var _ref23 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12(_ref24, payload) {
    var commit = _ref24.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!payload.props.item.dataValidade) {
              _context12.next = 16;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, { root: true });
            _context12.prev = 2;
            _context12.next = 5;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getUltimaTramitacao(payload.props.item.idDocumento);

          case 5:
            response = _context12.sent;

            payload.props.item.ultimaTramitacao = response.data;
            _context12.next = 13;
            break;

          case 9:
            _context12.prev = 9;
            _context12.t0 = _context12['catch'](2);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar informações da última tramitação' }, { root: true });
            throw _context12.t0;

          case 13:
            _context12.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_caixa_postal_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, { root: true });
            return _context12.finish(13);

          case 16:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this, [[2, 9, 13, 16]]);
  }));

  return function (_x20, _x21) {
    return _ref23.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  numeroDocumento: function numeroDocumento(state) {
    return state.numeroDocumento;
  },
  idTipoDocumento: function idTipoDocumento(state) {
    return state.idTipoDocumento;
  },
  idUnidadeAtual: function idUnidadeAtual(state) {
    return state.idUnidadeAtual;
  },
  dataEnvioInicio: function dataEnvioInicio(state) {
    return state.dataEnvioInicio;
  },
  dataEnvioFim: function dataEnvioFim(state) {
    return state.dataEnvioFim;
  },
  listaTiposDocumento: function listaTiposDocumento(state) {
    return state.listaTiposDocumento;
  },
  listaUnidadesAutorizadas: function listaUnidadesAutorizadas(state) {
    return state.listaUnidadesAutorizadas;
  },
  listaDocumentos: function listaDocumentos(state) {
    return state.listaDocumentos;
  },
  buscandoDocumentosCaixaPostal: function buscandoDocumentosCaixaPostal(state) {
    return state.buscandoDocumentosCaixaPostal;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_caixa_postal_state_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_getters_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_caixa_postal_mutations_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_caixa_postal_actions_js__ = __webpack_require__(293);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_caixa_postal_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_caixa_postal_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_caixa_postal_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__ = __webpack_require__(70);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_NUMERO_DOCUMENTO, function (state, payload) {
  state.numeroDocumento = payload.numeroDocumento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_ID_TIPO_DOCUMENTO, function (state, payload) {
  state.idTipoDocumento = payload.idTipoDocumento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_ID_UNIDADE_ATUAL, function (state, payload) {
  state.idUnidadeAtual = payload.idUnidadeAtual;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_DATA_ENVIO_INICIO, function (state, payload) {
  state.dataEnvioInicio = payload.dataEnvioInicio;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_DATA_ENVIO_FIM, function (state, payload) {
  state.dataEnvioFim = payload.dataEnvioFim;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_LISTA_TIPOS_DOCUMENTO, function (state, payload) {
  state.listaTiposDocumento = payload.listaTiposDocumento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_LISTA_UNIDADES_AUTORIZADAS, function (state, payload) {
  state.listaUnidadesAutorizadas = payload.listaUnidadesAutorizadas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (state, payload) {
  state.listaDocumentos = payload.listaDocumentos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_caixa_postal_mutations_types__["a" /* default */].SET_BUSCANDO_DOCUMENTOS_CAIXA_POSTAL, function (state, payload) {
  state.buscandoDocumentosCaixaPostal = payload.buscandoDocumentosCaixaPostal;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  numeroDocumento: undefined,
  idTipoDocumento: undefined,
  idUnidadeAtual: undefined,
  dataEnvioInicio: undefined,
  dataEnvioFim: undefined,
  listaTiposDocumento: [],
  listaUnidadesAutorizadas: [],
  listaDocumentos: [],
  buscandoDocumentosCaixaPostal: false
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types_js__ = __webpack_require__(71);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types_js__["a" /* default */], {
  GET_DOCUMENTO: 'GET_DOCUMENTO',
  GET_PRESENTE_CAIXA_POSTAL: 'GET_PRESENTE_CAIXA_POSTAL',
  GET_RAIZ_PRESENTE_CAIXA_POSTAL: 'GET_RAIZ_PRESENTE_CAIXA_POSTAL',
  GET_EMAIL_INTERESSADO: 'GET_EMAIL_INTERESSADO',
  SET_EMAIL_INTERESSADO: 'SET_EMAIL_INTERESSADO',
  RECEBER_DOCUMENTO: 'RECEBER_DOCUMENTO',
  GET_URL_CONSOLIDACAO: 'GET_URL_CONSOLIDACAO',
  GET_PDF_CAPA: 'GET_PDF_CAPA',
  GET_PDF_COMPROVANTE_PROTOCOLIZACAO: 'GET_PDF_COMPROVANTE_PROTOCOLIZACAO',
  ENVIAR_COMPROVANTE_PROTOCOLIZACAO_POR_EMAIL: 'ENVIAR_COMPROVANTE_PROTOCOLIZACAO_POR_EMAIL',
  CONFIRMAR: 'ui/CONFIRMAR',
  SALVAR_TAGS: 'SALVAR_TAGS',
  FAVORITAR_DOCUMENTO: 'FAVORITAR_DOCUMENTO',
  DESFAVORITAR_DOCUMENTO: 'DESFAVORITAR_DOCUMENTO',
  GET_CONSOLIDACOES: 'GET_CONSOLIDACOES'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_documentos__ = __webpack_require__(8);






var _this = this,
    _actions;




var API_URL = "https://api-lepisma.prod.uks.ufes.br/";

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_DOCUMENTO, function (_ref, payload) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_DOCUMENTO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_DOCUMENTO, function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(_ref3, payload) {
    var commit = _ref3.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando dados do documento.' }, { root: true });
            _context.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_DOCUMENTO, { documento: undefined });
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getDocument(payload.docId);

          case 5:
            response = _context.sent;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_DOCUMENTO, { documento: response.data });
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context.t0.body && _context.t0.body.message ? _context.t0.body.message : 'Não foi possível buscar dados do documento' }, { root: true });
            throw _context.t0;

          case 13:
            _context.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando dados do documento.' }, { root: true });
            return _context.finish(13);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_EMAIL_INTERESSADO, function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5, payload) {
    var commit = _ref5.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando email do interessado.' }, { root: true });
            _context2.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_EMAIL_INTERESSADO, { emailInteressado: undefined });
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getEmailInteressado(payload.tipoInteressado, payload.idInteressado);

          case 5:
            response = _context2.sent;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_EMAIL_INTERESSADO, { emailInteressado: response.data.email ? response.data.email : undefined });
            _context2.next = 13;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar o email do interessado deste documento' }, { root: true });
            throw _context2.t0;

          case 13:
            _context2.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando email do interessado.' }, { root: true });
            return _context2.finish(13);

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_EMAIL_INTERESSADO, function (_ref6, payload) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_EMAIL_INTERESSADO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_PRESENTE_CAIXA_POSTAL, function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, payload) {
    var commit = _ref8.commit;
    var parameters, response, listaFiltrada;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença na caixa postal' }, { root: true });
            _context3.prev = 1;
            parameters = { numeroDocumento: payload.documento.numero };
            _context3.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getListaDocumentosCaixaPostal(parameters);

          case 5:
            response = _context3.sent;
            listaFiltrada = response.data.filter(function (item) {
              return item.idDocumento === payload.documento.idDocumento;
            });

            if (listaFiltrada.length > 0) commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_PRESENTE_CAIXA_POSTAL, { presenteCaixaPostal: true });else commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_PRESENTE_CAIXA_POSTAL, { presenteCaixaPostal: false });
            _context3.next = 14;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível verificar se o documento está presente na caixa postal' }, { root: true });
            throw _context3.t0;

          case 14:
            _context3.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença na caixa postal' }, { root: true });
            return _context3.finish(14);

          case 17:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_RAIZ_PRESENTE_CAIXA_POSTAL, function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(_ref10, payload) {
    var commit = _ref10.commit;
    var current, parameters, response, listaFiltrada;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença de documentos agregadores na caixa postal' }, { root: true });
            _context4.prev = 1;
            current = payload.documento;

          case 3:
            if (!current.idDocumentoAgregador) {
              _context4.next = 9;
              break;
            }

            _context4.next = 6;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getDocument(current.idDocumentoAgregador);

          case 6:
            current = _context4.sent.data;
            _context4.next = 3;
            break;

          case 9:
            parameters = { numeroDocumento: current.numero };
            _context4.next = 12;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getListaDocumentosCaixaPostal(parameters);

          case 12:
            response = _context4.sent;
            listaFiltrada = response.data.filter(function (item) {
              return item.idDocumento === current.idDocumento;
            });

            if (listaFiltrada.length > 0) commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_RAIZ_PRESENTE_CAIXA_POSTAL, { raizPresenteCaixaPostal: true });else commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_RAIZ_PRESENTE_CAIXA_POSTAL, { raizPresenteCaixaPostal: false });
            _context4.next = 21;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível verificar presença de documentos agregadores na caixa postal' }, { root: true });
            throw _context4.t0;

          case 21:
            _context4.prev = 21;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença de documentos agregadores na caixa postal' }, { root: true });
            return _context4.finish(21);

          case 24:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[1, 17, 21, 24]]);
  }));

  return function (_x7, _x8) {
    return _ref9.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_PRESENTE_CAIXA_POSTAL, function (_ref11, payload) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_PRESENTE_CAIXA_POSTAL, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].RECEBER_DOCUMENTO, function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(_ref13, payload) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;
    var config;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            config = {
              textoPergunta: 'Receber o documento?',
              textoConteudo: (payload.documento.tipo ? payload.documento.tipo : payload.documento.tipoDocumento) + ' n\xFAmero "' + (payload.documento.numero ? payload.documento.numero : payload.documento.numeroDocumento) + '" est\xE1 presente em sua caixa postal mas ainda n\xE3o foi recebido. Deseja receber este documento?',
              textoNao: 'Não',
              textoSim: 'Receber'
            };
            _context5.next = 3;
            return dispatch(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].CONFIRMAR, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 3:
            if (!_context5.sent) {
              _context5.next = 19;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, { root: true });
            _context5.prev = 5;
            _context5.next = 8;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].receberDocumento(payload.documento.idDocumento);

          case 8:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento recebido com sucesso' }, { root: true });
            return _context5.abrupt('return', true);

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5['catch'](5);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível receber o documento' }, { root: true });
            return _context5.abrupt('return', false);

          case 16:
            _context5.prev = 16;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, { root: true });
            return _context5.finish(16);

          case 19:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this, [[5, 12, 16, 19]]);
  }));

  return function (_x9, _x10) {
    return _ref12.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_URL_CONSOLIDACAO, function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(_ref15, payload) {
    var commit = _ref15.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Solicitando consolidação...' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_URL_CONSOLIDACAO, { consolidacaoURL: null });
            _context6.prev = 2;
            _context6.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].solicitaConsolidacao(payload.parameters);

          case 5:
            response = _context6.sent;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_URL_CONSOLIDACAO, { consolidacaoURL: API_URL + 'consolidacao/' + response.body.uuid });
            localStorage.setItem('PROTOCOLO' + response.body.uuid, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.body));
            _context6.next = 14;
            break;

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6['catch'](2);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar a solicitação de consolidação' }, { root: true });
            throw _context6.t0;

          case 14:
            _context6.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Solicitando consolidação...' }, { root: true });
            return _context6.finish(14);

          case 17:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this, [[2, 10, 14, 17]]);
  }));

  return function (_x11, _x12) {
    return _ref14.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_PDF_CAPA, function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(_ref17, payload) {
    var commit = _ref17.commit;
    var response, blob, blobURL;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando capa' }, { root: true });
            _context7.prev = 1;
            _context7.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getPDFCapa(payload.parameters);

          case 4:
            response = _context7.sent;
            blob = new Blob([response.body], { type: 'application/pdf' });
            blobURL = (window.URL || window.webkitURL).createObjectURL(blob);

            window.open(blobURL, '_blank');
            _context7.next = 14;
            break;

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o comprovante' }, { root: true });
            throw _context7.t0;

          case 14:
            _context7.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando capa' }, { root: true });
            return _context7.finish(14);

          case 17:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x13, _x14) {
    return _ref16.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_PDF_COMPROVANTE_PROTOCOLIZACAO, function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8(_ref19, payload) {
    var commit = _ref19.commit;
    var response, blob, blobURL;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando comprovante de protocolização' }, { root: true });
            _context8.prev = 1;
            _context8.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getPDFComprovanteProtocolizacao(payload.parameters);

          case 4:
            response = _context8.sent;
            blob = new Blob([response.body], { type: 'application/pdf' });
            blobURL = (window.URL || window.webkitURL).createObjectURL(blob);

            window.open(blobURL, '_blank');
            _context8.next = 14;
            break;

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o comprovante' }, { root: true });
            throw _context8.t0;

          case 14:
            _context8.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando comprovante de protocolização' }, { root: true });
            return _context8.finish(14);

          case 17:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x15, _x16) {
    return _ref18.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].ENVIAR_COMPROVANTE_PROTOCOLIZACAO_POR_EMAIL, function () {
  var _ref20 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9(_ref21, payload) {
    var commit = _ref21.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando comprovante de protocolização para: ' + payload.parameters.destinatario }, { root: true });
            _context9.prev = 1;
            _context9.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].enviarComprovanteProtocolizacaoPorEmail(payload.parameters);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Comprovante de protocolização enviado para ' + payload.parameters.destinatario }, { root: true });
            _context9.next = 11;
            break;

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível enviar o comprovante' }, { root: true });
            throw _context9.t0;

          case 11:
            _context9.prev = 11;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando comprovante de protocolização para: ' + payload.parameters.destinatario }, { root: true });
            return _context9.finish(11);

          case 14:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this, [[1, 7, 11, 14]]);
  }));

  return function (_x17, _x18) {
    return _ref20.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SALVAR_TAGS, function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10(_ref23, payload) {
    var commit = _ref23.commit,
        dispatch = _ref23.dispatch;
    var response;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando marcadores' }, { root: true });
            _context10.prev = 1;
            _context10.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].salvarTags(payload.idDocumento, payload.stringTags);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Marcadores salvos com sucesso' }, { root: true });
            _context10.next = 7;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getDocument(payload.idDocumento);

          case 7:
            response = _context10.sent;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_DOCUMENTO, { documento: response.data });
            _context10.next = 15;
            break;

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context10.t0.body.message }, { root: true });
            throw _context10.t0;

          case 15:
            _context10.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando marcadores' }, { root: true });
            return _context10.finish(15);

          case 18:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this, [[1, 11, 15, 18]]);
  }));

  return function (_x19, _x20) {
    return _ref22.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].FAVORITAR_DOCUMENTO, function () {
  var _ref24 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11(_ref25, payload) {
    var commit = _ref25.commit,
        dispatch = _ref25.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Adicionando documento aos favoritos' }, { root: true });
            _context11.prev = 1;
            _context11.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].favoritarDocumento(payload.idDocumento);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento adicionado aos favoritos com sucesso' }, { root: true });
            return _context11.abrupt('return', true);

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível adicionar o documento aos favoritos' }, { root: true });
            return _context11.abrupt('return', false);

          case 12:
            _context11.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Adicionando documento aos favoritos' }, { root: true });
            return _context11.finish(12);

          case 15:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x21, _x22) {
    return _ref24.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].DESFAVORITAR_DOCUMENTO, function () {
  var _ref26 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12(_ref27, payload) {
    var commit = _ref27.commit,
        dispatch = _ref27.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, { root: true });
            _context12.prev = 1;
            _context12.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].desfavoritarDocumento(payload.idDocumento);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento removido dos favoritos com sucesso' }, { root: true });
            return _context12.abrupt('return', true);

          case 8:
            _context12.prev = 8;
            _context12.t0 = _context12['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível remover o documento dos favoritos' }, { root: true });
            return _context12.abrupt('return', false);

          case 12:
            _context12.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, { root: true });
            return _context12.finish(12);

          case 15:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x23, _x24) {
    return _ref26.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].GET_CONSOLIDACOES, function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13(_ref29, usuario) {
    var commit = _ref29.commit;
    var response, localStorageConsolidacoes, i, key, item, result;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando consolidações recentes' }, { root: true });
            _context13.prev = 1;
            _context13.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].buscarConsolidacoes();

          case 4:
            response = _context13.sent;

            if (!response.data) {
              _context13.next = 9;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_LISTA_CONSOLIDACOES, { listaConsolidacoes: response.data });
            _context13.next = 15;
            break;

          case 9:
            localStorageConsolidacoes = [];

            for (i = 0; i < localStorage.length; i++) {
              key = localStorage.key(i);
              item = JSON.parse(localStorage.getItem(key));

              if (key.startsWith('PROTOCOLO') && !item.idUsuario) {
                localStorageConsolidacoes.push(item);
              }
            }
            _context13.next = 13;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].buscarConsolidacaoPorUUID(localStorageConsolidacoes);

          case 13:
            result = _context13.sent;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SET_LISTA_CONSOLIDACOES, { listaConsolidacoes: result.data });

          case 15:
            _context13.next = 22;
            break;

          case 17:
            _context13.prev = 17;
            _context13.t0 = _context13['catch'](1);

            console.log(_context13.t0);
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar as consolidações recentes' }, { root: true });
            return _context13.abrupt('return', false);

          case 22:
            _context13.prev = 22;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando consolidações recentes' }, { root: true });
            return _context13.finish(22);

          case 25:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this, [[1, 17, 22, 25]]);
  }));

  return function (_x25, _x26) {
    return _ref28.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  documento: function documento(state) {
    return state.documento;
  },
  presenteCaixaPostal: function presenteCaixaPostal(state) {
    return state.presenteCaixaPostal;
  },
  raizPresenteCaixaPostal: function raizPresenteCaixaPostal(state) {
    return state.raizPresenteCaixaPostal;
  },
  emailInteressado: function emailInteressado(state) {
    return state.emailInteressado;
  },
  consolidacaoURL: function consolidacaoURL(state) {
    return state.consolidacaoURL;
  },
  listaConsolidacoes: function listaConsolidacoes(state) {
    return state.listaConsolidacoes;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_documento_state_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_documento_getters_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_documento_mutations_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_documento_actions_js__ = __webpack_require__(299);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_documento_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_documento_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_documento_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_documento_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types__ = __webpack_require__(71);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types__["a" /* default */].SET_DOCUMENTO, function (state, payload) {
  state.documento = payload.documento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types__["a" /* default */].SET_PRESENTE_CAIXA_POSTAL, function (state, payload) {
  state.presenteCaixaPostal = payload.presenteCaixaPostal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types__["a" /* default */].SET_RAIZ_PRESENTE_CAIXA_POSTAL, function (state, payload) {
  state.raizPresenteCaixaPostal = payload.raizPresenteCaixaPostal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types__["a" /* default */].SET_EMAIL_INTERESSADO, function (state, payload) {
  state.emailInteressado = payload.emailInteressado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types__["a" /* default */].SET_URL_CONSOLIDACAO, function (state, payload) {
  state.consolidacaoURL = payload.consolidacaoURL;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_documento_mutations_types__["a" /* default */].SET_LISTA_CONSOLIDACOES, function (state, payload) {
  state.listaConsolidacoes = payload.listaConsolidacoes;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  documento: {},
  presenteCaixaPostal: false,
  raizPresenteCaixaPostal: false,
  emailInteressado: undefined,
  consolidacaoURL: undefined,
  listaConsolidacoes: []
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_documentos_favoritos_mutations_types_js__ = __webpack_require__(72);



var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_documentos_favoritos_mutations_types_js__["a" /* default */], {
  BUSCAR_FAVORITOS: 'BUSCAR_FAVORITOS',
  DESFAVORITAR_DOCUMENTO: 'DESFAVORITAR_DOCUMENTO',
  ALTERNAR_ACOMPANHAMENTO: 'ALTERNAR_ACOMPANHAMENTO',
  GET_ULTIMA_TRAMITACAO: 'GET_ULTIMA_TRAMITACAO',
  ATUALIZA_MARCADORES: 'ATUALIZA_MARCADORES'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_documentos__ = __webpack_require__(8);




var _this = this,
    _actions;




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SET_LISTA_FAVORITOS, function (_ref, payload) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SET_LISTA_FAVORITOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].BUSCAR_FAVORITOS, function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref3, payload) {
    var commit = _ref3.commit;
    var response, length, i;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Favoritos' }, { root: true });
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__utils_documentos__["a" /* default */].buscarDocumentosFavoritos(payload);

          case 4:
            response = _context.sent;
            length = response.body.length;

            for (i = 0; i < length; i++) {
              response.body[i].tagsFavoritoTela = response.body[i].tagsFavorito ? response.body[i].tagsFavorito : [];
              if (response.body[i].estado && response.body[i].estado['32002'] === 3) {
                response.body[i].tipo = response.body[i].tipo + ' (Digitalizado)';
              }
            }

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SET_LISTA_FAVORITOS, { listaDeDocumentosFavoritos: response.body });
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os documentos favoritos' }, { root: true });
            throw _context.t0;

          case 14:
            _context.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Favoritos' }, { root: true });
            return _context.finish(14);

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 10, 14, 17]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].DESFAVORITAR_DOCUMENTO, function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, { root: true });
            _context2.prev = 1;
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__utils_documentos__["a" /* default */].desfavoritarDocumento(payload.idDocumento);

          case 4:

            payload.listaFavoritos.splice(payload.listaFavoritos.findIndex(function (i) {
              return i.idDocumento === payload.idDocumento;
            }), 1);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SET_LISTA_FAVORITOS, { listaDeDocumentosFavoritos: payload.listaFavoritos });
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento removido dos favoritos com sucesso' }, { root: true });
            return _context2.abrupt('return', true);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível remover o documento dos favoritos' }, { root: true });
            return _context2.abrupt('return', false);

          case 14:
            _context2.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, { root: true });
            return _context2.finish(14);

          case 17:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].ALTERNAR_ACOMPANHAMENTO, function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Alternando acompanhamento por email de documento favorito' }, { root: true });
            _context3.prev = 1;
            _context3.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__utils_documentos__["a" /* default */].alternarAcompanhamentoDeDocumentoFavorito(payload.idDocumento, payload.acompanharPorEmail);

          case 4:

            payload.listaFavoritos.forEach(function (i) {
              if (i.idDocumento === payload.idDocumento) {
                i.acompanhadoPorEmail = payload.acompanharPorEmail;
              }
            });

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SET_LISTA_FAVORITOS, { listaDeDocumentosFavoritos: payload.listaFavoritos });
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Opção de acompanhamento do documento favorito alternada com sucesso.' }, { root: true });
            return _context3.abrupt('return', true);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível alternar a opção de acompanhamento por email do favorito' }, { root: true });
            return _context3.abrupt('return', false);

          case 14:
            _context3.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Alternando acompanhamento por email de documento favorito' }, { root: true });
            return _context3.finish(14);

          case 17:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[1, 10, 14, 17]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].GET_ULTIMA_TRAMITACAO, function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref9, payload) {
    var commit = _ref9.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(payload.props.item.situacao !== 'EM_CRIACAO')) {
              _context4.next = 16;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, { root: true });
            _context4.prev = 2;
            _context4.next = 5;
            return __WEBPACK_IMPORTED_MODULE_4__utils_documentos__["a" /* default */].getUltimaTramitacao(payload.props.item.idDocumento);

          case 5:
            response = _context4.sent;

            payload.props.item.ultimaTramitacao = response.data;
            _context4.next = 13;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4['catch'](2);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar informações da última tramitação' }, { root: true });
            throw _context4.t0;

          case 13:
            _context4.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, { root: true });
            return _context4.finish(13);

          case 16:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[2, 9, 13, 16]]);
  }));

  return function (_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].ATUALIZA_MARCADORES, function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref11, payload) {
    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return __WEBPACK_IMPORTED_MODULE_4__utils_documentos__["a" /* default */].alterarMarcadoresDeDocumentosFavoritos(payload.idDocumento, payload.tagsFavoritoTela);

          case 3:
            payload.tagsFavorito = payload.tagsFavoritoTela;
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Marcadores salvos.' }, { root: true });
            _context5.next = 11;
            break;

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Erro ao salvar os marcadores.' }, { root: true });
            throw _context5.t0;

          case 11:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this, [[0, 7]]);
  }));

  return function (_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaDeDocumentosFavoritos: function listaDeDocumentosFavoritos(state) {
    return state.listaDeDocumentosFavoritos;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_documentos_favoritos_state_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_documentos_favoritos_getters_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_documentos_favoritos_mutations_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_js__ = __webpack_require__(305);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_documentos_favoritos_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_documentos_favoritos_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_documentos_favoritos_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_documentos_favoritos_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_documentos_favoritos_mutations_types__ = __webpack_require__(72);



var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_documentos_favoritos_mutations_types__["a" /* default */].SET_LISTA_FAVORITOS, function (state, payload) {
  state.listaDeDocumentosFavoritos = payload.listaDeDocumentosFavoritos;
});
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaDeDocumentosFavoritos: []
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_mutations_types_js__ = __webpack_require__(73);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_mutations_types_js__["a" /* default */], {
  GET_DOCUMENTO_SELECIONADO: 'GET_DOCUMENTO_SELECIONADO',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  JUNTAR_DOCUMENTOS: 'JUNTAR_DOCUMENTOS'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(23);






var _this = this,
    _actions;





var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_PASSO_ATUAL, function (_ref, payload) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_PASSO_ATUAL, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (_ref2, payload) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_TIPO_JUNTADA_SELECIONADA, function (_ref3, payload) {
  var commit = _ref3.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_TIPO_JUNTADA_SELECIONADA, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].GET_DOCUMENTO_SELECIONADO, function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(_ref5, payload) {
    var commit = _ref5.commit;
    var response, infoDocumento;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: {} });
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getListaDocumentos({ numeroDocumento: payload.documentoSelecionado.numeroDocumento });

          case 5:
            response = _context.sent;
            infoDocumento = response.data.find(function (documento) {
              return documento.idDocumento === payload.documentoSelecionado.idDocumento;
            });

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: infoDocumento });
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, { root: true });
            throw _context.t0;

          case 14:
            _context.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, { root: true });
            return _context.finish(14);

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 10, 14, 17]]);
  }));

  return function (_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, function (_ref6, payload) {
  var commit = _ref6.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].GET_LISTA_DOCUMENTOS, function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(_ref8, payload) {
    var commit = _ref8.commit;

    var response, listaDocumentos, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, documento, vinculos;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, { root: true });
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, { documentoSelecionado: {} });
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: [] });
            _context2.next = 6;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getListaDocumentosParaJuntada(payload.numeroDocumento);

          case 6:
            response = _context2.sent;

            if (!(response.data.length === 0)) {
              _context2.next = 11;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Nenhum documento encontrado' }, { root: true });
            _context2.next = 52;
            break;

          case 11:
            listaDocumentos = [];
            _context2.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando documentos agregados' }, { root: true });
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context2.prev = 17;
            _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(response.data);

          case 19:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context2.next = 28;
              break;
            }

            documento = _step.value;
            _context2.next = 23;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].getListaVinculosDocumento(documento.idDocumento);

          case 23:
            vinculos = _context2.sent.data;

            if (vinculos.some(function (vinculo) {
              return vinculo.tipoAgregacao === 'APENSACAO';
            })) listaDocumentos.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, documento, { possuiApensados: true }));else listaDocumentos.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, documento, { possuiApensados: false }));

          case 25:
            _iteratorNormalCompletion = true;
            _context2.next = 19;
            break;

          case 28:
            _context2.next = 34;
            break;

          case 30:
            _context2.prev = 30;
            _context2.t0 = _context2['catch'](17);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 34:
            _context2.prev = 34;
            _context2.prev = 35;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 37:
            _context2.prev = 37;

            if (!_didIteratorError) {
              _context2.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context2.finish(37);

          case 41:
            return _context2.finish(34);

          case 42:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: listaDocumentos });
            _context2.next = 49;
            break;

          case 45:
            _context2.prev = 45;
            _context2.t1 = _context2['catch'](12);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível verificar a presença de documentos agregados' }, { root: true });
            throw _context2.t1;

          case 49:
            _context2.prev = 49;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando documentos agregados' }, { root: true });
            return _context2.finish(49);

          case 52:
            _context2.next = 58;
            break;

          case 54:
            _context2.prev = 54;
            _context2.t2 = _context2['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, { root: true });
            throw _context2.t2;

          case 58:
            _context2.prev = 58;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documentos' }, { root: true });
            return _context2.finish(58);

          case 61:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[0, 54, 58, 61], [12, 45, 49, 52], [17, 30, 34, 42], [35,, 37, 41]]);
  }));

  return function (_x3, _x4) {
    return _ref7.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].JUNTAR_DOCUMENTOS, function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(_ref10, payload) {
    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Juntando documentos' }, { root: true });
            _context3.next = 4;
            return __WEBPACK_IMPORTED_MODULE_6__utils_documentos__["a" /* default */].juntarDocumentos(payload.tipoJuntadaSelecionada, payload.documentoSelecionado, payload.documento);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento ' + payload.documentoSelecionado.numero + ' ' + (payload.tipoJuntadaSelecionada.tipo === 'X' ? 'anexado' : 'apensado') + ' a ' + payload.documento.numero + ' com sucesso' }, { root: true });
            __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({ name: 'InformacoesDocumento', params: { documentId: payload.documento.idDocumento } });
            _context3.next = 12;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](0);

            if (_context3.t0.status === 500) commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context3.t0.body.message }, { root: true });else commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ocorreu um erro desconhecido ao tentar juntar documentos. Por favor, entre em contato com o administrador.' }, { root: true });
            throw _context3.t0;

          case 12:
            _context3.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_5__vuex_juntada_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Juntando documentos' }, { root: true });
            return _context3.finish(12);

          case 15:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 8, 12, 15]]);
  }));

  return function (_x5, _x6) {
    return _ref9.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  passoAtual: function passoAtual(state) {
    return state.passoAtual;
  },
  listaDocumentos: function listaDocumentos(state) {
    return state.listaDocumentos;
  },
  tipoJuntadaSelecionada: function tipoJuntadaSelecionada(state) {
    return state.tipoJuntadaSelecionada;
  },
  documentoSelecionado: function documentoSelecionado(state) {
    return state.documentoSelecionado;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_juntada_state_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_getters_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_juntada_mutations_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_juntada_actions_js__ = __webpack_require__(311);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_juntada_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_juntada_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_juntada_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_mutations_types__ = __webpack_require__(73);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_mutations_types__["a" /* default */].SET_PASSO_ATUAL, function (state, payload) {
  state.passoAtual = payload.passoAtual;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_mutations_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (state, payload) {
  state.listaDocumentos = payload.listaDocumentos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_mutations_types__["a" /* default */].SET_TIPO_JUNTADA_SELECIONADA, function (state, payload) {
  state.tipoJuntadaSelecionada = payload.tipoJuntadaSelecionada;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_juntada_mutations_types__["a" /* default */].SET_DOCUMENTO_SELECIONADO, function (state, payload) {
  state.documentoSelecionado = payload.documentoSelecionado;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  passoAtual: 1,
  listaDocumentos: [],
  tipoJuntadaSelecionada: {},
  documentoSelecionado: {}
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types_js__ = __webpack_require__(74);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types_js__["a" /* default */], {
  GET_LISTA_UNIDADES: 'GET_LISTA_UNIDADES',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  RECEBER_DOCUMENTO_PARA_REENCAMINHAMENTO: 'RECEBER_DOCUMENTO_PARA_REENCAMINHAMENTO',
  REALIZAR_REENCAMINHAMENTO: 'REALIZAR_REENCAMINHAMENTO'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_documentos__ = __webpack_require__(8);





var _this = this,
    _actions;




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_PASSO_ATUAL, function (_ref, payload) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_PASSO_ATUAL, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_NUMERO_DOCUMENTO, function (_ref2, payload) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_NUMERO_DOCUMENTO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_LISTA_UNIDADES, function (_ref3, payload) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_LISTA_UNIDADES, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_UNIDADE, function (_ref4, payload) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_UNIDADE, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (_ref5, payload) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_DOCUMENTO, function (_ref6, payload) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_DOCUMENTO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].GET_LISTA_UNIDADES, function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(_ref8) {
    var commit = _ref8.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades permitidas' }, { root: true });
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaUnidadesReencaminhamento();

          case 4:
            response = _context.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_LISTA_UNIDADES, { listaUnidades: response.data });
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de unidades permitidas para reencaminhamento' }, { root: true });
            throw _context.t0;

          case 12:
            _context.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando unidades permitidas' }, { root: true });
            return _context.finish(12);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x) {
    return _ref7.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].GET_LISTA_DOCUMENTOS, function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(_ref10, payload) {
    var commit = _ref10.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando documentos permitidos' }, { root: true });
            _context2.prev = 1;

            if (!(!payload.numeroDocumento && !payload.idUnidade)) {
              _context2.next = 6;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos a unidade para buscar documentos a serem reencaminhados' }, { root: true });
            _context2.next = 10;
            break;

          case 6:
            _context2.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaDocumentosReencaminhamento(payload.idUnidade, payload.numeroDocumento);

          case 8:
            response = _context2.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_LISTA_DOCUMENTOS, { listaDocumentos: response.data });

          case 10:
            _context2.next = 16;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar a lista de documentos permitidos para reencaminhamento' }, { root: true });
            throw _context2.t0;

          case 16:
            _context2.prev = 16;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando documentos permitidos' }, { root: true });
            return _context2.finish(16);

          case 19:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 12, 16, 19]]);
  }));

  return function (_x2, _x3) {
    return _ref9.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].RECEBER_DOCUMENTO_PARA_REENCAMINHAMENTO, function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(_ref12, payload) {
    var commit = _ref12.commit;
    var confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            confirmacaoCallback = function () {
              var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, { root: true });
                        _context3.prev = 1;
                        _context3.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].receberDocumentoReencaminhamento(payload.documentoSelecionado.idDocumento);

                      case 4:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento recebido com sucesso' }, { root: true });
                        payload.documentoSelecionado.situacao = 'T';
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_DOCUMENTO, { documentoSelecionado: payload.documentoSelecionado });
                        _context3.next = 13;
                        break;

                      case 9:
                        _context3.prev = 9;
                        _context3.t0 = _context3['catch'](1);

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível receber o documento' }, { root: true });
                        throw _context3.t0;

                      case 13:
                        _context3.prev = 13;

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, { root: true });
                        return _context3.finish(13);

                      case 16:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this, [[1, 9, 13, 16]]);
              }));

              return function confirmacaoCallback() {
                return _ref13.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Receber o documento?',
              textoConteudo: 'Voc\xEA, "' + payload.servidor.nome + '", receber\xE1 ' + payload.documentoSelecionado.tipoDocumento + ' n\xFAmero "' + payload.documentoSelecionado.numeroDocumento + '" em nome de "' + payload.documentoSelecionado.destino + '"',
              textoNao: 'Não',
              textoSim: 'Receber',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function (_x4, _x5) {
    return _ref11.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].REALIZAR_REENCAMINHAMENTO, function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(_ref15, payload) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;
    var usuarioDocumentoReencaminhado, confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            usuarioDocumentoReencaminhado = payload.documentoSelecionado.destino;

            confirmacaoCallback = function () {
              var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Reencaminhando documento' }, { root: true });
                        _context5.prev = 1;
                        _context5.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].realizarReencaminhamento(payload.documentoSelecionado.idDocumento, payload.fluxoSelecionado.id, payload.destinoSelecionado.id, payload.despacho);

                      case 4:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento reencaminhado com sucesso' }, { root: true });
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_PASSO_ATUAL, { passoAtual: 1 });
                        dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].GET_LISTA_DOCUMENTOS, { idUnidade: payload.unidadeSelecionada.id });
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SET_DOCUMENTO, { documentoSelecionado: null });
                        _context5.next = 14;
                        break;

                      case 10:
                        _context5.prev = 10;
                        _context5.t0 = _context5['catch'](1);

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível reencaminhar o documento' }, { root: true });
                        throw _context5.t0;

                      case 14:
                        _context5.prev = 14;

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Reencaminhando documento' }, { root: true });
                        return _context5.finish(14);

                      case 17:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this, [[1, 10, 14, 17]]);
              }));

              return function confirmacaoCallback() {
                return _ref16.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Reencaminhar o documento?',
              textoConteudo: payload.documentoSelecionado.tipoDocumento + ' n\xFAmero "' + payload.documentoSelecionado.numeroDocumento + '" ser\xE1 reencaminhado de "' + usuarioDocumentoReencaminhado + '" para "' + payload.destinoSelecionado.nome + '"',
              textoNao: 'Não',
              textoSim: 'Reencaminhar',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_reencaminhamento_documento_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 4:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function (_x6, _x7) {
    return _ref14.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  passoAtual: function passoAtual(state) {
    return state.passoAtual;
  },
  listaUnidades: function listaUnidades(state) {
    return state.listaUnidades;
  },
  listaDocumentos: function listaDocumentos(state) {
    return state.listaDocumentos;
  },
  unidadeSelecionada: function unidadeSelecionada(state) {
    return state.unidadeSelecionada;
  },
  documentoSelecionado: function documentoSelecionado(state) {
    return state.documentoSelecionado;
  },
  numeroDocumento: function numeroDocumento(state) {
    return state.numeroDocumento;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_reencaminhamento_documento_state_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_getters_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_reencaminhamento_documento_mutations_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_reencaminhamento_documento_actions_js__ = __webpack_require__(317);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_reencaminhamento_documento_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_reencaminhamento_documento_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_reencaminhamento_documento_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types__ = __webpack_require__(74);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types__["a" /* default */].SET_PASSO_ATUAL, function (state, payload) {
  state.passoAtual = payload.passoAtual;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types__["a" /* default */].SET_LISTA_UNIDADES, function (state, payload) {
  state.listaUnidades = payload.listaUnidades;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types__["a" /* default */].SET_UNIDADE, function (state, payload) {
  state.unidadeSelecionada = payload.unidadeSelecionada;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types__["a" /* default */].SET_LISTA_DOCUMENTOS, function (state, payload) {
  state.listaDocumentos = payload.listaDocumentos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types__["a" /* default */].SET_DOCUMENTO, function (state, payload) {
  state.documentoSelecionado = payload.documentoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_reencaminhamento_documento_mutations_types__["a" /* default */].SET_NUMERO_DOCUMENTO, function (state, payload) {
  state.numeroDocumento = payload.numeroDocumento;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  passoAtual: 1,
  listaUnidades: [],
  listaUsuarios: [],
  listaDocumentos: [],
  unidadeSelecionada: null,
  documentoSelecionado: null,
  numeroDocumento: null
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_relatorios_mutations_types_js__ = __webpack_require__(75);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_relatorios_mutations_types_js__["a" /* default */], {
  GET_LISTA_UNIDADES_PROCEDENCIA: 'GET_LISTA_UNIDADES_PROCEDENCIA',
  GERAR_PDF_GUIA_REMESSA_MALOTE: 'GERAR_PDF_GUIA_REMESSA_MALOTE',
  GERAR_PDF_DOCUMENTOS_DESARQUIVADOS_SETOR: 'GERAR_PDF_DOCUMENTOS_DESARQUIVADOS_SETOR'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_relatorios__ = __webpack_require__(249);




var _this = this,
    _actions;





var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].GET_LISTA_UNIDADES_PROCEDENCIA, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
    var commit = _ref2.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando lista de unidades de procedência' }, { root: true });
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__utils_documentos__["a" /* default */].getListaUnidadesProcedenciaRelatorios(payload.relatorio);

          case 4:
            response = _context.sent;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SET_LISTA_UNIDADES_PROCEDENCIA, { listaUnidadesProcedencia: response.data });
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar unidades de procedência' }, { root: true });
            throw _context.t0;

          case 12:
            _context.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando lista de unidades de procedência' }, { root: true });
            return _context.finish(12);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].GERAR_PDF_GUIA_REMESSA_MALOTE, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
    var commit = _ref4.commit;
    var response, blob, blobURL;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(payload.parameters.idsUnidades.length <= 0)) {
              _context2.next = 4;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma unidade de procedência, juntamente com o intervalo de tempo' }, { root: true });
            _context2.next = 21;
            break;

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de guia de remessa de malote' }, { root: true });
            _context2.prev = 5;
            _context2.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5__utils_relatorios__["a" /* default */].getPDFGuiaRemessaMalote(payload.parameters);

          case 8:
            response = _context2.sent;
            blob = new Blob([response.body], { type: 'application/pdf' });
            blobURL = (window.URL || window.webkitURL).createObjectURL(blob);

            window.open(blobURL, '_blank');
            _context2.next = 18;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2['catch'](5);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o pdf do relatório' }, { root: true });
            throw _context2.t0;

          case 18:
            _context2.prev = 18;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de guia de remessa de malote' }, { root: true });
            return _context2.finish(18);

          case 21:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[5, 14, 18, 21]]);
  }));

  return function (_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].GERAR_PDF_DOCUMENTOS_DESARQUIVADOS_SETOR, function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, payload) {
    var commit = _ref6.commit;
    var response, blob, blobURL;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(payload.parameters.idsUnidades.length <= 0)) {
              _context3.next = 4;
              break;
            }

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma unidade de procedência, juntamente com o intervalo de tempo' }, { root: true });
            _context3.next = 21;
            break;

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de documentos desarquivados' }, { root: true });
            _context3.prev = 5;
            _context3.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5__utils_relatorios__["a" /* default */].getPDFDocumentosDesarquivadosSetor(payload.parameters);

          case 8:
            response = _context3.sent;
            blob = new Blob([response.body], { type: 'application/pdf' });
            blobURL = (window.URL || window.webkitURL).createObjectURL(blob);

            window.open(blobURL, '_blank');
            _context3.next = 18;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3['catch'](5);

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o pdf do relatório' }, { root: true });
            throw _context3.t0;

          case 18:
            _context3.prev = 18;

            commit(__WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando relatório de documentos desarquivados' }, { root: true });
            return _context3.finish(18);

          case 21:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[5, 14, 18, 21]]);
  }));

  return function (_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaUnidadesProcedencia: function listaUnidadesProcedencia(state) {
    return state.listaUnidadesProcedencia;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_relatorios_state_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_relatorios_getters_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_relatorios_mutations_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_js__ = __webpack_require__(323);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_relatorios_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_relatorios_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_relatorios_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_relatorios_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_relatorios_mutations_types_js__ = __webpack_require__(75);



var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_relatorios_mutations_types_js__["a" /* default */].SET_LISTA_UNIDADES_PROCEDENCIA, function (state, payload) {
  state.listaUnidadesProcedencia = payload.listaUnidadesProcedencia;
});

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaUnidadesProcedencia: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types_js__ = __webpack_require__(76);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types_js__["a" /* default */], {
  GET_LISTA_TRAMITACOES: 'GET_LISTA_TRAMITACOES',
  GET_LISTA_FLUXOS: 'GET_LISTA_FLUXOS',
  GET_LISTA_FLUXOS_REENCAMINHAMENTO: 'GET_LISTA_FLUXOS_REENCAMINHAMENTO',
  GET_LISTA_DESTINOS_FLUXO: 'GET_LISTA_DESTINOS_FLUXO',
  GET_VALIDACAO_FLUXO: 'GET_VALIDACAO_FLUXO',
  GET_DESPACHO_SALVO: 'GET_DESPACHO_SALVO',
  SALVAR_DESPACHO_TRAMITACAO: 'SALVAR_DESPACHO_TRAMITACAO',
  ENVIAR_TRAMITACAO: 'ENVIAR_TRAMITACAO',
  ENVIAR_TRAMITACAO_MULTIPLA: 'ENVIAR_TRAMITACAO_MULTIPLA',
  CONFIRMAR: 'ui/CONFIRMAR',
  GET_LISTA_HIPOTESE_LEGAL: 'GET_LISTA_HIPOTESE_LEGAL',
  SALVAR_DESPACHO_PREPARATORIO: 'SALVAR_DESPACHO_PREPARATORIO'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_documentos__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dates__ = __webpack_require__(29);








var _this = this,
    _actions;




// import router from '@/router'

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_TRAMITACOES, function (_ref, payload) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_TRAMITACOES, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].GET_LISTA_TRAMITACOES, function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(_ref3, payload) {
    var commit = _ref3.commit;
    var response, items, length, i;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tramitações' }, { root: true });
            _context.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_TRAMITACOES, { listaTramitacoes: [] });
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getProcessingsList(payload.idDocumento);

          case 5:
            response = _context.sent;
            items = response.data;
            length = items.length;

            for (i = 0; i < length; i++) {
              items[i].dias = __WEBPACK_IMPORTED_MODULE_9__utils_dates__["a" /* default */].daysDiffInteger(items[i].dtDespacho, items[i].dtRecebimento);
            }
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_TRAMITACOES, { listaTramitacoes: items });
            _context.next = 16;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar as tramitações' }, { root: true });
            throw _context.t0;

          case 16:
            _context.prev = 16;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando tramitações' }, { root: true });
            return _context.finish(16);

          case 19:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 12, 16, 19]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_FLUXOS, function (_ref4, payload) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_FLUXOS, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].GET_LISTA_FLUXOS, function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(_ref6, payload) {
    var commit = _ref6.commit;
    var response, items;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, { root: true });
            _context2.prev = 1;
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getPassosFluxoPossiveisList(payload.idDocumento);

          case 4:
            response = _context2.sent;
            items = response.data;

            items.sort(function (a, b) {
              return a.descricao.localeCompare(b.descricao);
            });
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_FLUXOS, { listaFluxos: items });
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESTINO, { destinoSelecionado: undefined });
            _context2.next = 15;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os fluxos' }, { root: true });
            throw _context2.t0;

          case 15:
            _context2.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, { root: true });
            return _context2.finish(15);

          case 18:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 11, 15, 18]]);
  }));

  return function (_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_FLUXO, function (_ref7, payload) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_FLUXO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].GET_LISTA_FLUXOS_REENCAMINHAMENTO, function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(_ref9, payload) {
    var commit = _ref9.commit;
    var response, items;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, { root: true });
            _context3.prev = 1;
            _context3.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getPassosFluxoPossiveisReencaminhamentoList(payload.idDocumento);

          case 4:
            response = _context3.sent;
            items = response.data;

            items.sort(function (a, b) {
              return a.descricao.localeCompare(b.descricao);
            });
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_FLUXOS, { listaFluxos: items });
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESTINO, { destinoSelecionado: undefined });
            _context3.next = 15;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os fluxos' }, { root: true });
            throw _context3.t0;

          case 15:
            _context3.prev = 15;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando fluxos' }, { root: true });
            return _context3.finish(15);

          case 18:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[1, 11, 15, 18]]);
  }));

  return function (_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].GET_LISTA_DESTINOS_FLUXO, function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4(_ref11, payload) {
    var commit = _ref11.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando destinos' }, { root: true });
            _context4.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESTINOS_FLUXO, { listaDestinosFluxo: [] });
            _context4.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getDestinosPassoFluxoList(payload.idDocumento, payload.idFluxo);

          case 5:
            response = _context4.sent;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESTINOS_FLUXO, { listaDestinosFluxo: response.data });
            _context4.next = 13;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os destinos do fluxo' }, { root: true });
            throw _context4.t0;

          case 13:
            _context4.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando destinos' }, { root: true });
            return _context4.finish(13);

          case 16:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x7, _x8) {
    return _ref10.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].GET_VALIDACAO_FLUXO, function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5(_ref13, payload) {
    var commit = _ref13.commit;
    var response, regras;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Validando fluxo' }, { root: true });
            _context5.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_VALIDACAO_FLUXO, { listaValidacaoFluxo: {} });
            _context5.next = 5;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getValidacaoFluxo(payload.idDocumento, payload.idFluxo);

          case 5:
            response = _context5.sent;
            regras = [];


            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(response.data).forEach(function (tipo) {
              response.data[tipo].forEach(function (msg) {
                regras.push({ 'tipo': tipo, 'msg': msg });
              });
            });

            console.log(regras);
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_VALIDACAO_FLUXO, { listaValidacaoFluxo: regras });
            _context5.next = 16;
            break;

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível validar a tramitacao para esse fluxo' }, { root: true });
            throw _context5.t0;

          case 16:
            _context5.prev = 16;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Validando fluxo' }, { root: true });
            return _context5.finish(16);

          case 19:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this, [[1, 12, 16, 19]]);
  }));

  return function (_x9, _x10) {
    return _ref12.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESTINO, function (_ref14, payload) {
  var commit = _ref14.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESTINO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESPACHO, function (_ref15, payload) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESPACHO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].GET_DESPACHO_SALVO, function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6(_ref17, payload) {
    var commit = _ref17.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando despacho salvo' }, { root: true });
            _context6.prev = 1;
            _context6.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getDespachoSalvo(payload.idDocumento);

          case 4:
            response = _context6.sent;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESPACHO_SALVO, { despachoSalvo: response.data.despacho });
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESPACHO_PREPARATORIO, { despachoPreparatorio: response.data.despachoPreparatorio });
            _context6.next = 13;
            break;

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar o despacho salvo' }, { root: true });
            throw _context6.t0;

          case 13:
            _context6.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando despacho salvo' }, { root: true });
            return _context6.finish(13);

          case 16:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x11, _x12) {
    return _ref16.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SALVAR_DESPACHO_TRAMITACAO, function () {
  var _ref18 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8(_ref19, payload) {
    var commit = _ref19.commit;
    var confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            confirmacaoCallback = function () {
              var _ref20 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho' }, { root: true });
                        _context7.prev = 1;
                        _context7.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].salvarDespacho(payload.idDocumento, payload.despacho);

                      case 4:
                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Despacho salvo com sucesso' }, { root: true });
                        _context7.next = 11;
                        break;

                      case 7:
                        _context7.prev = 7;
                        _context7.t0 = _context7['catch'](1);

                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o despacho como padrão' }, { root: true });
                        throw _context7.t0;

                      case 11:
                        _context7.prev = 11;

                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho' }, { root: true });
                        return _context7.finish(11);

                      case 14:
                      case 'end':
                        return _context7.stop();
                    }
                  }
                }, _callee7, _this, [[1, 7, 11, 14]]);
              }));

              return function confirmacaoCallback() {
                return _ref20.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Salvar o despacho atual?',
              textoConteudo: 'O despacho atual será salvo para ser utilizado especificamente para a tramitação deste documento',
              textoNao: 'Cancelar',
              textoSim: 'Salvar',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 3:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function (_x13, _x14) {
    return _ref18.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].ENVIAR_TRAMITACAO, function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10(_ref22, payload) {
    var commit = _ref22.commit,
        dispatch = _ref22.dispatch;
    var realizarTramitacao, responseListaAnexos, config;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            realizarTramitacao = function () {
              var _ref23 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Realizando tramitação' }, { root: true });
                        _context9.prev = 1;
                        _context9.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].enviarTramitacao(payload.documento.idDocumento, payload.fluxo.id, payload.destino.id, payload.despacho, payload.tipoDespacho, payload.nivelAcesso, payload.hipoteseLegal, payload.despachoPreparatorio);

                      case 4:
                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Tramitação realizada com sucesso' }, { root: true });
                        _context9.next = 11;
                        break;

                      case 7:
                        _context9.prev = 7;
                        _context9.t0 = _context9['catch'](1);

                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context9.t0.body.message }, { root: true });
                        throw _context9.t0;

                      case 11:
                        _context9.prev = 11;

                        commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Realizando tramitação' }, { root: true });
                        return _context9.finish(11);

                      case 14:
                      case 'end':
                        return _context9.stop();
                    }
                  }
                }, _callee9, _this, [[1, 7, 11, 14]]);
              }));

              return function realizarTramitacao() {
                return _ref23.apply(this, arguments);
              };
            }();

            if (!(payload.documento.situacao === 'EM_CRIACAO' && (payload.documento.idTipo === 571 || payload.documento.idTipoDocumento === 571))) {
              _context10.next = 35;
              break;
            }

            // Em criação e documento avulso
            responseListaAnexos = {};
            _context10.prev = 3;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando existência de peças' }, { root: true });
            _context10.next = 7;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getListaArquivos(payload.documento.idDocumento);

          case 7:
            responseListaAnexos = _context10.sent;
            _context10.next = 14;
            break;

          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10['catch'](3);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Erro ao verificar a existência de peças' }, { root: true });
            throw _context10.t0;

          case 14:
            _context10.prev = 14;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando existência de peças' }, { root: true });
            return _context10.finish(14);

          case 17:
            if (!(responseListaAnexos.data.length === 0)) {
              _context10.next = 30;
              break;
            }

            config = {
              textoPergunta: 'Tramitar sem adicionar peças?',
              textoConteudo: 'O documento será tramitado sem possuir nenhuma peça adicionada.',
              textoNao: 'Cancelar',
              textoSim: 'Tramitar'
            };
            _context10.next = 21;
            return dispatch(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].CONFIRMAR, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 21:
            if (!_context10.sent) {
              _context10.next = 27;
              break;
            }

            _context10.next = 24;
            return realizarTramitacao();

          case 24:
            return _context10.abrupt('return', true);

          case 27:
            return _context10.abrupt('return', false);

          case 28:
            _context10.next = 33;
            break;

          case 30:
            _context10.next = 32;
            return realizarTramitacao();

          case 32:
            return _context10.abrupt('return', true);

          case 33:
            _context10.next = 38;
            break;

          case 35:
            _context10.next = 37;
            return realizarTramitacao();

          case 37:
            return _context10.abrupt('return', true);

          case 38:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this, [[3, 10, 14, 17]]);
  }));

  return function (_x15, _x16) {
    return _ref21.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].ENVIAR_TRAMITACAO_MULTIPLA, function () {
  var _ref24 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13(_ref25, payload) {
    var commit = _ref25.commit;

    var realizarTramitacao, _ref27, _ref28, results;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Tramitando múltiplos documentos' }, { root: true });
            _context13.prev = 1;

            realizarTramitacao = function () {
              var _ref26 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11(documento, fluxo, destino, despacho, tipoDespacho, nivelAcesso, hipoteseLegal, despachoPreparatorio) {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.prev = 0;
                        _context11.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].enviarTramitacao(documento.idDocumento, fluxo.id, destino.id, despacho, tipoDespacho, nivelAcesso, hipoteseLegal, despachoPreparatorio);

                      case 3:
                        return _context11.abrupt('return', { documento: documento, tramitado: true, error: null });

                      case 6:
                        _context11.prev = 6;
                        _context11.t0 = _context11['catch'](0);
                        return _context11.abrupt('return', { documento: documento, tramitado: false, error: _context11.t0 });

                      case 9:
                      case 'end':
                        return _context11.stop();
                    }
                  }
                }, _callee11, _this, [[0, 6]]);
              }));

              return function realizarTramitacao(_x19, _x20, _x21, _x22, _x23, _x24, _x25, _x26) {
                return _ref26.apply(this, arguments);
              };
            }();

            _context13.next = 5;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(payload.documentos.map(function () {
              var _ref29 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12(documento) {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return realizarTramitacao(documento, payload.fluxo, payload.destino, payload.despacho, payload.tipoDespacho, payload.nivelAcesso, payload.hipoteseLegal, payload.despachoPreparatorio);

                      case 2:
                        return _context12.abrupt('return', _context12.sent);

                      case 3:
                      case 'end':
                        return _context12.stop();
                    }
                  }
                }, _callee12, _this);
              }));

              return function (_x27) {
                return _ref29.apply(this, arguments);
              };
            }()));

          case 5:
            _ref27 = _context13.sent;
            _ref28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray___default()(_ref27);
            results = _ref28.slice(0);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Tramitações realizadas com sucesso' }, { root: true });
            return _context13.abrupt('return', results);

          case 12:
            _context13.prev = 12;
            _context13.t0 = _context13['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: _context13.t0.body.message }, { root: true });
            throw _context13.t0;

          case 16:
            _context13.prev = 16;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Tramitando múltiplos documentos' }, { root: true });
            return _context13.finish(16);

          case 19:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this, [[1, 12, 16, 19]]);
  }));

  return function (_x17, _x18) {
    return _ref24.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_NIVEL_ACESSO, function (_ref30, payload) {
  var commit = _ref30.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_NIVEL_ACESSO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].GET_LISTA_HIPOTESE_LEGAL, function () {
  var _ref31 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14(_ref32, payload) {
    var commit = _ref32.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando ...' }, { root: true });
            _context14.prev = 1;
            _context14.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].getMotivosRestricoesArquivo();

          case 4:
            response = _context14.sent;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_LISTA_HIPOTESE_LEGAL, { listaHipotesesLegais: response.data });
            _context14.next = 12;
            break;

          case 8:
            _context14.prev = 8;
            _context14.t0 = _context14['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi carregar a lista de hipóteses legais.' }, { root: true });
            throw _context14.t0;

          case 12:
            _context14.prev = 12;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando ...' }, { root: true });
            return _context14.finish(12);

          case 15:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this, [[1, 8, 12, 15]]);
  }));

  return function (_x28, _x29) {
    return _ref31.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_HIPOTESE_LEGAL, function (_ref33, payload) {
  var commit = _ref33.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_HIPOTESE_LEGAL, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_TIPO_DESPACHO, function (_ref34, payload) {
  var commit = _ref34.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_TIPO_DESPACHO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESPACHO_PREPARATORIO, function (_ref35, payload) {
  var commit = _ref35.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SET_DESPACHO_PREPARATORIO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SALVAR_DESPACHO_PREPARATORIO, function () {
  var _ref36 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15(_ref37, payload) {
    var commit = _ref37.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho preparatório' }, { root: true });
            _context15.prev = 1;
            _context15.next = 4;
            return __WEBPACK_IMPORTED_MODULE_8__utils_documentos__["a" /* default */].salvarDespachoPreparatorio(payload.idDocumento, payload.despachoPreparatorio);

          case 4:
            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Despacho preparatório salvo com sucesso' }, { root: true });
            _context15.next = 11;
            break;

          case 7:
            _context15.prev = 7;
            _context15.t0 = _context15['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o despacho preparatório' }, { root: true });
            throw _context15.t0;

          case 11:
            _context15.prev = 11;

            commit(__WEBPACK_IMPORTED_MODULE_7__vuex_tramitacoes_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando despacho preparatório' }, { root: true });
            return _context15.finish(11);

          case 14:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, _this, [[1, 7, 11, 14]]);
  }));

  return function (_x30, _x31) {
    return _ref36.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaTramitacoes: function listaTramitacoes(state) {
    return state.listaTramitacoes;
  },
  listaFluxos: function listaFluxos(state) {
    return state.listaFluxos;
  },
  listaDestinosFluxo: function listaDestinosFluxo(state) {
    return state.listaDestinosFluxo;
  },
  listaValidacaoFluxo: function listaValidacaoFluxo(state) {
    return state.listaValidacaoFluxo;
  },
  fluxoSelecionado: function fluxoSelecionado(state) {
    return state.fluxoSelecionado;
  },
  destinoSelecionado: function destinoSelecionado(state) {
    return state.destinoSelecionado;
  },
  despachoSelecionado: function despachoSelecionado(state) {
    return state.despachoSelecionado;
  },
  despachoSalvo: function despachoSalvo(state) {
    return state.despachoSalvo;
  },
  nivelAcessoSelecionado: function nivelAcessoSelecionado(state) {
    return state.nivelAcessoSelecionado;
  },
  hipoteseLegalSelecionada: function hipoteseLegalSelecionada(state) {
    return state.hipoteseLegalSelecionada;
  },
  listaHipotesesLegais: function listaHipotesesLegais(state) {
    return state.listaHipotesesLegais;
  },
  tipoDespachoSelecionado: function tipoDespachoSelecionado(state) {
    return state.tipoDespachoSelecionado;
  },
  despachoPreparatorio: function despachoPreparatorio(state) {
    return state.despachoPreparatorio;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_tramitacoes_state_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_getters_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_tramitacoes_mutations_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_tramitacoes_actions_js__ = __webpack_require__(329);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_tramitacoes_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_tramitacoes_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_tramitacoes_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__ = __webpack_require__(76);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_LISTA_TRAMITACOES, function (state, payload) {
  state.listaTramitacoes = payload.listaTramitacoes;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_LISTA_FLUXOS, function (state, payload) {
  state.listaFluxos = payload.listaFluxos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_DESTINOS_FLUXO, function (state, payload) {
  state.listaDestinosFluxo = payload.listaDestinosFluxo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_VALIDACAO_FLUXO, function (state, payload) {
  state.listaValidacaoFluxo = payload.listaValidacaoFluxo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_FLUXO, function (state, payload) {
  state.fluxoSelecionado = payload.fluxoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_DESTINO, function (state, payload) {
  state.destinoSelecionado = payload.destinoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_DESPACHO, function (state, payload) {
  state.despachoSelecionado = payload.despachoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_DESPACHO_SALVO, function (state, payload) {
  state.despachoSalvo = payload.despachoSalvo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_NIVEL_ACESSO, function (state, payload) {
  state.nivelAcessoSelecionado = payload.nivelAcessoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_LISTA_HIPOTESE_LEGAL, function (state, payload) {
  state.listaHipotesesLegais = payload.listaHipotesesLegais;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_HIPOTESE_LEGAL, function (state, payload) {
  state.hipoteseLegalSelecionada = payload.hipoteseLegalSelecionada;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_TIPO_DESPACHO, function (state, payload) {
  state.tipoDespachoSelecionado = payload.tipoDespachoSelecionado;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_tramitacoes_mutations_types__["a" /* default */].SET_DESPACHO_PREPARATORIO, function (state, payload) {
  state.despachoPreparatorio = payload.despachoPreparatorio;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaTramitacoes: [],
  listaFluxos: [],
  listaDestinosFluxo: [],
  listaValidacaoFluxo: [],
  fluxoSelecionado: null,
  destinoSelecionado: null,
  despachoSelecionado: null,
  despachoSalvo: null,
  nivelAcessoSelecionado: 'P',
  listaHipotesesLegais: [],
  hipoteseLegalSelecionada: null,
  tipoDespachoSelecionado: 'I',
  despachoPreparatorio: null
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__ = __webpack_require__(77);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */], {
  GET_INFORMACAO: 'GET_INFORMACAO',
  CONFIRMAR: 'CONFIRMAR'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_informacao__ = __webpack_require__(248);





var _this = this,
    _actions;




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, function (_ref, payload) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, function (_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_SNACKBAR, function (_ref3, payload) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_SNACKBAR);
  setTimeout(function () {
    commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SET_SNACKBAR, payload);
    commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_SNACKBAR);
  }, 250);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_SNACKBAR, function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_SNACKBAR);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, function (_ref5, payload) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_CONFIRMATION_DIALOG, function (_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_CONFIRMATION_DIALOG);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].CONFIRMAR, function (_ref7, payload) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_CONFIRMAR_DIALOG, payload);
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE, { resolve: resolve });
    commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SET_CONFIRMAR_DIALOG_PROMISE_REJECT, { reject: reject });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_CONFIRMAR_DIALOG, function (_ref8) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].HIDE_CONFIRMAR_DIALOG);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].GET_INFORMACAO, function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref10) {
    var commit = _ref10.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_5__utils_informacao__["a" /* default */].getInformacao();

          case 3:
            response = _context.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SET_INFORMACAO, { informacao: response.data });
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar novidades' });

          case 10:
            _context.prev = 10;
            return _context.finish(10);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 7, 10, 12]]);
  }));

  return function (_x) {
    return _ref9.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SET_INFORMACAO, function (_ref11, payload) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_ui_actions_types__["a" /* default */].SET_INFORMACAO, payload);
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  globalLoading: function globalLoading(state) {
    return state.globalLoading;
  },
  globalLoadingMessageArray: function globalLoadingMessageArray(state) {
    return state.globalLoadingMessageArray;
  },
  snackbar: function snackbar(state) {
    return state.snackbar;
  },
  snackbarType: function snackbarType(state) {
    return state.snackbarType;
  },
  snackbarText: function snackbarText(state) {
    return state.snackbarText;
  },
  confirmationDialog: function confirmationDialog(state) {
    return state.confirmationDialog;
  },
  confirmationDialogConfig: function confirmationDialogConfig(state) {
    return state.confirmationDialogConfig;
  },
  confirmarDialog: function confirmarDialog(state) {
    return state.confirmarDialog;
  },
  confirmarDialogConfig: function confirmarDialogConfig(state) {
    return state.confirmarDialogConfig;
  },
  confirmarDialogPromiseResolve: function confirmarDialogPromiseResolve(state) {
    return state.confirmarDialogPromiseResolve;
  },
  confirmarDialogPromiseReject: function confirmarDialogPromiseReject(state) {
    return state.confirmarDialogPromiseReject;
  },
  informacao: function informacao(state) {
    return state.informacao;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_ui_state_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_getters_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_ui_mutations_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_ui_actions_js__ = __webpack_require__(335);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_ui_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_ui_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_ui_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_ui_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__ = __webpack_require__(77);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_GLOBAL_LOADING, function (state, payload) {
  state.globalLoadingMessageArray.unshift(payload.globalLoadingTitle);
  state.globalLoading = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_GLOBAL_LOADING, function (state, payload) {
  var achou = false;
  if (payload && payload.globalLoadingTitle) {
    for (var i = 0; i < state.globalLoadingMessageArray.length; i++) {
      if (state.globalLoadingMessageArray[i] === payload.globalLoadingTitle) {
        state.globalLoadingMessageArray.splice(i, 1);
        achou = true;
        break;
      }
    }
  }
  // Se não tiver payload ou a mensagem estiver errada, tira uma mensagem
  // qualquer para o loading não ficar rodando infinitamente
  if (achou === false) {
    state.globalLoadingMessageArray.pop();
  }
  if (state.globalLoadingMessageArray.length === 0) {
    state.globalLoading = false;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SET_SNACKBAR, function (state, payload) {
  state.snackbarType = payload.snackbarType;
  state.snackbarText = payload.snackbarText;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_SNACKBAR, function (state, payload) {
  state.snackbar = false;
  setTimeout(function () {
    state.snackbarType = payload.snackbarType;
    state.snackbarText = payload.snackbarText;
    state.snackbar = true;
  }, 250);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_SNACKBAR, function (state) {
  state.snackbar = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_CONFIRMATION_DIALOG, function (state, payload) {
  state.confirmationDialogConfig.textoPergunta = payload.textoPergunta ? payload.textoPergunta : 'Deseja proceder com sua ação?';
  state.confirmationDialogConfig.textoConteudo = payload.textoConteudo ? payload.textoConteudo : 'Ao confirmar, sua ação será executada. Cancele caso não tenha certeza e acesse nossa seção de ajuda.';
  state.confirmationDialogConfig.textoNao = payload.textoNao ? payload.textoNao : 'Não';
  state.confirmationDialogConfig.textoSim = payload.textoSim ? payload.textoSim : 'Sim';
  state.confirmationDialogConfig.confirmacaoCallback = payload.confirmacaoCallback;
  state.confirmationDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_CONFIRMATION_DIALOG, function (state) {
  state.confirmationDialog = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_CONFIRMAR_DIALOG, function (state, payload) {
  state.confirmarDialogConfig.textoPergunta = payload.textoPergunta ? payload.textoPergunta : 'Deseja proceder com sua ação?';
  state.confirmarDialogConfig.textoConteudo = payload.textoConteudo ? payload.textoConteudo : 'Ao confirmar, sua ação será executada. Cancele caso não tenha certeza e acesse nossa seção de ajuda.';
  state.confirmarDialogConfig.textoNao = payload.textoNao ? payload.textoNao : 'Não';
  state.confirmarDialogConfig.textoSim = payload.textoSim ? payload.textoSim : 'Sim';
  state.confirmarDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_CONFIRMAR_DIALOG, function (state) {
  state.confirmarDialog = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE, function (state, payload) {
  state.confirmarDialogPromiseResolve = payload.resolve;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SET_CONFIRMAR_DIALOG_PROMISE_REJECT, function (state, payload) {
  state.confirmarDialogPromiseReject = payload.reject;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SET_INFORMACAO, function (state, payload) {
  state.informacao = payload.informacao;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  globalLoading: false,
  globalLoadingMessageArray: [],
  snackbar: false,
  snackbarType: '',
  snackbarText: '',
  confirmationDialog: false,
  confirmationDialogConfig: {},
  confirmarDialog: false,
  confirmarDialogConfig: {},
  confirmarDialogPromiseResolve: null,
  confirmarDialogPromiseReject: null,
  informacao: {
    mensagem: '',
    dataValidade: ''
  }
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_vinculos_documento_mutations_types_js__ = __webpack_require__(78);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_vinculos_documento_mutations_types_js__["a" /* default */], {
  INICIALIZAR_DADOS_VINCULOS_DOCUMENTO: 'INICIALIZAR_DADOS_VINCULOS_DOCUMENTO',
  GET_DOCUMENTO_AGREGADOR: 'GET_DOCUMENTO_AGREGADOR',
  SET_DOCUMENTO_AGREGADOR: 'SET_DOCUMENTO_AGREGADOR',
  GET_LISTA_VINCULOS_DOCUMENTO: 'GET_LISTA_VINCULOS_DOCUMENTO',
  DESAPENSAR_DOCUMENTO: 'DESAPENSAR_DOCUMENTO',
  DESANEXAR_DOCUMENTO: 'DESANEXAR_DOCUMENTO'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_documentos__ = __webpack_require__(8);





var _this = this,
    _actions;




var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].INICIALIZAR_DADOS_VINCULOS_DOCUMENTO, function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].GET_LISTA_VINCULOS_DOCUMENTO, { idDocumento: payload.idDocumento });
            if (payload.idDocumentoAgregador) dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].GET_DOCUMENTO_AGREGADOR, { idDocumentoAgregador: payload.idDocumentoAgregador });else commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SET_DOCUMENTO_AGREGADOR, { documentoAgregador: undefined });

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].GET_LISTA_VINCULOS_DOCUMENTO, function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
    var commit = _ref4.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando vínculos do documento' }, { root: true });
            _context2.prev = 1;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SET_LISTA_VINCULOS_DOCUMENTO, { listaVinculosDocumento: [] });
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getListaVinculosDocumento(payload.idDocumento);

          case 5:
            response = _context2.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SET_LISTA_VINCULOS_DOCUMENTO, { listaVinculosDocumento: response.data });
            _context2.next = 13;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível obter os vínculos do documento' }, { root: true });
            throw _context2.t0;

          case 13:
            _context2.prev = 13;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando vínculos do documento' }, { root: true });
            return _context2.finish(13);

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 9, 13, 16]]);
  }));

  return function (_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].GET_DOCUMENTO_AGREGADOR, function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, payload) {
    var commit = _ref6.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento agregador' }, { root: true });
            _context3.prev = 1;
            _context3.next = 4;
            return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].getDocument(payload.idDocumentoAgregador, false);

          case 4:
            response = _context3.sent;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SET_DOCUMENTO_AGREGADOR, { documentoAgregador: response.data });
            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](1);

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar o documento agregador' }, { root: true });

          case 11:
            _context3.prev = 11;

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando documento agregador' }, { root: true });
            return _context3.finish(11);

          case 14:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[1, 8, 11, 14]]);
  }));

  return function (_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SET_DOCUMENTO_AGREGADOR, function (_ref7, payload) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SET_DOCUMENTO_AGREGADOR, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].DESAPENSAR_DOCUMENTO, function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(_ref9, payload) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;
    var confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            confirmacaoCallback = function () {
              var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Desapensando documentos' }, { root: true });
                        _context4.prev = 1;
                        _context4.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].desapensarDocumentos(payload.documentoPai.idDocumento, payload.documentoFilho.idDocumento);

                      case 4:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documentos desapensados com sucesso' }, { root: true });
                        dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].GET_LISTA_VINCULOS_DOCUMENTO, { idDocumento: payload.documentoPai.idDocumento });
                        _context4.next = 11;
                        break;

                      case 8:
                        _context4.prev = 8;
                        _context4.t0 = _context4['catch'](1);

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível desapensar os documentos' }, { root: true });

                      case 11:
                        _context4.prev = 11;

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Desapensando documentos' }, { root: true });
                        return _context4.finish(11);

                      case 14:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this, [[1, 8, 11, 14]]);
              }));

              return function confirmacaoCallback() {
                return _ref10.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Desapensar os documentos?',
              textoConteudo: 'O ' + payload.documentoFilho.tipo.toLowerCase() + ' n\xFAmero ' + payload.documentoFilho.numero + ' ser\xE1 desapensado do ' + payload.documentoPai.tipo.toLowerCase() + ' n\xFAmero ' + payload.documentoPai.numero + '.',
              textoNao: 'Cancelar',
              textoSim: 'Desapensar',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}()), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].DESANEXAR_DOCUMENTO, function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(_ref12, payload) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    var confirmacaoCallback, config;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            confirmacaoCallback = function () {
              var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Desanexando documentos' }, { root: true });
                        _context6.prev = 1;
                        _context6.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_5__utils_documentos__["a" /* default */].desapensarDocumentos(payload.documentoPai.idDocumento, payload.documentoFilho.idDocumento);

                      case 4:
                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documentos desanexados com sucesso' }, { root: true });
                        dispatch(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].GET_LISTA_VINCULOS_DOCUMENTO, { idDocumento: payload.documentoPai.idDocumento });
                        _context6.next = 11;
                        break;

                      case 8:
                        _context6.prev = 8;
                        _context6.t0 = _context6['catch'](1);

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível desanexar os documentos' }, { root: true });

                      case 11:
                        _context6.prev = 11;

                        commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Desanexando documentos' }, { root: true });
                        return _context6.finish(11);

                      case 14:
                      case 'end':
                        return _context6.stop();
                    }
                  }
                }, _callee6, _this, [[1, 8, 11, 14]]);
              }));

              return function confirmacaoCallback() {
                return _ref13.apply(this, arguments);
              };
            }();

            config = {
              textoPergunta: 'Desanexar os documentos?',
              textoConteudo: 'O ' + payload.documentoFilho.tipo.toLowerCase() + ' n\xFAmero ' + payload.documentoFilho.numero + ' ser\xE1 desanexado do ' + payload.documentoPai.tipo.toLowerCase() + ' n\xFAmero ' + payload.documentoPai.numero + '.',
              textoNao: 'Cancelar',
              textoSim: 'Desanexar',
              confirmacaoCallback: confirmacaoCallback
            };

            commit(__WEBPACK_IMPORTED_MODULE_4__vuex_vinculos_documento_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config), { root: true });

          case 3:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function (_x9, _x10) {
    return _ref11.apply(this, arguments);
  };
}()), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  listaVinculosDocumento: function listaVinculosDocumento(state) {
    return state.listaVinculosDocumento;
  },
  documentoAgregador: function documentoAgregador(state) {
    return state.documentoAgregador;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_vinculos_documento_state_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_vinculos_documento_getters_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_vinculos_documento_mutations_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_vinculos_documento_actions_js__ = __webpack_require__(341);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_vinculos_documento_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_vinculos_documento_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_vinculos_documento_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_vinculos_documento_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_vinculos_documento_mutations_types__ = __webpack_require__(78);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_vinculos_documento_mutations_types__["a" /* default */].SET_LISTA_VINCULOS_DOCUMENTO, function (state, payload) {
  state.listaVinculosDocumento = payload.listaVinculosDocumento;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_vinculos_documento_mutations_types__["a" /* default */].SET_DOCUMENTO_AGREGADOR, function (state, payload) {
  state.documentoAgregador = payload.documentoAgregador;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  listaVinculosDocumento: [],
  documentoAgregador: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_layout__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_layouts_layout__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-layout': __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_layout___default.a
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-menu': function appMenu() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 423));
    },
    'app-content': function appContent() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 420));
    },
    'app-footer': function appFooter() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 421));
    },
    'app-snackbar': function appSnackbar() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 424));
    },
    'app-informacao': function appInformacao() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 422));
    }
  }
});

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 91,
	"./af.js": 91,
	"./ar": 99,
	"./ar-dz": 92,
	"./ar-dz.js": 92,
	"./ar-kw": 93,
	"./ar-kw.js": 93,
	"./ar-ly": 94,
	"./ar-ly.js": 94,
	"./ar-ma": 95,
	"./ar-ma.js": 95,
	"./ar-ps": 96,
	"./ar-ps.js": 96,
	"./ar-sa": 97,
	"./ar-sa.js": 97,
	"./ar-tn": 98,
	"./ar-tn.js": 98,
	"./ar.js": 99,
	"./az": 100,
	"./az.js": 100,
	"./be": 101,
	"./be.js": 101,
	"./bg": 102,
	"./bg.js": 102,
	"./bm": 103,
	"./bm.js": 103,
	"./bn": 105,
	"./bn-bd": 104,
	"./bn-bd.js": 104,
	"./bn.js": 105,
	"./bo": 106,
	"./bo.js": 106,
	"./br": 107,
	"./br.js": 107,
	"./bs": 108,
	"./bs.js": 108,
	"./ca": 109,
	"./ca.js": 109,
	"./cs": 110,
	"./cs.js": 110,
	"./cv": 111,
	"./cv.js": 111,
	"./cy": 112,
	"./cy.js": 112,
	"./da": 113,
	"./da.js": 113,
	"./de": 116,
	"./de-at": 114,
	"./de-at.js": 114,
	"./de-ch": 115,
	"./de-ch.js": 115,
	"./de.js": 116,
	"./dv": 117,
	"./dv.js": 117,
	"./el": 118,
	"./el.js": 118,
	"./en-au": 119,
	"./en-au.js": 119,
	"./en-ca": 120,
	"./en-ca.js": 120,
	"./en-gb": 121,
	"./en-gb.js": 121,
	"./en-ie": 122,
	"./en-ie.js": 122,
	"./en-il": 123,
	"./en-il.js": 123,
	"./en-in": 124,
	"./en-in.js": 124,
	"./en-nz": 125,
	"./en-nz.js": 125,
	"./en-sg": 126,
	"./en-sg.js": 126,
	"./eo": 127,
	"./eo.js": 127,
	"./es": 131,
	"./es-do": 128,
	"./es-do.js": 128,
	"./es-mx": 129,
	"./es-mx.js": 129,
	"./es-us": 130,
	"./es-us.js": 130,
	"./es.js": 131,
	"./et": 132,
	"./et.js": 132,
	"./eu": 133,
	"./eu.js": 133,
	"./fa": 134,
	"./fa.js": 134,
	"./fi": 135,
	"./fi.js": 135,
	"./fil": 136,
	"./fil.js": 136,
	"./fo": 137,
	"./fo.js": 137,
	"./fr": 140,
	"./fr-ca": 138,
	"./fr-ca.js": 138,
	"./fr-ch": 139,
	"./fr-ch.js": 139,
	"./fr.js": 140,
	"./fy": 141,
	"./fy.js": 141,
	"./ga": 142,
	"./ga.js": 142,
	"./gd": 143,
	"./gd.js": 143,
	"./gl": 144,
	"./gl.js": 144,
	"./gom-deva": 145,
	"./gom-deva.js": 145,
	"./gom-latn": 146,
	"./gom-latn.js": 146,
	"./gu": 147,
	"./gu.js": 147,
	"./he": 148,
	"./he.js": 148,
	"./hi": 149,
	"./hi.js": 149,
	"./hr": 150,
	"./hr.js": 150,
	"./hu": 151,
	"./hu.js": 151,
	"./hy-am": 152,
	"./hy-am.js": 152,
	"./id": 153,
	"./id.js": 153,
	"./is": 154,
	"./is.js": 154,
	"./it": 156,
	"./it-ch": 155,
	"./it-ch.js": 155,
	"./it.js": 156,
	"./ja": 157,
	"./ja.js": 157,
	"./jv": 158,
	"./jv.js": 158,
	"./ka": 159,
	"./ka.js": 159,
	"./kk": 160,
	"./kk.js": 160,
	"./km": 161,
	"./km.js": 161,
	"./kn": 162,
	"./kn.js": 162,
	"./ko": 163,
	"./ko.js": 163,
	"./ku": 165,
	"./ku-kmr": 164,
	"./ku-kmr.js": 164,
	"./ku.js": 165,
	"./ky": 166,
	"./ky.js": 166,
	"./lb": 167,
	"./lb.js": 167,
	"./lo": 168,
	"./lo.js": 168,
	"./lt": 169,
	"./lt.js": 169,
	"./lv": 170,
	"./lv.js": 170,
	"./me": 171,
	"./me.js": 171,
	"./mi": 172,
	"./mi.js": 172,
	"./mk": 173,
	"./mk.js": 173,
	"./ml": 174,
	"./ml.js": 174,
	"./mn": 175,
	"./mn.js": 175,
	"./mr": 176,
	"./mr.js": 176,
	"./ms": 178,
	"./ms-my": 177,
	"./ms-my.js": 177,
	"./ms.js": 178,
	"./mt": 179,
	"./mt.js": 179,
	"./my": 180,
	"./my.js": 180,
	"./nb": 181,
	"./nb.js": 181,
	"./ne": 182,
	"./ne.js": 182,
	"./nl": 184,
	"./nl-be": 183,
	"./nl-be.js": 183,
	"./nl.js": 184,
	"./nn": 185,
	"./nn.js": 185,
	"./oc-lnc": 186,
	"./oc-lnc.js": 186,
	"./pa-in": 187,
	"./pa-in.js": 187,
	"./pl": 188,
	"./pl.js": 188,
	"./pt": 190,
	"./pt-br": 189,
	"./pt-br.js": 189,
	"./pt.js": 190,
	"./ro": 191,
	"./ro.js": 191,
	"./ru": 192,
	"./ru.js": 192,
	"./sd": 193,
	"./sd.js": 193,
	"./se": 194,
	"./se.js": 194,
	"./si": 195,
	"./si.js": 195,
	"./sk": 196,
	"./sk.js": 196,
	"./sl": 197,
	"./sl.js": 197,
	"./sq": 198,
	"./sq.js": 198,
	"./sr": 200,
	"./sr-cyrl": 199,
	"./sr-cyrl.js": 199,
	"./sr.js": 200,
	"./ss": 201,
	"./ss.js": 201,
	"./sv": 202,
	"./sv.js": 202,
	"./sw": 203,
	"./sw.js": 203,
	"./ta": 204,
	"./ta.js": 204,
	"./te": 205,
	"./te.js": 205,
	"./tet": 206,
	"./tet.js": 206,
	"./tg": 207,
	"./tg.js": 207,
	"./th": 208,
	"./th.js": 208,
	"./tk": 209,
	"./tk.js": 209,
	"./tl-ph": 210,
	"./tl-ph.js": 210,
	"./tlh": 211,
	"./tlh.js": 211,
	"./tr": 212,
	"./tr.js": 212,
	"./tzl": 213,
	"./tzl.js": 213,
	"./tzm": 215,
	"./tzm-latn": 214,
	"./tzm-latn.js": 214,
	"./tzm.js": 215,
	"./ug-cn": 216,
	"./ug-cn.js": 216,
	"./uk": 217,
	"./uk.js": 217,
	"./ur": 218,
	"./ur.js": 218,
	"./uz": 220,
	"./uz-latn": 219,
	"./uz-latn.js": 219,
	"./uz.js": 220,
	"./vi": 221,
	"./vi.js": 221,
	"./x-pseudo": 222,
	"./x-pseudo.js": 222,
	"./yo": 223,
	"./yo.js": 223,
	"./zh-cn": 224,
	"./zh-cn.js": 224,
	"./zh-hk": 225,
	"./zh-hk.js": 225,
	"./zh-mo": 226,
	"./zh-mo.js": 226,
	"./zh-tw": 227,
	"./zh-tw.js": 227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(401),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a40399e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-menu'), _vm._v(" "), _c('app-content'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('app-snackbar'), _vm._v(" "), _c('app-informacao')], 1)
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-layout')
},staticRenderFns: []}

/***/ }),
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[247]);


// WEBPACK FOOTER //
// static/js/app.1a58cf6ca3d555acbcd6.js